<template>
	<div class="header">
		<div class="container-fluid">
			<div class="mt-5">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">List Contract</li>
								<li class="breadcrumb-item">{{ breadcrumb }}</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title fw-bolder">List Contract</h4>
					<!-- <div class="card-header-title form-group col-2">
            <input
            type="text"
            v-model="search"
            class="form-control"
            placeholder="Search"
            @input="onSearch()"
            />
            </div> -->
					<!-- Button -->
					<b-button variant="primary" class="ml-2 mr-2" @click="openNewContract" v-if="direct == 'MyContract' && canAdd">
						<span class="fe fe-plus-circle"></span>
						Contract
					</b-button>
					<b-button v-b-toggle.collapse-1 variant="primary" style="margin-left: 7px">
						<span class="fe fe-filter"></span>
					</b-button>
					<!-- Button import -->
					<!-- <b-button v-if="role_id !== '3'" v-b-modal.importFile variant="primary" class="ml-2 mr-2"
            @click="isImport = true">
            <span class="fe fe-file-plus"></span>
            Import
            </b-button> -->
					<!-- <b-button variant="primary" @click="downloadAll()">
            <span class="fe fe-download"></span>
            Export
            </b-button> -->
				</div>
				<b-collapse id="collapse-1" visible>
					<div class="row row-cols-1 row-cols-lg-2 p-4">
						<div class="col">
							<div class="form-group">
								<label class="form-label">Filter Department</label>
								<v-select
									v-model="body.department_id"
									:options="listDepartments"
									label="name"
									:reduce="(e) => e.id"
									name="Department"
									@input="filterPage()"
									:clearable="false"
								/>
							</div>
						</div>
						<div class="col">
							<label class="form-label">
								Search
								<span
									v-b-popover.hover.right="
										'Search by contract name, contract number, contract owner/co-owner, vendors, contract type'
									"
									variant="secondary"
									style="cursor: pointer"
								>
									<i class="fe fe-help-circle text-danger" style="cursor: help"></i>
								</span>
							</label>
							<b-form-input v-model="body.search" class="w-full" placeholder="Type Here..." @input="filterPage()">
							</b-form-input>
						</div>
					</div>
				</b-collapse>

				<div class="card-body card-header">
					<div class="row align-items-center" style="margin-top: -1.5rem">
						<!-- Nav -->
						<ul class="nav nav-tabs nav-overflow header-tabs ml-2">
							<li class="nav-item" @click="directTabs('MyContract')">
								<a class="nav-link" :class="{ active: direct === 'MyContract' }"> All Contracts </a>
							</li>
							<li class="nav-item" @click="directTabs('draft')">
								<a class="nav-link" :class="{ active: direct === 'draft' }"> Draft </a>
							</li>
							<li class="nav-item" @click="directTabs('onGoing')">
								<a class="nav-link" :class="{ active: direct === 'onGoing' }"> On Going </a>
							</li>
							<li class="nav-item" @click="directTabs('closed')">
								<a class="nav-link" :class="{ active: direct === 'closed' }"> Closed </a>
							</li>
							<li class="nav-item" @click="directTabs('earlyTermination')">
								<a class="nav-link" :class="{ active: direct === 'earlyTermination' }"> Early Terminated </a>
							</li>
							<li class="nav-item" @click="directTabs('expiredSoon')">
								<a class="nav-link" :class="{ active: direct === 'expiredSoon' }"> Expired Soon </a>
							</li>
							<li class="nav-item" @click="directTabs('expired')">
								<a class="nav-link" :class="{ active: direct === 'expired' }"> Expired </a>
							</li>
							<li class="nav-item" @click="directTabs('valueWarning')">
								<a class="nav-link" :class="{ active: direct === 'valueWarning' }"> Value Warning </a>
							</li>
						</ul>
					</div>
				</div>

				<div v-if="direct === 'MyContract'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<!-- <tableListContract :list="formattedListMyContract.data" :totalRows="formattedListMyContract.totalItems" -->
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsMyContract"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@updateData="updateMyContract"
							@amendContract="amandementContract"
							@sendNotification="sendNotification"
							@deleteData="deleteMyContract"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'myContract'"
						/>
					</div>
				</div>
				<div v-if="direct === 'draft'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsDraft"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@amendContract="amandementContract"
							@deleteData="deleteMyContract"
							@sendNotification="sendNotification"
							@detailData="getDetailContract"
							@updateData="updateMyContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'draft'"
						/>
					</div>
				</div>
				<div v-if="direct === 'onGoing'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsOnGoing"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@amendContract="amandementContract"
							@deleteData="deleteMyContract"
							@sendNotification="sendNotification"
							@detailData="getDetailContract"
							@updateData="updateMyContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'onGoing'"
						/>
					</div>
				</div>
				<div v-if="direct === 'closed'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsClosed"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@updateData="updateMyContract"
							@sendNotification="sendNotification"
							@downloadData="downloadClosed"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'closed'"
						/>
					</div>
				</div>
				<div v-if="direct === 'earlyTermination'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsEarlyTermination"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@amendContract="amandementContract"
							@sendNotification="sendNotification"
							@updateData="updateMyContract"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'earlyTermination'"
						/>
					</div>
				</div>
				<div v-if="direct === 'expiredSoon'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsExpiredSoon"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@updateData="updateMyContract"
							@sendNotification="sendNotification"
							@amendContract="amandementContract"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'expiredSoon'"
						/>
					</div>
				</div>
				<div v-if="direct === 'expired'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsExpired"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@updateData="updateMyContract"
							@sendNotification="sendNotification"
							@amendContract="amandementContract"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'expired'"
						/>
					</div>
				</div>
				<div v-if="direct === 'valueWarning'">
					<div :class="`cart ${load === true ? '' : 'd-none'}`">
						<div class="card-body text-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>
					</div>
					<div :class="`cart ${load === true ? 'd-none' : ''}`">
						<tableListContract
							:list="listContract.data"
							:totalRows="listContract.totalItems"
							:columns="columnsValueWarning"
							:currentPage="body.page"
							:perPage="body.pageSize"
							@updateData="updateMyContract"
							@amendContract="amandementContract"
							@sendNotification="sendNotification"
							@detailData="getDetailContract"
							@onPageChange="onPageChange"
							@onSortChange="onSortChange"
							:type="'valueWarning'"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- Modal Edit-->
		<b-modal id="modal-1" size="xl" hide-footer title="Contract Form" @hide="modalClose($event)">
			<b-tabs content-class="mt-3" v-model="tabIndex">
				<b-tab title="Contract Information" active>
					<div class="card">
						<div class="card-body">
							<label class="font-weight-bold">Budget Section</label>
							<div class="row">
								<div class="form-group">
									<label>Department<span class="text-danger">*</span></label>
									<v-select
										:options="listDepartments"
										:reduce="(e) => e.id"
										label="name"
										name="Department"
										v-model="selectedDepartmentContractId"
										:disabled="!isAdd"
										:clearable="false"
										v-validate="'required'"
										@input="handleChangeContractDepartment($event)"
									/>
								</div>
								<div class="col-lg-6">
									<div class="form-group">
										<label>Budget Plan<span class="text-danger">*</span></label>
										<v-select
											:options="ListBudgetPlan"
											:reduce="(e) => e.id"
											label="label"
											name="Budget Plan"
											v-model="saveContract.budget_plan_id"
											@input="getListBudgetTask()"
										/>
									</div>
								</div>

								<div class="col-lg-6">
									<div class="form-group">
										<label>Budget GL<span class="text-danger">*</span></label>
										<v-select
											:options="ListBudgetGL"
											:reduce="(e) => e.id"
											label="label"
											name="Budget GL"
											v-model="saveContract.budget_gl_id"
											@input="selectBudgetTask($event)"
											placeholder="Budget GL"
											:disabled="!saveContract.budget_plan_id"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Budget GL')">
											{{ errors.first('Budget GL') }}
										</span>
									</div>
								</div>

								<div class="col-lg-6">
									<div class="form-group">
										<label>Budget Task<span class="text-danger">*</span></label>
										<v-select
											:options="ListBudgetTask"
											:reduce="(e) => e.id"
											label="name"
											name="Budget Task"
											v-model="saveContract.budget_task_id"
											placeholder="Budget Task"
											@input="selectBudgetTaskDetail()"
											:disabled="!saveContract.budget_plan_id || !saveContract.budget_gl_id"
										/>
									</div>
								</div>
								<div class="col-lg-6">
									<div class="form-group">
										<label>Remaining Budget</label>
										<input type="text" disabled class="form-control" :value="remainingBudgets" />
									</div>
								</div>
								<b-button variant="primary" size="sm" @click="savetoTable"><span class="fe fe-save mr-1"></span>Save</b-button>
								<!-- <div class="col-lg-6">
                    <div class="form-group">
                      <label>Remaining Budget<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="saveContract.remaining_budget"
                        v-validate="'required'">
                      <span class="text-sm text-danger"
                        v-show="errors.has('Remaining Budget')">{{ errors.first("Remaining Budget") }}</span>
                    </div>
                  </div> -->
								<!-- <div class="col-lg-6">
                    <div class="form-group">
                      <label>OA Number<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-validate="'required|max:1000'" name="OA Number" placeholder="OA Number"
                        v-model="saveContract.oa_number" @input="saveContract.oa_number = $event.target.value.replace(/\D/g, '');"/>
                      <span class="text-sm text-danger"
                        v-show="errors.has('OA Number')">{{ errors.first("OA Number") }}</span>
                    </div>
                  </div> -->
							</div>
							<div class="row mt-5">
								<div>
									<!-- @on-sort-change.prevent="sortingawok" -->
									<h3>List Budget GL<span class="text-danger">*</span></h3>
									<vue-good-table
										:line-numbers="false"
										:columns="columnsBudgetGL"
										:rows="listBudgetTaskGL"
										:sort-options="{
											enabled: true,
										}"
										:search-options="{
											enabled: false,
										}"
										:pagination-options="{
											enabled: true,
											perPage: 5,
										}"
										style-class="vgt-table vgt-responsive border-0 table table-bordered"
									>
										<div slot="emptystate" class="text-center font-size-14">No data available</div>
										<template slot="table-row" slot-scope="props">
											<span v-if="props.column.field == 'action'">
												<div class="d-flex justify-content-center">
													<b-button type="button" class="mr-2" size="sm" variant="warning" @click="editRow(props.row, 'edit-gl')">
														<span class="fe fe-edit"></span>
													</b-button>
													<b-button type="button" size="sm" variant="primary" @click="removeRow(props.row.budget_task_id)">
														<span class="fe fe-trash"></span>
													</b-button>
												</div>
											</span>
											<span v-else-if="props.column.field == 'remaining_budget'">
												Rp. {{ convertNumber(props.row.remaining_budget) }}
											</span>
										</template>
										<template slot="pagination-bottom" slot-scope="props">
											<div class="d-flex justify-content-end">
												<div>
													<b-pagination
														:value="1"
														:total-rows="listBudgetTaskGL.length"
														:per-page="5"
														first-number
														last-number
														align="right"
														prev-class="prev-item"
														next-class="next-item"
														class="m-3"
														@input="(value) => props.pageChanged({ currentPage: value })"
													>
													</b-pagination>
												</div>
											</div>
										</template>
									</vue-good-table>
								</div>
							</div>
							<div class="card mt-3" v-if="saveContract.type_contract == '5'">
								<div class="card-header">
									<!-- Title -->
									<h4 class="card-header-title">OA Number <span class="text-danger">*</span></h4>

									<!-- Link -->
									<div style="display: flex; align-items: center; gap: 0.5rem">
										<div style="display: flex; align-items: center; gap: 0.25rem">
											<span
												class="fe fe-info"
												style="cursor: pointer"
												v-b-tooltip.hover
												title="Press 'Enter' to input OA Number"
											></span>
										</div>
										<input
											type="text"
											v-model="oaNumber"
											class="form-control"
											style="width: 100%"
											placeholder="Input OA Number here"
											@input="filterInput"
											@keydown.enter.prevent="handleEnter('add')"
										/>
										<button class="btn btn-primary btn-sm" @click="handleEnter('add')" type="button">Add</button>
									</div>
								</div>
								<div class="card-body">
									<vue-good-table
										:line-numbers="false"
										:columns="columnsOA"
										:rows="orderedOaNumber"
										:search-options="{
											enabled: false,
										}"
										:pagination-options="{
											enabled: true,
											perPage: 5,
										}"
										style-class="vgt-table table table-bordered"
									>
										<div slot="emptystate" class="text-center font-size-14">No data available</div>
										<template slot="table-row" slot-scope="props">
											<span v-if="props.column.field == 'action'">
												<div class="d-flex justify-content-center">
													<b-button variant="warning" class="mr-2" size="sm" @click="editRow(props.row, 'edit-oa', false)"
														><span class="fe fe-edit"></span
													></b-button>
													<b-button variant="primary" size="sm" @click="deleteItem(props.row.originalIndex, 'add')"
														><span class="fe fe-trash"></span
													></b-button>
												</div>
											</span>
										</template>
										<template slot="pagination-bottom" slot-scope="props">
											<div class="d-flex justify-content-end">
												<div>
													<b-pagination
														:value="1"
														:total-rows="saveContract.oa_number.length"
														:per-page="5"
														first-number
														last-number
														align="right"
														prev-class="prev-item"
														next-class="next-item"
														class="m-3"
														@input="(value) => props.pageChanged({ currentPage: value })"
													>
													</b-pagination>
												</div>
											</div>
										</template>
									</vue-good-table>
								</div>
								<!-- / .card-body -->
							</div>
						</div>
					</div>
					<div class="card mt-3">
						<div class="card-body">
							<label class="font-weight-bold">Contract Detail</label>
							<div class="row mt-2">
								<div class="col-12 col-lg-6">
									<div class="form-group">
										<label>Type Of Contract <span class="text-danger">*</span></label>
										<v-select
											v-model="saveContract.type_contract"
											:options="listTypeContract"
											v-validate="'required'"
											label="name"
											:reduce="(e) => e.id"
											name="Type Of Contract"
											placeholder="Type of Contract"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Type Of Contract')">{{
											errors.first('Type Of Contract')
										}}</span>
									</div>
									<div class="form-group">
										<label>Contract Name <span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="saveContract.name"
											class="form-control"
											v-validate="'required|max:1000'"
											placeholder="Contract Name"
											name="Contract Name"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Contract Name')">{{
											errors.first('Contract Name')
										}}</span>
									</div>
									<div class="form-group">
										<label>Contract Number <span class="text-danger">*</span></label>
										<input
											type="text"
											class="form-control"
											v-validate="'required|max:1000'"
											name="Contract Number"
											placeholder="Contract Number"
											v-model="saveContract.no"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Contract Number')">{{
											errors.first('Contract Number')
										}}</span>
									</div>
									<div class="form-group">
										<label>Contract Value<span class="text-danger">*</span></label>
										<div class="input-group">
											<div class="input-with-prefix">
												<span class="prefix">Rp</span>
												<input
													type="text"
													class="form-control with-prefix"
													v-validate="'required'"
													name="Contract Value"
													placeholder="Contract Value"
													v-model="formattedContractValue"
													@keypress="isNumber($event)"
													@input="changeContractValue($event, 'contract')"
												/>
											</div>
										</div>
										<span class="text-sm text-danger" v-show="errors.has('Contract Value')">{{
											errors.first('Contract Value')
										}}</span>
									</div>
									<div class="form-group">
										<label>Vendor<span class="text-danger">*</span></label>
										<v-select
											v-model="saveContract.vendor"
											:options="listVendor"
											:reduce="(e) => e"
											placeholder="Vendor"
											v-validate="'required'"
											name="Vendor"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Vendor')">{{ errors.first('Vendor') }}</span>
									</div>
								</div>

								<div class="col-12 col-lg-6">
									<div class="form-group">
										<label>Contract Owner<span class="text-danger">*</span></label>
										<v-select
											v-model="saveContract.contract_owner"
											:options="listUser"
											label="fullname"
											placeholder="Contract Owner"
											:reduce="(e) => e.id"
											v-validate="'required'"
											name="Contract Owner"
											@input="setOwnerDepartment"
										/>
										<!-- <v-select v-model="saveContract.contract_owner" :options="list_owner" label="fullname" placeholder="Contract Owner"
                        :reduce="(e) => e.id" v-validate="'required'" name="Contract Owner" @search="ownerSearch"/> -->
										<span class="text-sm text-danger" v-show="errors.has('Contract Owner')">{{
											errors.first('Contract Owner')
										}}</span>
									</div>
									<div class="form-group">
										<label>Contract Owner Department</label>
										<input
											type="text"
											class="form-control"
											placeholder="Contract Owner Department"
											disabled
											v-model="saveContract.contract_owner_department"
										/>
									</div>
									<div class="form-group">
										<label>Contract Co-Owner/PMO<span class="text-danger">*</span></label>
										<v-select
											v-model="saveContract.contract_co_owner"
											:options="listUser"
											label="fullname"
											placeholder="Contract Co-Owner/PMO"
											:reduce="(e) => e.id"
											v-validate="'required'"
											name="Contract Co-Owner/PMO"
											@input="setCoOwnerDepartment"
										/>

										<!-- <v-select v-model="saveContract.contract_co_owner" :options="list_co_owner" label="fullname" placeholder="Contract Co-Owner/PMO"
                        :reduce="(e) => e.id" v-validate="'required'" name="Contract Co-Owner/PMO" @search="coOwnerSearch"/> -->
										<span class="text-sm text-danger" v-show="errors.has('Contract Co-Owner/PMO')">{{
											errors.first('Contract Co-Owner/PMO')
										}}</span>
									</div>
									<div class="form-group">
										<label>Contract Co-Owner Department</label>
										<input
											type="text"
											class="form-control"
											placeholder="Contract Co Owner Department"
											disabled
											v-model="saveContract.contract_co_owner_department"
										/>
									</div>
									<div class="form-group">
										<label>Scope of Work<span class="text-danger">*</span></label>
										<input
											type="text"
											class="form-control"
											v-validate="'required|max:1000'"
											name="Scope of Work"
											placeholder="Scope of Work"
											v-model="saveContract.scope_of_work"
										/>
										<span class="text-sm text-danger" v-show="errors.has('Scope of Work')">{{
											errors.first('Scope of Work')
										}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-3">
						<div class="card-body">
							<label class="font-weight-bold">Contract Document</label>
							<div class="row mt-2">
								<div class="col-lg-4">
									<div class="form-group">
										<label>ToR (Max. 10Mb)<span class="text-danger">*</span></label>
										<!-- <div class="file-upload-wrapper">
                          <div class="file-upload-label" id="file-label">
                            <span ref="fileNameRef">{{ filesName.tor || 'Choose a file or drop it here' }}</span>
                            <button type="button">Browse</button>
                          </div>
                          <input
                            type="file"
                            id="tor-upload"
                            accept=".pdf"
                            @change="setFileTor"
                            v-validate="'required'"
                            ref="fileTor"
                            name="ToR"
                          />
                        </div> -->
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileTor"
											v-validate="'required'"
											ref="fileTor"
											name="ToR"
										/>
										<a
											v-if="detailContract?.upload_tor?.[0]?.file"
											:href="detailContract.upload_tor[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('ToR')">{{ errors.first('ToR') }}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>BoQ (Max. 10Mb)<span class="text-danger">*</span></label>
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileBoq"
											v-validate="'required'"
											ref="fileBoq"
											name="BoQ"
										/>
										<a
											v-if="detailContract?.upload_boq?.[0]?.file"
											:href="detailContract.upload_boq[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('BoQ')">{{ errors.first('BoQ') }}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>NoA/SPP (Max. 10Mb)<span class="text-danger">*</span></label>
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileNoa"
											v-validate="'required'"
											ref="fileNoa"
											name="NoA/SPP"
										/>
										<a
											v-if="detailContract?.upload_noa_spp?.[0]?.file"
											:href="detailContract.upload_noa_spp[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('NoA/SPP')">{{ errors.first('NoA/SPP') }}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>OE (Max. 10Mb)<span class="text-danger">*</span></label>
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileOe"
											v-validate="'required'"
											ref="fileOe"
											name="OE"
										/>
										<a
											v-if="detailContract?.upload_oe?.[0]?.file"
											:href="detailContract.upload_oe[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('OE')">{{ errors.first('OE') }}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>Contract Fully Signed (Max. 10Mb)<span class="text-danger">*</span></label>
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileFs"
											ref="fileFs"
											v-validate="'required'"
											name="Contract Fully Signed"
										/>
										<a
											v-if="detailContract?.upload_fs?.[0]?.file"
											:href="detailContract.upload_fs[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('Contract Fully Signed')">{{
											errors.first('Contract Fully Signed')
										}}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>BAPP (Max. 10Mb)<span class="text-danger">*</span></label>
										<input
											type="file"
											class="form-control"
											accept=".pdf"
											@change="setFileBapp"
											v-validate="'required'"
											ref="fileBapp"
											name="BAPP"
										/>
										<a
											v-if="detailContract?.upload_bapp?.[0]?.file"
											:href="detailContract.upload_bapp[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('BAPP')">{{ errors.first('BAPP') }}</span>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label>Others (Max. 10Mb)</label>
										<input type="file" class="form-control" accept=".pdf" @change="setFileOthers" ref="fileOther" name="Others" />
										<a
											v-if="detailContract?.files?.[0]?.file"
											:href="detailContract.files[0].file"
											class="text-info"
											target="_blank"
											>Click to view</a
										>
										<span class="text-sm text-danger" v-show="errors.has('Others')">{{ errors.first('Others') }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-3">
						<div class="card-body">
							<label class="font-weight-bold">Contract Duration <span class="text-danger">*</span></label>
							<div class="row g-3 mb-5 mt-2">
								<div class="form-group col">
									<label>Start Date <span class="text-danger">*</span></label>
									<input
										type="date"
										v-model="saveContract.start_date"
										class="form-control"
										placeholder="Start Date"
										v-validate="'required'"
										name="Start Date"
									/>
									<span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first('Start Date') }}</span>
								</div>
								<div class="form-group col">
									<label>End Date <span class="text-danger">*</span></label>
									<input
										type="date"
										v-model="saveContract.end_date"
										class="form-control"
										placeholder="End Date"
										:min="endMin(saveContract.start_date)"
										v-validate="'required'"
										name="End Date"
										:disabled="!saveContract.start_date"
										@change="getTotalDuration(`contract`, saveContract.start_date, saveContract.end_date)"
									/>
									<span class="text-sm text-danger" v-show="errors.has('End Date')"
										>The Date must be in the format dd-mm-yyyy</span
									>
								</div>
								<div class="form-group col">
									<label>Total Duration (Month)</label>
									<input type="text" v-model="saveContract.total_duration" class="form-control" disabled />
								</div>
							</div>

							<div class="card">
								<div class="card-header">
									<h4 class="card-header-title">Contract Duration Detail</h4>
									<a href="#!" class="btn btn-sm btn-primary" @click="addDurationDetail"> Add </a>
								</div>
								<div class="card-body">
									<div v-for="(item, index) in saveContract.contract_duration_detail.details" :key="index">
										<hr v-if="index > 0" class="my-3" />
										<div class="row">
											<div class="form-group col-10">
												<label>Detail Name {{ index + 1 }}<span class="text-danger">*</span></label>
												<input
													type="text"
													class="form-control"
													v-model="item.detail_name"
													:placeholder="`Contract Detail ${index + 1}`"
													v-validate="'required|max:1000'"
													@input="checkLengthValue(item.detail_name)"
													:name="`Contract Detail ${index}`"
												/>
												<span class="text-sm text-danger" v-show="errors.has(`Contract Detail ${index}`)">{{
													errors.first(`Contract Detail ${index}`)
												}}</span>
											</div>
											<div class="col-lg-1 d-flex align-items-center">
												<a href="#!" class="btn btn-sm btn-primary" @click="addDurationDetailItems(index)">Add</a>
											</div>
											<div class="col-lg-1 d-flex align-items-center">
												<a href="#!" class="btn btn-sm btn-primary" @click="removeDurationDetail(index)"
													><span class="fe fe-trash"></span
												></a>
											</div>
										</div>
										<div class="row" v-for="(dtas, itmIndex) in item.items" :key="itmIndex">
											<div class="form-group col-4">
												<label>Item Name {{ itmIndex + 1 }} <span class="text-danger">*</span></label>
												<input
													type="text"
													class="form-control"
													v-model="dtas.item_name"
													:placeholder="`Item Name ${itmIndex + 1}`"
													v-validate="'required|max:1000'"
													:name="`Item Name ${itmIndex + 1}`"
												/>
												<span class="text-sm text-danger" v-show="errors.has(`Item Name ${itmIndex + 1}`)">{{
													errors.first(`Item Name ${itmIndex + 1}`)
												}}</span>
											</div>
											<div class="form-group col-3">
												<label>Work Duration (Month) {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
												<input
													type="number"
													class="form-control"
													v-validate="'required'"
													v-model="dtas.work_duration"
													:placeholder="`Work Duration ${itmIndex + 1}`"
													:name="`Work Duration ${itmIndex + 1}`"
													@keypress="isNumber($event)"
												/>
												<span class="text-sm text-danger" v-if="isExceedingLimit">
													Total work duration exceeds the allowed
													{{ saveContract.total_duration }} months!
												</span>
											</div>
											<div class="form-group col-4">
												<label>Description {{ itmIndex + 1 }}</label>
												<input
													type="text"
													class="form-control"
													v-model="dtas.description"
													:placeholder="`Description ${itmIndex + 1}`"
													v-validate="'required|max:1000'"
													:name="`Description ${itmIndex + 1}`"
												/>
												<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
													errors.first(`Description ${itmIndex + 1}`)
												}}</span>
											</div>
											<div class="col-lg-1 d-flex align-items-center">
												<a href="#!" class="btn btn-sm btn-primary" @click="removeDurationDetailItems(index, itmIndex)"
													><span class="fe fe-trash"></span
												></a>
											</div>
										</div>
									</div>
									<!-- <div>dbasmndasbdmn</div> -->
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<button
							type="button"
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-outline-primary mr-3"
							@click="tabIndex++"
						>
							Next
						</button>
					</div>
				</b-tab>
				<!-- TAB TOP -->
				<b-tab title="Term of Payment">
					<div class="card">
						<div class="card-header">
							<h4 class="card-header-title">Fixed Assigment</h4>
							<a href="#!" class="btn btn-sm btn-primary" @click="addFixedAssigment"> Add </a>
						</div>
						<div class="card-body">
							<div v-if="saveContract.term_of_payments.fixed_assignment.contract_items.length > 0" class="row mb-3">
								<div class="col-6">Fixed Assigment</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Percentage<span class="text-danger">*</span></label>
									<input
										type="number"
										class="form-control"
										v-model="saveContract.term_of_payments.fixed_assignment.percentage"
										:placeholder="`Percentage`"
										@keypress="isPercent($event)"
										@input="calculateAmountFromPercent('fixed_assignment')"
									/>
								</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Amount<span class="text-danger">*</span></label>
									<input
										type="text"
										class="form-control"
										v-model="formattedFixedAmount"
										:placeholder="`Amount`"
										@keypress="isNumber($event)"
										@input="calculatePercentFromAmount('fixed_assignment')"
									/>
								</div>
							</div>
							<div v-for="(item, index) in saveContract.term_of_payments.fixed_assignment.contract_items" :key="index">
								<hr v-if="index > 0" class="my-3" />
								<div class="row">
									<div class="form-group col-5">
										<label>Contract Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.contract_item"
											class="form-control"
											:placeholder="`Contract Item ${index + 1}`"
											v-validate="'required|max:1000'"
											:name="`Fixed Assignment Contract Item ${index + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Fixed Assignment Contract Item ${index + 1}`)">{{
											errors.first(`Fixed Assignment Contract Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label>Percentage Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="item.percentage_item"
											class="form-control"
											:placeholder="`Percentage Item ${index + 1}`"
											v-validate="'required'"
											:name="`Fixed Assignment Percentage Item ${index + 1}`"
											@keypress="isPercent($event)"
											@input="calculateAmountFromPercentage(index, 'fixed_assignment')"
											:disabled="
												!saveContract.term_of_payments.fixed_assignment.amount ||
												saveContract.term_of_payments.fixed_assignment.amount == 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Fixed Assignment Percentage Item ${index + 1}`)">{{
											errors.first(`Fixed Assignment Percentage Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-3">
										<label>Amount Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.amount_item"
											class="form-control"
											:placeholder="`Amount Item ${index + 1}`"
											v-validate="'required'"
											:name="`Fixed Assignment Amount Item ${index + 1}`"
											@keypress="isNumber($event)"
											@input="calculatePercentageFromAmount(index, 'fixed_assignment')"
											:disabled="
												!saveContract.term_of_payments.fixed_assignment.amount ||
												saveContract.term_of_payments.fixed_assignment.amount == 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Fixed Assignment Amount Item ${index + 1}`)">{{
											errors.first(`Fixed Assignment Amount Item ${index + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											:class="{
												disabled:
													(!item.amount_item && !item.percentage_item) || (item.contract_item == 0 && item.percentage_item == 0),
											}"
											class="btn btn-sm btn-primary"
											@click="addFixedAssigmentItems(index)"
											>Add</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="removeFixedAssigment(index)"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
								<div class="row" v-for="(dts, itmIndex) in item.terms" :key="itmIndex">
									<div class="form-group col-3">
										<label>Term {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											class="form-control"
											v-model="dts.term"
											v-validate="'required|max:1000'"
											:placeholder="`Term ${itmIndex + 1}`"
											:name="`Term ${item.contract_item} ${itmIndex + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Term ${item.contract_item} ${itmIndex + 1}`)">{{
											errors.first(`Term ${item.contract_item} ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label>Percentage {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="dts.percentage"
											class="form-control"
											v-validate="'required'"
											:placeholder="`Percentage ${itmIndex + 1}`"
											:name="`FA Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isPercent($event)"
											@input="calculateTermAmountFromPercentage(index, itmIndex, item.contract_item, 'fixed_assignment')"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`FA Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`FA Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>
									<div class="form-group col-2">
										<label>Amount {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="dts.amount"
											class="form-control"
											v-validate="'required'"
											:placeholder="`Amount ${itmIndex + 1}`"
											:name="`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isNumber($event)"
											@input="calculateTermPercentageFromAmount(index, itmIndex, item.contract_item, 'fixed_assignment')"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>
									<div class="form-group col-3">
										<label>Description {{ itmIndex + 1 }}</label>
										<input
											type="text"
											v-model="dts.description"
											class="form-control"
											:placeholder="`Description ${itmIndex + 1}`"
											v-validate="'max:1000'"
											:name="`Description ${itmIndex + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
											errors.first(`Description ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="addFixedAssigmentItemsDetail(index, itmIndex)"
											><span class="fe fe-plus"></span>Detail</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="removeFixedAssigmentItems(index, itmIndex)"
											><span class="fe fe-trash"></span
										></a>
									</div>
									<div class="row" v-for="(detail, detailIndex) in dts.details" :key="detailIndex">
										<div class="form-group col-lg-11">
											<label>Detail {{ detailIndex + 1 }}</label>
											<textarea
												class="form-control"
												v-model="dts.details[detailIndex]"
												:placeholder="`Detail ${detailIndex + 1}`"
												v-validate="'max:1000'"
												:name="`Details ${detailIndex + 1}`"
											/>
											<span class="text-sm text-danger" v-show="errors.has(`Details ${detailIndex + 1}`)">{{
												errors.first(`Details ${detailIndex + 1}`)
											}}</span>
										</div>
										<div class="col-lg-1 d-flex align-items-center">
											<a
												href="#!"
												class="btn btn-sm btn-primary"
												@click="removeFixedAssigmentItemsDetail(index, itmIndex, detailIndex)"
											>
												<span class="fe fe-trash"></span>
											</a>
										</div>
									</div>
								</div>

								<!-- <div class="row g-3 text-right">
                    <div class="col"></div>
                    <div class="col-2 align-self-center">
                      <label class="text-center">Total Percentage %</label>
                    </div>
                    <div class="col-3">
                      <input type="text" v-model="item.total_percentage" class="form-control" placeholder="Percentage"
                        disabled />
                    </div>
                    <div class="col-1"></div>
                  </div> -->
							</div>
							<!-- <div>dbasmndasbdmn</div> -->
						</div>
					</div>
					<div class="card mt-5">
						<div class="card-header">
							<h4 class="card-header-title">Provision</h4>
							<a href="#!" class="btn btn-sm btn-primary" @click="addProvision"> Add </a>
						</div>
						<div class="card-body">
							<div v-if="saveContract.term_of_payments.provision.contract_items.length > 0" class="row mb-3">
								<div class="col-6">Provision</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Percentage<span class="text-danger">*</span></label>
									<input
										type="number"
										class="form-control"
										v-model="saveContract.term_of_payments.provision.percentage"
										:placeholder="`Percentage`"
										@keypress="isPercent($event)"
										@input="calculateAmountFromPercent('provision')"
									/>
								</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Amount<span class="text-danger">*</span></label>
									<input
										type="text"
										class="form-control"
										v-model="formattedProvisionAmount"
										:placeholder="`Amount`"
										@keypress="isNumber($event)"
										@input="calculatePercentFromAmount('provision')"
									/>
								</div>
							</div>
							<div v-for="(item, index) in saveContract.term_of_payments.provision.contract_items" :key="index">
								<hr v-if="index > 0" class="my-3" />
								<div class="row">
									<div class="form-group col-5">
										<label>Contract Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.contract_item"
											class="form-control"
											:placeholder="`Contract Item ${index + 1}`"
											v-validate="'required|max:1000'"
											:name="`Provision Contract Item ${index + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Provision Contract Item ${index + 1}`)">{{
											errors.first(`Provision Contract Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label>Percentage Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="item.percentage_item"
											class="form-control"
											:placeholder="`Percentage Item ${index + 1}`"
											v-validate="'required'"
											:name="`Provision Percentage Item ${index + 1}`"
											@keypress="isPercent($event)"
											@input="calculateAmountFromPercentage(index, 'provision')"
											:disabled="
												!saveContract.term_of_payments.provision.amount || saveContract.term_of_payments.provision.amount == 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Provision Percentage Item ${index + 1}`)">{{
											errors.first(`Provision Percentage Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-3">
										<label>Amount Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.amount_item"
											class="form-control"
											:placeholder="`Amount Item ${index + 1}`"
											v-validate="'required'"
											:name="`Provision Amount Item ${index + 1}`"
											@keypress="isNumber($event)"
											@input="calculatePercentageFromAmount(index, 'provision')"
											:disabled="
												!saveContract.term_of_payments.provision.amount || saveContract.term_of_payments.provision.amount == 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Provision Amount Item ${index + 1}`)">{{
											errors.first(`Provision Amount Item ${index + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											:class="{
												disabled:
													(!item.amount_item && !item.percentage_item) || (item.contract_item == 0 && item.percentage_item == 0),
											}"
											class="btn btn-sm btn-primary"
											@click="addProvisionItems(index)"
											>Add</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="removeProvision(index)"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
								<div class="row" v-for="(dts, itmIndex) in item.terms" :key="itmIndex">
									<div class="form-group col-3">
										<label>Term {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											class="form-control"
											v-model="dts.term"
											v-validate="'required|max:1000'"
											:placeholder="`Term ${itmIndex + 1}`"
											:name="`Term ${item.contract_item} ${itmIndex + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Term ${item.contract_item} ${itmIndex + 1}`)">{{
											errors.first(`Term ${item.contract_item} ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label>Percentage {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="dts.percentage"
											class="form-control"
											v-validate="'required'"
											:placeholder="`Percentage ${itmIndex + 1}`"
											:name="`Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isPercent($event)"
											@input="calculateTermAmountFromPercentage(index, itmIndex, item.contract_item, 'provision')"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>
									<div class="form-group col-2">
										<label>Amount {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="dts.amount"
											class="form-control"
											v-validate="'required'"
											:placeholder="`Amount ${itmIndex + 1}`"
											:name="`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isNumber($event)"
											@input="calculateTermPercentageFromAmount(index, itmIndex, item.contract_item, 'provision')"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>
									<div class="form-group col-3">
										<label>Description {{ itmIndex + 1 }}</label>
										<input
											type="text"
											v-model="dts.description"
											class="form-control"
											:placeholder="`Description ${itmIndex + 1}`"
											v-validate="'max:1000'"
											:name="`Description ${itmIndex + 1}`"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
											errors.first(`Description ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="addProvisionItemsDetail(index, itmIndex)"
											><span class="fe fe-plus"></span>Detail</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a href="#!" class="btn btn-sm btn-primary" @click="removeProvisionItems(index, itmIndex)"
											><span class="fe fe-trash"></span
										></a>
									</div>
									<div class="row" v-for="(detail, detailIndex) in dts.details" :key="detailIndex">
										<div class="form-group col-lg-11">
											<label>Detail {{ detailIndex + 1 }}</label>
											<textarea
												class="form-control"
												v-model="dts.details[detailIndex]"
												:placeholder="`Detail ${detailIndex + 1}`"
												v-validate="'max:1000'"
												:name="`Details ${detailIndex + 1}`"
											/>
											<span class="text-sm text-danger" v-show="errors.has(`Details ${detailIndex + 1}`)">{{
												errors.first(`Details ${detailIndex + 1}`)
											}}</span>
										</div>
										<div class="col-lg-1 d-flex align-items-center">
											<a
												href="#!"
												class="btn btn-sm btn-primary"
												@click="removeProvisionItemsDetail(index, itmIndex, detailIndex)"
											>
												<span class="fe fe-trash"></span>
											</a>
										</div>
									</div>
								</div>

								<!-- <div class="row g-3 text-right">
                    <div class="col"></div>
                    <div class="col-2 align-self-center">
                      <label class="text-center">Total Percentage %</label>
                    </div>
                    <div class="col-3">
                      <input type="text" v-model="item.total_percentage" class="form-control" placeholder="Percentage"
                        disabled />
                    </div>
                    <div class="col-1"></div>
                  </div> -->
							</div>
							<!-- <div>dbasmndasbdmn</div> -->
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<div class="row">
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Fixed Assignment</label>
										<p>{{ totalFixedPercentage }}%</p>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Provision</label>
										<p>{{ totalProvisionPercentage }}%</p>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Total Percentage</label>
										<p>{{ totalOverallPercentage }}%</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<button
							type="button"
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-outline-primary mr-3"
							@click="tabIndex++"
						>
							Next
						</button>
					</div>
				</b-tab>
				<b-tab title="Notification Configuration">
					<div class="row g-3">
						<div class="row">
							<div class="form-group col">
								<label>Email CC <span class="text-danger">*</span></label>
								<v-select
									name="Email CC"
									v-validate="saveContract.email_cc.length < 1 ? 'required' : ''"
									v-model="saveContract.email_cc"
									:options="listUser"
									label="email"
									:reduce="(e) => e.email"
									placeholder="Select email cc"
									multiple
									@input="ValidateEmailCcContract"
								>
									<template slot="option" slot-scope="option">
										{{ option.fullname }}
									</template>

									<template slot="selected-option" slot-scope="option">
										{{ option.email }}
									</template>
								</v-select>
								<span class="text-sm text-danger" v-show="errors.has('Email CC')">{{ errors.first('Email CC') }}</span>
							</div>
							<div class="form-group col">
								<label>Email BCC </label>
								<v-select
									name="Email BCC"
									v-validate="emailActive && notificationRecipientEmails.length < 1 ? 'required' : ''"
									v-model="saveContract.email_bcc"
									:options="listUser"
									label="email"
									:reduce="(e) => e.email"
									placeholder="Select user email"
									multiple
								>
									<template slot="option" slot-scope="option">
										{{ option.fullname }}
									</template>

									<template slot="selected-option" slot-scope="option">
										{{ option.email }}
									</template>
								</v-select>
								<span class="text-sm text-danger" v-show="errors.has('Email BCC')">{{ errors.first('Email BCC') }}</span>
							</div>
						</div>
						<div class="row">
							<div class="form-group col">
								<label>Email External (optional)</label>
								<v-select
									ref="saveContract_email_external"
									name="Email External"
									v-model="saveContract.email_external"
									placeholder="Type email then press enter to add"
									multiple
									taggable
									no-drop
									:select-on-key-codes="[188, 13]"
									:select-on-tab="true"
									@search:blur="addContractEmailExternal"
								></v-select>
							</div>
							<div class="form-group col">
								<label>WhatsApp Number (optional)</label>
								<v-select
									ref="saveContract_whatsapp_number"
									name="WhatsApp Number"
									v-model="saveContract.whatsapp_number"
									placeholder="For example 08123456789 then press enter to add"
									multiple
									taggable
									no-drop
									:select-on-tab="true"
									:map-keydown="validateWhatsappNumber"
									@search:blur="addContractWhatsappNumber"
								></v-select>
							</div>
						</div>
						<div class="form-group" v-if="isAdd == true">
							<!-- v-if="isAdd == true" -->
							<div v-if="isLoading == false">
								<button
									style="margin-left: 10px; float: right"
									class="mt-2 btn btn-primary"
									type="button"
									@click="saveAdd('submit')"
								>
									Submit
								</button>
								<button
									style="margin-left: 10px; float: right"
									class="mt-2 btn btn-warning"
									type="button"
									@click="saveAdd('draft')"
								>
									Save Draft
								</button>
								<button
									type="button"
									style="margin-right: auto; float: right"
									class="mt-2 btn btn-outline-primary mr-3"
									@click="tabIndex--"
								>
									Back
								</button>
							</div>
							<div v-else>
								<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled>
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									Loading...
								</button>
							</div>
						</div>
						<div class="form-group" v-else>
							<div v-if="isLoading == false">
								<button
									style="margin-left: 10px; float: right"
									class="mt-2 btn btn-primary"
									type="button"
									@click="saveUpdate('existing')"
								>
									Submit
								</button>
								<button
									style="margin-left: 10px; float: right"
									class="mt-2 btn btn-warning"
									type="button"
									@click="saveUpdate('draft')"
									v-if="latestStatus == 'Draft'"
								>
									Save Draft
								</button>
								<button
									type="button"
									style="margin-right: auto; float: right"
									class="mt-2 btn btn-outline-primary mr-3"
									@click="tabIndex--"
								>
									Back
								</button>
							</div>
							<div v-else>
								<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled>
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									Loading...
								</button>
							</div>
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-modal>
		<!-- Modal Edit GL -->
		<b-modal id="modal-edit-gl" size="lg" hide-footer :title="typeEdit == 'edit-gl' ? 'Edit Budget GL' : 'Edit OA'">
			<div v-if="typeEdit == 'edit-gl'">
				<div class="form-group">
					<label>Budget Plan<span class="text-danger">*</span></label>
					<v-select
						:options="ListBudgetPlan"
						:reduce="(e) => e.id"
						label="label"
						name="Budget Plan"
						v-model="editGL.budget_plan_id"
						v-validate="'required'"
						@input="getListBudgetTaskforEdit()"
					/>
					<span class="text-sm text-danger" v-show="errors.has('Budget Plan')">{{ errors.first('Budget Plan') }}</span>
				</div>
				<div class="form-group">
					<label>Budget GL<span class="text-danger">*</span></label>
					<v-select
						:options="ListBudgetGL"
						:reduce="(e) => e.id"
						label="label"
						name="Budget GL"
						v-model="editGL.budget_gl_id"
						v-validate="'required'"
						@input="selectBudgetTaskforEdit($event)"
						placeholder="Budget GL"
					/>
					<!-- name="Budget GL" :value="editGL.budget_gl_id" @input="handleInput" placeholder="Budget GL"/> -->
					<span class="text-sm text-danger" v-show="errors.has('Budget GL')">{{ errors.first('Budget GL') }}</span>
				</div>
				<div class="form-group">
					<label>Budget Task<span class="text-danger">*</span></label>
					<v-select
						:options="ListBudgetTask"
						:reduce="(e) => e.id"
						label="name"
						name="Budget Task"
						v-model="editGL.budget_task_id"
						placeholder="Budget Task"
						v-validate="'required'"
						@input="selectBudgetTaskDetail2()"
					/>
					<span class="text-sm text-danger" v-show="errors.has('Budget Task')">{{ errors.first('Budget Task') }}</span>
				</div>
				<div class="d-flex justify-content-end">
					<b-button variant="primary" @click="updateGL()">Save</b-button>
				</div>
			</div>
			<div v-else>
				<div class="form-group">
					<label>OA Number</label>
					<input type="text" class="form-control" v-model="oaNumberedit.oa_number" @input="filterInput" />
				</div>
				<div class="d-flex justify-content-end">
					<b-button variant="primary" @click="updateOA()">Save</b-button>
				</div>
			</div>
		</b-modal>
		<!-- Modal Import -->
		<b-modal id="importFile" size="xl" hide-footer title="Form Import">
			<form @submit.prevent="importData()">
				<div class="row">
					<div class="col-12 mb-3" v-for="(item, i) in importPayload" :key="i">
						<label
							>Upload File
							<span class="mx-3"
								><a :href="item.sample" download target="_blank"> <i class="fe fe-download"></i> Download Template </a></span
							>
						</label>
						<input type="file" class="form-control" placeholder="File" ref="importFileUpload" @change="importFileUpload" />
					</div>
				</div>

				<div class="row">
					<div class="col-12 text-right">
						<button
							style="margin-left: auto; float: right"
							class="btn btn-primary mt-4"
							type="submit"
							v-if="isLoading == false"
						>
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</div>
			</form>
		</b-modal>
		<b-modal id="modal-notification" size="xl" hide-footer title="Detail Notification" @hide="closeNotification($event)">
			<div class="row g-3">
				<div class="form-group col overflow-auto">
					<label>Notification <span class="text-danger">*</span></label>
					<vue-good-table
						@on-selected-rows-change="selectionAdd"
						:columns="columnsNotification"
						ref="tableNotif"
						:rows="listNotification"
						:select-options="{
							enabled: true,
							disableSelectInfo: true,
							selectOnCheckboxOnly: true,
						}"
						style-class="vgt-table border-0 table"
					>
						<template slot="table-row" slot-scope="props">
							<!-- <span v-if="props.column.field == 'action'">
                  <b-button
                    @click="detailNotification(props.row)"
                    type="button"
                    class="no-wrap ml-2"
                    variant="info"
                    style="margin-left: 5px"
                    size="sm"
                  >
                    <span class="fe fe-eye"></span>
                  </b-button>
                </span> -->
							<span v-if="props.column.field == 'email'" class="text-center" style="margin-bottom: 30px">
								<div class="text-center">
									<input
										class="form-check-input"
										type="checkbox"
										v-model="props.row.email"
										@change="emailActive = props.row.email"
									/>
								</div>
							</span>
							<span v-else-if="props.column.field == 'whatsapp'" class="text-center" style="margin-bottom: 30px">
								<div class="text-center">
									<input
										class="form-check-input"
										type="checkbox"
										v-model="props.row.whatsapp"
										@change="whatsappActive = props.row.whatsapp"
									/>
								</div>
							</span>
						</template>
					</vue-good-table>
				</div>
			</div>
			<div class="row g-3">
				<div class="form-group col">
					<label>Email CC </label>
					<v-select
						name="Email CC"
						v-validate="emailActive && notificationRecipientEmails.length < 1 ? 'required' : ''"
						v-model="modalNotification.email_cc"
						:options="listUser"
						label="email"
						:reduce="(e) => e.email"
						placeholder="Select email cc"
						multiple
					>
						<template #option="{ fullname }">
							<div>{{ fullname }}</div>
						</template>
					</v-select>
					<span class="text-sm text-danger" v-show="errors.has('Email CC')">{{ errors.first('Email CC') }}</span>
				</div>
				<div class="form-group col">
					<label>Email BCC </label>
					<v-select
						name="Email BCC"
						v-validate="emailActive && notificationRecipientEmails.length < 1 ? 'required' : ''"
						v-model="modalNotification.email_bcc"
						:options="listUser"
						label="email"
						:reduce="(e) => e.email"
						placeholder="Select user email"
						multiple
					>
						<template #option="{ fullname }">
							<div>{{ fullname }}</div>
						</template>
					</v-select>
					<span class="text-sm text-danger" v-show="errors.has('Email BCC')">{{ errors.first('Email BCC') }}</span>
				</div>
			</div>
			<div class="row g-3">
				<div class="form-group col">
					<label>Email External (optional)</label>
					<v-select
						ref="modalNotification_email_external"
						v-model="modalNotification.email_external"
						placeholder="Type email then press enter to add"
						multiple
						taggable
						no-drop
						:select-on-key-codes="[188, 13]"
						:select-on-tab="true"
						@search:blur="addNotificationEmailExternal"
					></v-select>
				</div>
				<div class="form-group col">
					<label>Additional Number (optional)</label>
					<v-select
						ref="modalNotification_whatsapp_number"
						v-model="modalNotification.whatsapp_number"
						placeholder="For example 08123456789 then press enter to add"
						multiple
						taggable
						no-drop
						:select-on-tab="true"
						:map-keydown="validateWhatsappNumber"
						@search:blur="addNotificationWhatsappNumber"
					></v-select>
				</div>
			</div>
			<div class="col-12 text-right">
				<button
					style="margin-left: auto; float: right"
					class="btn btn-primary mt-4"
					@click="submitNotification"
					v-if="isLoading == false"
					:disabled="!(whatsappActive || emailActive) || modalNotification.notification.length === 0"
				>
					Save
				</button>
				<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Loading...
				</button>
			</div>
		</b-modal>
		<!-- Modal Amandemen -->
		<b-modal id="modal-amandemen" size="xl" hide-footer title="Contract Amendment Form" @hide="confirmClose">
			<b-tabs content-class="mt-3" v-model="tabIndex" @activate-tab="beforeTabChange">
				<b-tab title="Amendment" active>
					<div class="row">
						<div class="col-lg-full">
							<div class="form-group">
								<label>Type of Amendment<span class="text-danger">*</span></label>
								<p>Amendment {{ this.detailContract?.amandement + 1 }}</p>
								<!-- <v-select v-model="selectedAmandemenType" :options="amandementOptions" label="name"
                  name="Type of Amandemen" :reduce="(e) => e.amandement"
                  @input="postgetListContractByAmandement(contractId, selectedAmandemenType)">
                </v-select> -->
							</div>
						</div>
						<div class="col-lg-full">
							<div class="form-group">
								<label for="scopeRenewal">Scope Renewal Contract</label>
								<b-form-checkbox-group id="scopeRenewal" v-model="selectedScopeRenewal" stacked>
									<b-form-checkbox value="scope_of_work">Scope of Work</b-form-checkbox>
									<b-form-checkbox value="contract_value">Contract Value</b-form-checkbox>
									<b-form-checkbox value="contract_duration">Contract Duration</b-form-checkbox>
									<b-form-checkbox value="term_of_payment">Term of Payment</b-form-checkbox>
									<b-form-checkbox
										value="oa_number"
										:disabled="this.detailContract.typeContract?.name != `Kontrak Payung / Outline Agreement`"
										>OA Number</b-form-checkbox
									>
								</b-form-checkbox-group>
							</div>
						</div>
					</div>
					<div class="form-group">
						<button
							type="button"
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-primary mr-3"
							@click="
								() => {
									beforeTabChange();
									tabIndex++;
								}
							"
						>
							Next
						</button>
						<!-- <button type="button" style="margin-right: auto; float: right" class="mt-4 btn btn-outline-primary mr-3"
              @click="() => { this.resetAllData();$bvModal.hide('modal-amandemen');}">
              Cancel
              </button> -->
					</div>
				</b-tab>
				<b-tab title="Contract Detail">
					<div class="row mt-5">
						<div>
							<h3>List Budget GL</h3>
							<vue-good-table
								:line-numbers="true"
								:columns="columnsBudgetGLAmandement"
								:rows="saveAmandement.list_budget_gl"
								:search-options="{
									enabled: false,
								}"
								:pagination-options="{
									enabled: true,
									perPage: 5,
								}"
								style-class="vgt-table table table-bordered"
							>
								<div slot="emptystate" class="text-center font-size-14">No data available</div>
								<template slot="table-row" slot-scope="props">
									<span v-if="props.column.field == 'remaining_budget'">
										Rp.{{ convertNumber(props.row.remaining_budget) }}
									</span>
								</template>
								<template slot="pagination-bottom" slot-scope="props">
									<div class="d-flex justify-content-end">
										<div>
											<b-pagination
												:value="1"
												:total-rows="saveAmandement.list_budget_gl.length"
												:per-page="5"
												first-number
												last-number
												align="right"
												prev-class="prev-item"
												next-class="next-item"
												class="m-3"
												@input="(value) => props.pageChanged({ currentPage: value })"
											>
											</b-pagination>
										</div>
									</div>
								</template>
							</vue-good-table>
						</div>
					</div>
					<div class="card mt-3" v-if="saveAmandement.type_contract == '5'">
						<div class="card-header">
							<!-- Title -->
							<h4 class="card-header-title">OA Number <span class="text-danger">*</span></h4>

							<!-- Link -->
							<div style="display: flex; align-items: center; gap: 0.5rem">
								<div style="display: flex; align-items: center; gap: 0.25rem">
									<span
										class="fe fe-info"
										style="cursor: pointer"
										v-b-tooltip.hover
										title="Press 'Enter' to input OA Number"
									></span>
								</div>
								<input
									type="text"
									v-model="oaNumber"
									class="form-control"
									style="width: 100%"
									placeholder="Input OA Number here"
									@input="filterInput"
									@keydown.enter.prevent="handleEnter('amandement')"
									:disabled="isScopeNotSelected('oa_number')"
								/>
								<button
									class="btn btn-primary btn-sm"
									@click="handleEnter('amandement')"
									type="button"
									:disabled="isScopeNotSelected('oa_number')"
								>
									Add
								</button>
							</div>
						</div>
						<div class="card-body">
							<vue-good-table
								:line-numbers="false"
								:columns="columnsOA"
								:rows="saveAmandement.oa_number"
								:search-options="{
									enabled: false,
								}"
								:pagination-options="{
									enabled: true,
									perPage: 5,
								}"
								style-class="vgt-table table table-bordered"
							>
								<div slot="emptystate" class="text-center font-size-14">No data available</div>
								<template slot="table-row" slot-scope="props">
									<span v-if="props.column.field == 'action'">
										<div class="d-flex justify-content-center">
											<b-button
												variant="warning"
												class="mr-2"
												size="sm"
												@click="editRow(props.row, 'edit-oa', true)"
												:disabled="isScopeNotSelected('oa_number')"
												><span class="fe fe-edit"></span
											></b-button>
											<b-button
												variant="primary"
												size="sm"
												@click="deleteItem(props.row.originalIndex, 'amandement')"
												:disabled="isScopeNotSelected('oa_number')"
												><span class="fe fe-trash"></span
											></b-button>
										</div>
									</span>
								</template>
								<template slot="pagination-bottom" slot-scope="props">
									<div class="d-flex justify-content-end">
										<div>
											<b-pagination
												:value="1"
												:total-rows="saveAmandement.oa_number.length"
												:per-page="5"
												first-number
												last-number
												align="right"
												prev-class="prev-item"
												next-class="next-item"
												class="m-3"
												@input="(value) => props.pageChanged({ currentPage: value })"
											>
											</b-pagination>
										</div>
									</div>
								</template>
							</vue-good-table>
						</div>
						<!-- / .card-body -->
					</div>
					<div class="row mt-5">
						<div class="col-lg-6">
							<div class="form-group">
								<label>Type Of Contract </label>
								<v-select
									v-model="saveAmandement.tipe_contract"
									:options="listTypeContract"
									label="name"
									:reduce="(e) => e.id"
									name="Type Of Contract"
									disabled
								/>
								<span class="text-sm text-danger" v-show="errors.has('Type Of Contract')">{{
									errors.first('Type Of Contract')
								}}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Contract Name </label>
								<input
									type="text"
									v-model="saveAmandement.name"
									class="form-control"
									v-validate="'required|max:1000'"
									name="Contract Name"
									disabled
								/>
								<span class="text-sm text-danger" v-show="errors.has('Contract Name')">{{
									errors.first('Contract Name')
								}}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Contract Number </label>
								<input
									type="text"
									class="form-control"
									v-validate="'required|max:1000'"
									name="Contract Number"
									v-model="saveAmandement.no"
									disabled
								/>
								<span class="text-sm text-danger" v-show="errors.has('Contract Number')">{{
									errors.first('Contract Number')
								}}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Vendor</label>
								<v-select v-model="saveAmandement.vendor" :options="listVendor" :reduce="(e) => e" name="Vendor" disabled />
								<span class="text-sm text-danger" v-show="errors.has('Vendor')">{{ errors.first('Vendor') }}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Contract Owner</label>
								<v-select
									v-model="saveAmandement.owner"
									:options="listUser"
									placeholder="Contract Owner"
									label="fullname"
									:reduce="(e) => e.id"
									name="Contract Owner"
									disabled
								/>
								<!-- <v-select v-model="saveAmandement.owner" :options="listUser" label="fullname" :reduce="(e) => e.id"
                      name="Contract Owner" disabled @search="ownerSearch"/> -->
								<span class="text-sm text-danger" v-show="errors.has('Contract Owner')">{{
									errors.first('Contract Owner')
								}}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Contract Co-Owner/PMO</label>
								<v-select
									v-model="saveAmandement.co_owner"
									:options="listUser"
									label="fullname"
									placeholder="Co-Owner/PMO"
									:reduce="(e) => e.id"
									name="Contract Co-Owner/PMO"
									disabled
								/>

								<!-- <v-select v-model="saveAmandement.co_owner" :options="listUser" label="fullname"
              :reduce="(e) => e.id" name="Contract Co-Owner/PMO" disabled @search="coOwnerSearch"/> -->
								<span class="text-sm text-danger" v-show="errors.has('Contract Co-Owner/PMO')">{{
									errors.first('Contract Co-Owner/PMO')
								}}</span>
							</div>
						</div>

						<div class="col-lg-6">
							<!-- <div class="form-group">
                <label>Contract Value<span class="text-danger"
                    v-if="!isScopeNotSelected('contract_value')">*</span></label>
                <input type="text" class="form-control" name="Contract Value" 
                  v-validate="!isScopeNotSelected('contract_value') ? 'required' : ''"
                  @input="formatIDRAmandement" @keypress="isNumber($event)"
                  v-model="formattedContractValueAmandement" :disabled="isScopeNotSelected('contract_value')" />
                <span class="text-sm text-danger"
                  v-show="errors.has('Contract Value')">{{ errors.first("Contract Value") }}</span>
              </div> -->
							<div class="form-group">
								<label>Contract Value<span class="text-danger">*</span></label>
								<div class="input-group">
									<div class="input-with-prefix">
										<span class="prefix">Rp</span>
										<input
											type="text"
											class="form-control with-prefix"
											v-validate="'required'"
											name="Contract Value"
											placeholder="Contract Value"
											v-model="formattedContractValueAmandement"
											@keypress="isNumber($event, 'amandement')"
											@input="changeContractValue($event, 'amandement')"
											:disabled="isScopeNotSelected('contract_value')"
										/>
									</div>
								</div>
								<span class="text-sm text-danger" v-show="errors.has('Contract Value')">{{
									errors.first('Contract Value')
								}}</span>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group">
								<label>Scope of Work<span class="text-danger" v-if="!isScopeNotSelected('scope_of_work')">*</span></label>
								<input
									type="text"
									class="form-control"
									name="Scope of Work"
									v-model="saveAmandement.scope_of_work"
									v-validate="!isScopeNotSelected('scope_of_work') ? 'required' : ''"
									maxlength="1000"
									@input="checkLengthValue(saveAmandement.scope_of_work)"
									:disabled="isScopeNotSelected('scope_of_work')"
								/>
								<span class="text-sm text-danger" v-show="errors.has('Scope of Work')">{{
									errors.first('Scope of Work')
								}}</span>
							</div>
						</div>
					</div>
					<div class="row mt-5">
						<h3>Supporting File</h3>
						<div class="col-lg-4">
							<div class="form-group">
								<label>ToR (Max. 10Mb)</label>
								<input
									type="file"
									class="form-control"
									accept=".pdf"
									@change="amandemenSetFileTor"
									ref="amandement_files_tor"
								/>
								<a
									:href="detailContract?.upload_tor?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_tor?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('ToR')">{{ errors.first('ToR') }}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>BoQ (Max. 10Mb)</label>
								<input
									type="file"
									class="form-control"
									accept=".pdf"
									@change="amandemenSetFileBoq"
									ref="amandement_files_boq"
								/>
								<a
									:href="detailContract?.upload_boq?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_boq?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('BoQ')">{{ errors.first('BoQ') }}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>NoA/SPP (Max. 10Mb)</label>
								<input
									type="file"
									class="form-control"
									accept=".pdf"
									@change="amandemenSetFileNoa"
									ref="amandement_files_noa_spp"
								/>
								<a
									:href="detailContract?.upload_noa_spp?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_noa_spp?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('NoA/SPP')">{{ errors.first('NoA/SPP') }}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>OE (Max. 10Mb)</label>
								<input type="file" class="form-control" accept=".pdf" @change="amandemenSetFileOe" ref="amandement_files_oe" />
								<a
									:href="detailContract?.upload_oe?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_oe?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('OE')">{{ errors.first('OE') }}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>Contract Fully Signed (Max. 10Mb)</label>
								<input type="file" class="form-control" accept=".pdf" @change="amandemenSetFileFs" ref="amandement_files_fs" />
								<a
									:href="detailContract?.upload_fs?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_fs?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('Contract Fully Signed')">{{
									errors.first('Contract Fully Signed')
								}}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>BAPP (Max. 10Mb)</label>
								<input
									type="file"
									class="form-control"
									accept=".pdf"
									@change="amandemenSetFileBapp"
									ref="amandement_files_bapp"
								/>
								<a
									:href="detailContract?.upload_bapp?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.upload_bapp?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('BAPP')">{{ errors.first('BAPP') }}</span>
							</div>
						</div>
						<div class="col-lg-4">
							<div class="form-group">
								<label>Others (Max. 10Mb)</label>
								<input type="file" class="form-control" accept=".pdf" @change="amandemenSetFileOthers" ref="amandement_files" />
								<a
									:href="detailContract?.files?.[0]?.file"
									class="text-info"
									target="_blank"
									v-show="detailContract?.files?.[0]?.file"
									>Click to view</a
								>
								<span class="text-sm text-danger" v-show="errors.has('Others')">{{ errors.first('Others') }}</span>
							</div>
						</div>
					</div>

					<div class="row g-3 mt-2 mb-5">
						<label class="font-weight-bold"
							>Contract Duration <span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span></label
						>
						<div class="form-group col">
							<label>Start Date <span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span></label>
							<input
								type="date"
								v-model="saveAmandement.start_date"
								class="form-control"
								placeholder="Start Date"
								v-validate="!isScopeNotSelected('contract_duration') ? 'required' : ''"
								name="Start Date"
								:disabled="isScopeNotSelected('contract_duration')"
							/>
							<span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first('Start Date') }}</span>
						</div>
						<div class="form-group col">
							<label>End Date <span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span></label>
							<input
								type="date"
								v-model="saveAmandement.end_date"
								class="form-control"
								placeholder="End Date"
								v-validate="!isScopeNotSelected('contract_duration') ? 'required' : ''"
								:min="endMin(saveAmandement.start_date)"
								name="End Date"
								:disabled="isScopeNotSelected('contract_duration')"
								@change="getTotalDuration(`amandement`, saveAmandement.start_date, saveAmandement.end_date)"
							/>
							<span class="text-sm text-danger" v-show="errors.has('End Date')">{{ errors.first('End Date') }}</span>
						</div>
						<div class="form-group col">
							<label>Total Duration (Month)</label>
							<input type="text" v-model="saveAmandement.total_duration" class="form-control" disabled />
							<span class="text-sm text-danger" v-show="errors.has('Total Duration')">{{
								errors.first('Total Duration')
							}}</span>
						</div>
					</div>
					<div class="card">
						<div class="card-header">
							<h4 class="card-header-title">
								Contract Duration Detail<span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span>
							</h4>
							<a
								href="#!"
								class="btn btn-sm btn-primary"
								@click="addDurationDetailAmandement"
								:class="{ disabled: isScopeNotSelected('contract_duration') }"
							>
								Add
							</a>
						</div>
						<div v-if="amandementDetail" class="card-body">
							<div v-for="(item, index) in saveAmandement.contract_duration_detail.details" :key="index">
								<hr v-if="index > 0" class="my-3" />
								<div class="row">
									<div class="form-group col-10">
										<label
											>Detail Name {{ index + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span></label
										>
										<input
											type="text"
											class="form-control"
											v-model="item.detail_name"
											v-validate="!isScopeNotSelected('contract_duration') ? 'required|max:1000' : ''"
											:placeholder="`Contract Detail ${index + 1}`"
											:name="`Contract Detail ${index}`"
											:disabled="isScopeNotSelected('contract_duration')"
											@input="checkLengthValue(item.detail_name)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Contract Detail ${index}`)">{{
											errors.first(`Contract Detail ${index}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="addDurationDetailItemsAmandement(index)"
											:class="{ disabled: isScopeNotSelected('contract_duration') }"
											>Add</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="removeDurationDetailAmandement(index)"
											:class="{ disabled: isScopeNotSelected('contract_duration') }"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
								<div class="row" v-for="(dtas, itmIndex) in item.items" :key="itmIndex">
									<div class="form-group col-4">
										<label
											>Item Name {{ itmIndex + 1 }}
											<span class="text-danger" v-if="!isScopeNotSelected('contract_duration')">*</span></label
										>
										<input
											type="text"
											class="form-control"
											v-model="dtas.item_name"
											v-validate="'required|max:1000'"
											:name="`Item Name ${itmIndex + 1}`"
											@input="checkLengthValue(dtas.item_name)"
											:disabled="isScopeNotSelected('contract_duration')"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Item Name ${itmIndex + 1}`)">{{
											errors.first(`Item Name ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="form-group col-3">
										<label
											>Work Duration (Month) {{ itmIndex + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('')">*</span></label
										>
										<input
											type="number"
											class="form-control disabled"
											v-model="dtas.work_duration"
											:name="`Work Duration ${itmIndex + 1}`"
											:disabled="isScopeNotSelected('contract_duration')"
										/>
										<span class="text-sm text-danger" v-if="isExceedingLimitAmandement">
											Total work duration exceeds the allowed
											{{ saveAmandement.total_duration }} months!
										</span>
									</div>
									<div class="form-group col-4">
										<label>Description {{ itmIndex + 1 }}</label>
										<input
											type="text"
											class="form-control"
											v-model="dtas.description"
											:name="`Description ${itmIndex + 1}`"
											@input="checkLengthValue(dtas.description)"
											:disabled="isScopeNotSelected('contract_duration')"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
											errors.first(`Description ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											:class="{ disabled: isScopeNotSelected('contract_duration') }"
											@click="removeDurationDetailItemsAmandement(index, itmIndex)"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
							</div>
							<!-- <div>dbasmndasbdmn</div> -->
						</div>
					</div>
					<div class="form-group">
						<button
							type="button"
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-primary mr-3"
							@click="tabIndex++"
						>
							Next
						</button>
					</div>
				</b-tab>
				<b-tab title="Term of Payment">
					<!-- Fixed Assignment Amandement -->
					<div class="card">
						<div class="card-header">
							<h4 class="card-header-title">Fixed Assignment</h4>
							<a
								href="#!"
								class="btn btn-sm btn-primary"
								@click="addFixedAssigmentAmandement"
								:class="{ disabled: isScopeNotSelected('term_of_payment') }"
							>
								Add
							</a>
						</div>
						<div class="card-body">
							<div v-if="saveAmandement.term_of_payments.fixed_assignment.contract_items.length > 0" class="row mb-3">
								<div class="col-6">Fixed Assigment</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Percentage<span class="text-danger">*</span></label>
									<input
										v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
										type="number"
										class="form-control"
										v-model="saveAmandement.term_of_payments.fixed_assignment.percentage"
										:placeholder="`Percentage`"
										@keypress="isPercent($event, 'amandement')"
										@input="calculateAmountFromPercent('fixed_assignment', 'amandement')"
										:disabled="isScopeNotSelected('term_of_payment')"
									/>
								</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Amount<span class="text-danger">*</span></label>
									<input
										v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
										type="text"
										class="form-control"
										v-model="formattedFixedAmountAmandement"
										:placeholder="`Amount`"
										@keypress="isNumber($event, 'amandement')"
										@input="calculatePercentFromAmount('fixed_assignment', 'amandement')"
										:disabled="isScopeNotSelected('term_of_payment')"
									/>
								</div>
							</div>
							<div v-for="(item, index) in saveAmandement.term_of_payments.fixed_assignment.contract_items" :key="index">
								<hr v-if="index > 0" class="my-3" />
								<div class="row">
									<div class="form-group col-5">
										<label
											>Contract Item {{ index + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="text"
											v-model="item.contract_item"
											class="form-control"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Contract Item ${index + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(item.contract_item)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Contract Item ${index + 1}`)">{{
											errors.first(`Contract Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label>Percentage Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="item.percentage_item"
											class="form-control"
											:placeholder="`Percentage Item ${index + 1}`"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Fixed Assignment Percentage Item ${index + 1}`"
											@keypress="isPercent($event, 'amandement')"
											@input="calculateAmountFromPercentage(index, 'fixed_assignment', 'amandement')"
											:disabled="
												isScopeNotSelected('term_of_payment') ||
												!saveAmandement.term_of_payments.fixed_assignment.amount ||
												saveAmandement.term_of_payments.fixed_assignment.amount <= 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Fixed Assignment Percentage Item ${index + 1}`)">{{
											errors.first(`Fixed Assignment Percentage Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-3">
										<label>Amount Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.amount_item"
											class="form-control"
											:placeholder="`Amount Item ${index + 1}`"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Fixed Assignment Amount Item ${index + 1}`"
											@keypress="isNumber($event, 'amandement')"
											@input="calculatePercentageFromAmount(index, 'fixed_assignment', 'amandement')"
											:disabled="
												isScopeNotSelected('term_of_payment') ||
												!saveAmandement.term_of_payments.fixed_assignment.amount ||
												saveAmandement.term_of_payments.fixed_assignment.amount <= 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Fixed Assignment Amount Item ${index + 1}`)">{{
											errors.first(`Fixed Assignment Amount Item ${index + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="addFixedAssigmentAmandementItems(index)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											>Add</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="removeFixedAssigmentAmandement(index)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
								<div class="row" v-for="(dts, itmIndex) in item.terms" :key="itmIndex">
									<div class="form-group col-3">
										<label
											>Term {{ itmIndex + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="text"
											class="form-control"
											v-model="dts.term"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Term ${itmIndex + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(dts.term)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Term ${itmIndex + 1}`)">{{
											errors.first(`Term ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label
											>Percentage {{ itmIndex + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="number"
											v-model="dts.percentage"
											class="form-control"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`FA Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isPercent($event, 'amandement')"
											@input="
												calculateTermAmountFromPercentage(index, itmIndex, item.contract_item, 'fixed_assignment', 'amandement')
											"
											:disabled="isScopeNotSelected('term_of_payment')"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`FA Percentage ${itmIndex + 1}`)">{{
											errors.first(`FA Percentage ${itmIndex + 1}`)
										}}</span>
									</div>

									<div class="form-group col-2">
										<label>Amount {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="dts.amount"
											class="form-control"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:placeholder="`Amount ${itmIndex + 1}`"
											:name="`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isNumber($event, 'amandement')"
											@input="
												calculateTermPercentageFromAmount(index, itmIndex, item.contract_item, 'fixed_assignment', 'amandement')
											"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`FA Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>

									<!-- Add Description Fixed Assignment -->
									<div class="form-group col-3">
										<label>Description {{ itmIndex + 1 }}</label>
										<input
											type="text"
											v-model="dts.description"
											class="form-control"
											maxlength="1000"
											:name="`Description ${itmIndex + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(dts.description)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
											errors.first(`Description ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											@click="addFixedAssigmentAmandementItemsDetail(index, itmIndex)"
										>
											<span class="fe fe-plus"></span>Detail
										</a>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="removeFixedAssigmentAmandementItems(index, itmIndex)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											><span class="fe fe-trash"></span
										></a>
									</div>
									<div class="row" v-for="(detail, detailIndex) in dts.details" :key="detailIndex">
										<div class="form-group col-lg-11">
											<label>Detail {{ detailIndex + 1 }}</label>
											<textarea
												class="form-control"
												v-model="dts.details[detailIndex]"
												:disabled="isScopeNotSelected('term_of_payment')"
												maxlength="1000"
											></textarea>
											<!-- <span class="text-sm text-danger"
                          v-show="errors.has(`Detail ${itmIndex+1}_${detailIndex+1}`)">{{ errors.first(`Detail ${itmIndex+1}_${detailIndex+1}`) }}</span> -->
											<small
												class="form-text"
												:class="{
													'text-danger': dts.details[detailIndex] && dts.details[detailIndex].length >= 1000,
												}"
											>
												{{ dts.details[detailIndex] ? dts.details[detailIndex].length : 0 }}/1000 characters
												<span v-if="dts.details[detailIndex] && dts.details[detailIndex].length >= 1000" class="text-danger">
													Character limit reached
												</span>
											</small>
										</div>
										<div class="col-lg-1 d-flex align-items-center">
											<a
												href="#!"
												class="btn btn-sm btn-primary"
												@click="removeFixedAssigmentAmandementItemsDetail(index, itmIndex, detailIndex)"
												:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											>
												<span class="fe fe-trash"></span>
											</a>
										</div>
									</div>
								</div>

								<!-- <div class="row g-3 text-right">
                  <div class="col"></div>
                  <div class="col-2 align-self-center">
                    <label class="text-center">Total Percentage %</label>
                  </div>
                  <div class="col-3">
                    <input type="text" v-model="item.total_percentage" class="form-control" placeholder="Percentage"
                      :disabled="isScopeNotSelected('term_of_payment')" />
                    <span class="text-sm text-danger"
                      v-show="errors.has(`Total Percentage ${index+1}`)">{{ errors.first(`Total Percentage ${index+1}`) }}</span>
                  </div>
                  <div class="col-1"></div>
                </div> -->
							</div>
							<!-- <div>dbasmndasbdmn</div> -->
						</div>
					</div>
					<!-- Provision -->
					<div class="card mt-5">
						<div class="card-header">
							<h4 class="card-header-title">Provision</h4>
							<a
								href="#!"
								class="btn btn-sm btn-primary"
								@click="addProvisionAmandement"
								:class="{ disabled: isScopeNotSelected('term_of_payment') }"
							>
								Add
							</a>
						</div>
						<div class="card-body">
							<div v-if="saveAmandement.term_of_payments.provision.contract_items.length > 0" class="row mb-3">
								<div class="col-6">Provision</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Percentage<span class="text-danger">*</span></label>
									<input
										v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
										type="number"
										class="form-control"
										v-model="saveAmandement.term_of_payments.provision.percentage"
										:placeholder="`Percentage`"
										@keypress="isPercent($event, 'amandement')"
										@input="calculateAmountFromPercent('provision', 'amandement')"
										:disabled="isScopeNotSelected('term_of_payment')"
									/>
								</div>
								<div class="form-group col-3 d-flex align-items-center">
									<label class="text-center mr-2">Amount<span class="text-danger">*</span></label>
									<input
										v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
										type="text"
										class="form-control"
										v-model="formattedProvisionAmountAmandement"
										:placeholder="`Amount`"
										@keypress="isNumber($event, 'amandement')"
										@input="calculatePercentFromAmount('provision', 'amandement')"
										:disabled="isScopeNotSelected('term_of_payment')"
									/>
								</div>
							</div>
							<div v-for="(item, index) in saveAmandement.term_of_payments.provision.contract_items" :key="index">
								<hr v-if="index > 0" class="my-3" />
								<div class="row">
									<div class="form-group col-5">
										<label
											>Contract Item {{ index + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="text"
											v-model="item.contract_item"
											class="form-control"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Contract Item ${index + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(item.contract_item)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Contract Item ${index + 1}`)">{{
											errors.first(`Contract Item ${index + 1}`)
										}}</span>
									</div>

									<div class="form-group col-2">
										<label>Percentage Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="number"
											v-model="item.percentage_item"
											class="form-control"
											:placeholder="`Percentage Item ${index + 1}`"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Provision Percentage Item ${index + 1}`"
											@keypress="isPercent($event, 'amandement')"
											@input="calculateAmountFromPercentage(index, 'provision', 'amandement')"
											:disabled="
												isScopeNotSelected('term_of_payment') ||
												!saveAmandement.term_of_payments.provision.amount ||
												saveAmandement.term_of_payments.provision.amount <= 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Provision Percentage Item ${index + 1}`)">{{
											errors.first(`Provision Percentage Item ${index + 1}`)
										}}</span>
									</div>
									<div class="form-group col-3">
										<label>Amount Item {{ index + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="item.amount_item"
											class="form-control"
											:placeholder="`Amount Item ${index + 1}`"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Provision Amount Item ${index + 1}`"
											@keypress="isNumber($event, 'amandement')"
											@input="calculatePercentageFromAmount(index, 'provision', 'amandement')"
											:disabled="
												isScopeNotSelected('term_of_payment') ||
												!saveAmandement.term_of_payments.provision.amount ||
												saveAmandement.term_of_payments.provision.amount <= 0
											"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Provision Amount Item ${index + 1}`)">{{
											errors.first(`Provision Amount Item ${index + 1}`)
										}}</span>
									</div>

									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="addProvisionAmandementItems(index)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											>Add</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="removeProvisionAmandement(index)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											><span class="fe fe-trash"></span
										></a>
									</div>
								</div>
								<div class="row" v-for="(dts, itmIndex) in item.terms" :key="itmIndex">
									<div class="form-group col-3">
										<label
											>Term {{ itmIndex + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="text"
											class="form-control"
											v-model="dts.term"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Term ${itmIndex + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(dts.term)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Term ${itmIndex + 1}`)">{{
											errors.first(`Term ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="form-group col-2">
										<label
											>Percentage {{ itmIndex + 1
											}}<span class="text-danger" v-if="!isScopeNotSelected('term_of_payment')">*</span></label
										>
										<input
											type="number"
											v-model="dts.percentage"
											class="form-control"
											@keypress="isPercent($event, 'amandement')"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:name="`Percentage ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@input="calculateTermAmountFromPercentage(index, itmIndex, item.contract_item, 'provision', 'amandement')"
											:disabled="isScopeNotSelected('term_of_payment')"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Percentage ${itmIndex + 1}`)">{{
											errors.first(`Percentage ${itmIndex + 1}`)
										}}</span>
									</div>

									<div class="form-group col-2">
										<label>Amount {{ itmIndex + 1 }}<span class="text-danger">*</span></label>
										<input
											type="text"
											v-model="dts.amount"
											class="form-control"
											v-validate="!isScopeNotSelected('term_of_payment') ? 'required' : ''"
											:placeholder="`Amount ${itmIndex + 1}`"
											:name="`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`"
											@keypress="isNumber($event, 'amandement')"
											@input="calculateTermPercentageFromAmount(index, itmIndex, item.contract_item, 'provision', 'amandement')"
										/>
										<!-- ISSUE PERCENT -->
										<span
											class="text-sm text-danger"
											v-show="errors.has(`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`)"
											>{{ errors.first(`Amount ${item.contract_item || 'item' + index + 1} ${itmIndex + 1}`) }}</span
										>
									</div>
									<!-- Add Description Provision -->
									<div class="form-group col-3">
										<label>Description {{ itmIndex + 1 }}</label>
										<input
											type="text"
											v-model="dts.description"
											class="form-control"
											maxlength="1000"
											:name="`Description ${itmIndex + 1}`"
											:disabled="isScopeNotSelected('term_of_payment')"
											@input="checkLengthValue(dts.description)"
										/>
										<span class="text-sm text-danger" v-show="errors.has(`Description ${itmIndex + 1}`)">{{
											errors.first(`Description ${itmIndex + 1}`)
										}}</span>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="addProvisionAmandementItemsDetail(index, itmIndex)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											><span class="fe fe-plus"></span>Detail</a
										>
									</div>
									<div class="col-lg-1 d-flex align-items-center">
										<a
											href="#!"
											class="btn btn-sm btn-primary"
											@click="removeProvisionAmandementItems(index, itmIndex)"
											:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											><span class="fe fe-trash"></span
										></a>
									</div>
									<div class="row" v-for="(detail, detailIndex) in dts.details" :key="detailIndex">
										<div class="form-group col-lg-11">
											<label>Detail {{ detailIndex + 1 }}</label>
											<textarea
												class="form-control"
												v-model="dts.details[detailIndex]"
												:disabled="isScopeNotSelected('term_of_payment')"
												maxlength="1000"
											></textarea>
											<!-- <span class="text-sm text-danger"
                          v-show="errors.has(`Detail ${itmIndex+1}_${detailIndex+1}`)">{{ errors.first(`Detail ${itmIndex+1}_${detailIndex+1}`) }}</span> -->
											<small
												class="form-text"
												:class="{
													'text-danger': dts.details[detailIndex] && dts.details[detailIndex].length >= 1000,
												}"
											>
												{{ dts.details[detailIndex] ? dts.details[detailIndex].length : 0 }}/1000 characters
												<span v-if="dts.details[detailIndex] && dts.details[detailIndex].length >= 1000" class="text-danger">
													Character limit reached
												</span>
											</small>
										</div>
										<div class="col-lg-1 d-flex align-items-center">
											<a
												href="#!"
												class="btn btn-sm btn-primary"
												@click="removeProvisionAmandementItemsDetail(index, itmIndex, detailIndex)"
												:class="{ disabled: isScopeNotSelected('term_of_payment') }"
											>
												<span class="fe fe-trash"></span>
											</a>
										</div>
									</div>
								</div>

								<!-- <div class="row g-3 text-right">
                  <div class="col"></div>
                  <div class="col-2 align-self-center">
                    <label class="text-center">Total Percentage %</label>
                  </div>
                  <div class="col-3">
                    <input type="text" v-model="item.total_percentage" class="form-control" placeholder="Percentage"
                      :disabled="isScopeNotSelected('term_of_payment')" />
                    <span class="text-sm text-danger"
                      v-show="errors.has(`Total Percentage ${index+1}`)">{{ errors.first(`Total Percentage ${index+1}`) }}</span>
                  </div>
                  <div class="col-1"></div>
                </div> -->
							</div>
							<!-- <div>dbasmndasbdmn</div> -->
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<div class="row">
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Fixed Assignment</label>
										<p>{{ totalFixedPercentageAmandement }}%</p>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Provision</label>
										<p>{{ totalProvisionPercentageAmandement }}%</p>
									</div>
								</div>
								<div class="col-lg-4">
									<div class="form-group">
										<label class="font-weight-bold">Total Percentage</label>
										<p>{{ totalOverallPercentageAmandement }}%</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<div>
							<button
								style="margin-left: 10px; float: right"
								class="mt-4 btn btn-primary"
								type="button"
								@click="saveRenewalAmandement"
								v-if="!isLoading"
							>
								Amendment
							</button>
							<button
								style="margin-left: auto; float: right"
								class="mt-4 btn btn-primary"
								type="button"
								disabled
								v-if="isLoading"
							>
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Loading...
							</button>
							<button
								style="margin-left: 10px; float: right"
								class="mt-4 btn btn-outline-primary"
								type="button"
								@click="tabIndex--"
							>
								Back
							</button>
						</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-modal>
		<!-- <b-modal id="modal-notification" size="xl" hide-footer title="Detail Notification" @hide="closeNotification($event)">
              <div class="row g-3">
              <div class="form-group col">
              <label>Notification <span class="text-danger">*</span></label>
              <vue-good-table @on-selected-rows-change="selectionAdd" :columns="columnsNotification" ref="tableNotif"
              :rows="listNotification" :select-options="{
                    enabled: true,
                    disableSelectInfo: true,
                    selectOnCheckboxOnly: true,
                  }" style-class="vgt-table border-0 table">
              <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'action'">
                <b-button @click="detailNotification(props.row)" type="button" class="no-wrap ml-2" variant="info"
                  style="margin-left: 5px" size="sm">
                  <span class="fe fe-eye"></span>
                </b-button>
              </span>
              <span v-else-if="props.column.field == 'email'" class="text-center" style="margin-bottom: 30px">
                <div class="text-center">
                  <input class="form-check-input" type="checkbox" v-model="props.row.email" @change="emailActive = props.row.email" />
                </div>
              </span>
              <span v-else-if="props.column.field == 'whatsapp'" class="text-center" style="margin-bottom: 30px">
                <div class="text-center">
                  <input class="form-check-input" type="checkbox" v-model="props.row.whatsapp" @change="whatsappActive = props.row.whatsapp" />
                </div>
              </span>
              </template>
              </vue-good-table>
              </div>
              </div>
              <div class="card" v-for="(item, index) in modalCreate.notification" :key="index">
              <div class="card-header">
              <h4 class="card-header-title fw-bolder">{{ item.notification_type }}</h4>
              </div>
              <div class="card-body">
              <div class="d-flex align-items-center gap-2">
              <label for="description" class="me-2 mb-0">Description</label>
              <textarea id="description" class="form-control" rows="2" v-model="item.description" disabled></textarea>
              </div>
              <div v-if="item.id == 3 || item.id == 4 || item.id == 5" class="d-flex align-items-center gap-2 mt-2">
              <label for="description" class="me-2 mb-0">Notif Condition</label>
              <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="item.additionalDatas.recurring">
              <label class="form-check-label">Recurring</label>
              </div>
              <div class="form-group col-3">
              <label>Notif At</label>
              <input type="time" class="form-control" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.notif_at" />
              </div>
              <div class="form-group col-3">
              <label>Repeat Every </label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control me-2" style="width: 80%;" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.repeat_every" />
                <span>days</span>
              </div>
              </div>
              <div class="form-group col-4">
              <label>Stop Date</label>
              <input type="date" class="form-control" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.stop_date" />
              </div>
              </div>
              <div v-if="item.id == 10" class="d-flex align-items-center gap-2 mt-2">
              <label for="description" class="me-2 mb-0">Notif Condition</label>
              <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="item.additionalDatas.recurring">
              <label class="form-check-label">Recurring</label>
              </div>
              <div class="form-group col-3">
              <label>Notif At</label>
              <input type="time"class="form-control" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.notif_at" />
              </div>
              <div class="form-group col-3">
              <label>Repeat Every </label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control me-2" style="width: 80%;" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.repeat_every" />
                <span>days</span>
              </div>
              </div>
              <div class="form-group col-4">
              <label>Date before expiration</label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control me-2" style="width: 80%;" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.days_before" />
                <span>days</span>
              </div>
              </div>
              </div>
              <div v-if="item.id == 11" class="d-flex align-items-center gap-2 mt-2">
              <label for="description" class="me-2 mb-0">Notif Condition</label>
              <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="item.additionalDatas.recurring">
              <label class="form-check-label">Recurring</label>
              </div>
              <div class="form-group col-3">
              <label>Notif At</label>
              <input type="time"class="form-control" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.notif_at" />
              </div>
              <div class="form-group col-3">
              <label>Repeat Every </label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control me-2" style="width: 80%;" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.repeat_every" />
                <span>days</span>
              </div>
              </div>
              <div class="form-group col-4">
              <label>Remaining Budget</label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control me-2" style="width: 80%;" min="0" max="100" :disabled="!item.additionalDatas.recurring" v-model="item.additionalDatas.remaining_budget"/>
                <span>%</span>
              </div>
              </div>
              </div>
              <div v-if="item.email" class="d-flex align-items-center gap-2 mt-2">
              <label for="description" class="me-2 mb-0">Email</label>
              <div class="form-group col-6">
              <label>Email CC</label>
              <v-select :options="listUser" label="email" v-model="item.additionalDatas.email_cc_list" multiple :reduce="(e) => e.email"></v-select>
              </div>
              <div class="form-group col-5">
              <label>Email BCC </label>
              <v-select :options="listUser" label="email" v-model="item.additionalDatas.email_bcc_list" multiple :reduce="(e) => e.email"></v-select>
              </div>
              </div>
              <div class="row g-3" v-if="item.whatsapp">
              <div class="col">
              <label>Phone Number</label>
              </div>
              <div class="col text-right">
              <button type="button" class="btn btn-primary mb-3" @click="addNumber(index)">
                <span class="fe fe-plus"></span> Add
              </button>
              </div>
              </div>
              <div v-if="item.whatsapp" class="row g-3" v-for="(items, indexx) in item.additionalDatas.whatsapp_number" :key="indexx">
              <div class="form-group col">
              <label>Additional Number {{ indexx + 1 }}</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">+62</div>
                </div>
                <input type="number" class="form-control" v-model="item.additionalDatas.whatsapp_number[indexx]"
                  v-validate="'numeric|max:13'" name="Additional Number"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 13)" />
                <span class="ml-2 text-sm text-danger" 
                  v-show="errors.has('Additional Number')">{{ errors.first("Additional Number") }}</span>
              </div>
              </div>
              <div class="col-1 text-right mt-4">
              <button type="button" style="margin-left: auto" class="btn btn-primary" @click="removeAddNumber(index, indexx)">
                <span class="fe fe-trash"></span>
              </button>
              </div>
              </div>

              </div>
              </div>
              <div class="col-12 text-right">
              <button style="margin-left: auto; float: right" class="btn btn-primary mt-4" @click="submitNotification"
              v-if="isLoading == false">
              Save
              </button>
              <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
              </button>
              </div>
              </b-modal> -->
	</div>
</template>

<script>
	import debounce from 'lodash/debounce';
	import moment from 'moment';
	import axiosIns from '@/api/axios';
	import tableListContract from '@/components/listContract/tableListContract.vue';
	import { stringify } from 'query-string';
	import list from '@/store/notification/list';
	import contract from '@/store/listContract/contract';
	import { props } from 'vue2-dropzone';
	import { authorize } from '@/utils/authorize';
	import { indonesianCalendar, formatCurrency, onlyNumber } from '@/utils/common';
	import role from '@/store/master/role';
	// import { props } from 'vue2-dropzone';
	export default {
		name: 'listContract',
		components: {
			tableListContract,
		},
		computed: {
			// formattedListMyContract() {
			//   return {
			//     ...this.listMyContract,
			//     data: this.listMyContract?.data?.map(contract => ({
			//       ...contract,
			//       budget_gl: contract.list_budget_gl?.[0]?.budget_gl || '-' // Fallback to '-' if undefined or empty
			//     }))
			//   };
			// },
			formattedContractValue: {
				get() {
					// Format ke IDR saat ditampilkan
					if (!this.saveContract.contract_value) return '';
					return this.saveContract.contract_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
				},
				set(value) {
					// Simpan nilai asli tanpa titik
					this.saveContract.contract_value = value.replace(/\./g, '');
				},
			},
			formattedContractValueAmandement: {
				get() {
					// Format ke IDR saat ditampilkan
					if (!this.saveAmandement.contract_value) return '';
					return this.saveAmandement.contract_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
				},
				set(value) {
					// Simpan nilai asli tanpa titik
					this.saveAmandement.contract_value = value.replace(/\./g, '');
				},
			},
			formattedFixedAmount: {
				get() {
					if (!this.saveContract.term_of_payments.fixed_assignment.amount) return '';
					return formatCurrency(this.saveContract.term_of_payments.fixed_assignment.amount);
				},
				set(value) {
					this.saveContract.term_of_payments.fixed_assignment.amount = this.unformatIDR(value);
				},
			},
			formattedProvisionAmount: {
				get() {
					if (!this.saveContract.term_of_payments.provision.amount) return '';
					return formatCurrency(this.saveContract.term_of_payments.provision.amount);
				},
				set(value) {
					this.saveContract.term_of_payments.provision.amount = this.unformatIDR(value);
				},
			},
			formattedFixedAmountAmandement: {
				get() {
					if (!this.saveAmandement.term_of_payments.fixed_assignment.amount) return '';
					return formatCurrency(this.saveAmandement.term_of_payments.fixed_assignment.amount);
				},
				set(value) {
					this.saveAmandement.term_of_payments.fixed_assignment.amount = this.unformatIDR(value);
				},
			},
			formattedProvisionAmountAmandement: {
				get() {
					if (!this.saveAmandement.term_of_payments.provision.amount) return '';
					return formatCurrency(this.saveAmandement.term_of_payments.provision.amount);
				},
				set(value) {
					this.saveAmandement.term_of_payments.provision.amount = this.unformatIDR(value);
				},
			},
			// isAmountItemExceedingContractValue() {
			//   const totalFixedAssignmentAmount = this.saveContract.term_of_payments.fixed_assignment.reduce((sum, item) => {
			//     return sum + this.unformatIDR(item.amount_item || 0);
			//   }, 0);

			//   const totalProvisionAmount = this.saveContract.term_of_payments.provision.reduce((sum, item) => {
			//     return sum + this.unformatIDR(item.amount_item || 0);
			//   }, 0);

			//   const totalAmount = totalFixedAssignmentAmount + totalProvisionAmount;
			//   const contractValue = this.unformatIDR(this.saveContract.contract_value || 0);

			//   return totalAmount > contractValue;
			// },
			totalFixedPercentage() {
				// return this.saveContract.term_of_payments.fixed_assignment.reduce((sum, item) => {
				//   return sum + Number(item.percentage_item|| 0);
				// }, 0);
				return parseFloat(this.saveContract.term_of_payments.fixed_assignment.percentage) || 0;
			},
			totalProvisionPercentage() {
				// return this.saveContract.term_of_payments.provision.reduce((sum, item) => {
				//   return sum + Number(item.percentage_item || 0);
				// }, 0);
				return parseFloat(this.saveContract.term_of_payments.provision.percentage) || 0;
			},
			totalOverallPercentage() {
				return this.totalFixedPercentage + this.totalProvisionPercentage;
			},
			totalWorkDuration() {
				return this.saveContract.contract_duration_detail.details.reduce((sum, detail) => {
					return sum + detail.items.reduce((itemSum, item) => itemSum + Number(item.work_duration || 0), 0);
				}, 0);
			},
			isExceedingLimit() {
				return false;
				// return this.totalWorkDuration > this.saveContract.total_duration;
			},
			totalWorkDurationAmandement() {
				return this.saveAmandement.contract_duration_detail.details.reduce((sum, detail) => {
					return sum + detail.items.reduce((itemSum, item) => itemSum + Number(item.work_duration || 0), 0);
				}, 0);
			},
			isExceedingLimitAmandement() {
				return false;
				// return (
				// 	this.totalWorkDurationAmandement > this.saveAmandement.total_duration
				// );
			},
			totalFixedPercentageAmandement() {
				// return this.saveAmandement.term_of_payments.fixed_assignment.reduce((sum, item) => {
				//   return s
				return parseFloat(this.saveAmandement.term_of_payments.fixed_assignment.percentage) || 0;
			},
			totalProvisionPercentageAmandement() {
				// return this.saveAmandement.term_of_payments.provision.reduce((sum, item) => {
				//   return sum + item.terms.reduce((subSum, term) => subSum + Number(term.percentage || 0), 0);
				// }, 0);
				return parseFloat(this.saveAmandement.term_of_payments.provision.percentage) || 0;
			},
			totalOverallPercentageAmandement() {
				return this.totalFixedPercentageAmandement + this.totalProvisionPercentageAmandement;
			},
			amandementOptions() {
				return Array.isArray(this.listAmandement)
					? this.listAmandement.map((item) => ({
							amandement: item.amandement,
							name: `Amandement ${item.amandement}`,
					  }))
					: [];
			},
			listVendor() {
				return this.$store.getters['listContract/listVendor'];
			},
			// listPO() {
			//   const processedArr = this.$store.getters["listContract/listpo"].map(element => {
			//     if (element) {
			//       return element;
			//     } else {
			//       return "";
			//     }
			//   })
			//   return processedArr
			// },
			listTypeContract() {
				return this.$store.getters['type_contract/list'];
			},
			listNotification() {
				return this.$store.getters['notification/list']?.data;
			},

			defaultRecipient() {
				// if (this.listNotification.length > 0) {
				// 	if (typeof this.listNotification[0].default_recipient === 'string') {
				// 		return JSON.parse(this.listNotification[0].default_recipient);
				// 	} else {
				// 		return this.listNotification[0].default_recipient;
				// 	}
				// }
				// return [];
				return this.listUser.map((user) => user.email);
			},

			// listNotification() {
			//   const list = this.$store.getters["notification/list"].data;

			//   const modifiedList = list.map(item => ({
			//     ...item,
			//     additionalDatas: {
			//       ...{
			//         timezone: moment().format('Z'),
			//         email_cc: false,
			//         email_cc_list: [],
			//         email_bcc: false,
			//         email_bcc_list: [],
			//         whatsapp: false,
			//         whatsapp_number: [],
			//         start_date: "",
			//         end_date: "",
			//         stop_date: "",
			//         recurring: false,
			//         notif_at: "",
			//         repeat_every: null,
			//         days_before: null,
			//         remaining_budget: null,
			//       },
			//       notification_id: item.id // dynamically set from current object
			//     }
			//   }));
			//   console.log(modifiedList);

			//   return modifiedList
			// },
			ListBudgetPlan() {
				const listBudgetPlan = this.$store.getters['listContract/listBudgetPlan'] || [];
				return listBudgetPlan.filter((item) => item.fund_center?.fund_center == this.selectedDepartment?.code);
			},
			ListBudgetGL() {
				let data = this.$store.getters['listContract/listBudgetGL'];
				const processedArr = data.map((element) => {
					return {
						id: element.id,
						label: `${element.type} - ${element.gl_code} - ${element.name}`,
					};
				});
				// console.log("ListBudgetGL", processedArr);

				return processedArr;
			},
			ListBudgetTask() {
				return this.$store.getters['listContract/listBudgetTask'];
			},
			ListBudgetTaskDetail() {
				return this.$store.getters['listContract/listBudgetTaskDetail'];
			},
			profile() {
				return this.$store.getters['profile/profileData'];
			},
			notificationRecipientEmails() {
				return [
					...new Set([
						...this.modalNotification.email_cc,
						...this.modalNotification.email_bcc,
						...this.modalNotification.email_external,
					]),
				];
			},
			orderedOaNumber() {
				return this.saveContract.oa_number.sort((a, b) => b.no - a.no);
			},
			listDepartments() {
				const loggedUser = this.$store.getters['profile/profileData'];
				return loggedUser.departments;
			},
			selectedDepartmentContractId: {
				get() {
					return this.saveContract.department_id;
				},
				set(value) {
					console.log('contract department changed', this.saveContract.department_id, value);
					return value;
				},
			},
		},
		watch: {
			isEmptyContractItems(newVal) {},
			isAmountItemExceedingContractValue(newVal) {
				if (newVal) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total amount item exceeds the contract value',
						});
				}
			},
			totalOverallPercentage(newVal) {
				if (newVal > 100) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total Percentage cannot exceed 100%',
						});
					// this.resetLastEnteredPercentage();
					// this.adjustLastEnteredPercentageContract();
				}
			},
			totalOverallPercentageAmandement(newVal) {
				if (newVal > 100) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total Percentage cannot exceed 100%',
						});
					// this.resetLastEnteredPercentageAmandement();
					this.adjustLastEnteredPercentageAmandement();
				}
			},
			selectedScopeRenewal(newVal) {
				// Reset semua nilai menjadi false
				Object.keys(this.scopeOfRenewalContractStatus).forEach((key) => {
					this.scopeOfRenewalContractStatus[key] = false;
				});

				// Set nilai yang dipilih menjadi true
				newVal.forEach((value) => {
					if (this.scopeOfRenewalContractStatus.hasOwnProperty(value)) {
						this.scopeOfRenewalContractStatus[value] = true;
					}
				});
			},
			ListBudgetTaskDetail(newVal) {
				this.unsaveListBudgetTaskGL = newVal;
				// this.saveContract.budget_gl = newVal[0].budget_gl;
			},
			ListBudgetPlan: {
				immediate: true,
				handler() {
					// this.setActiveBudgetPlan();
					this.setYear();
				},
			},
			'saveContract.department_id': {
				immediate: true,
				handler() {
					console.log('saveContract.department_id', this.saveContract.department_id);
				},
			},
			'saveContract.email_cc': {
				handler() {
					console.log('saveContract.email_cc', this.saveContract.email_cc);
				},
			},
		},
		data() {
			return {
				emailActive: false,
				typeEdit: '',
				indexOA: '',
				isAmandement: false,
				oaNumberedit: {
					no: '',
					oa_number: '',
				},
				whatsappActive: false,
				detailContract: {},
				latestStatus: '',
				remainingBudgets: null,
				contractId: null,
				oaNumber: '',
				listAmandement: {},
				amandementDetail: {},
				selectedAmandemenType: null,
				selectedScopeRenewal: [],
				list_co_owner: [],
				list_owner: [],
				filesName: {
					tor: '',
				},
				scopeOfRenewalContractStatus: {
					scope_of_work: false,
					contract_value: false,
					contract_duration: false,
					term_of_payment: false,
					oa_number: false,
				},
				body: {
					page: 1,
					pageSize: 10,
					type: '',
					order: 'desc',
					search: '',
					department_id: '',
				},
				listBudgetTaskGL: [],
				unsaveListBudgetTaskGL: [],
				tabIndex: 0,
				direct: 'MyContract',
				breadcrumb: 'All Contracts',
				isAdd: true,
				load: true,
				isLoading: false,
				percentage: 0,
				whatsapp_number: [8128384874221],
				email_cc: [],
				email_bcc: [],
				detailNotif: {},
				files: '',
				search: '',
				pageSize: 10,
				role_id: '',
				user_department: '',
				modalCreate: {
					no: '',
					name: '',
					type_contract: '',
					contract: '',
					budget: '',
					remaining_budget: '',
					files: [],
					vendor: [],
					po_number: [],
					contract_owner: [],
					start_date: '',
					end_date: '',
					scope_of_work: '',
					term_of_payments: [
						{
							term: '',
							percentage: '',
						},
					],
					notification: [],
					email_cc: [],
					email_bcc: [],
					whatsapp_number: [],
					email_external: [],
					email_external: [],
				},
				modalUpdate: {
					id: '',
					no: '',
					name: '',
					type_contract: '',
					contract: '',
					budget: '',
					remaining_budget: '',
					vendor: [],
					po_number: [],
					contract_owner: [],
					files: [],
					start_date: '',
					end_date: '',
					scope_of_work: '',
					term_of_payments: [
						{
							term: '',
							percentage: '',
						},
					],
					notification: [],
					email_cc: [],
					email_bcc: [],
					whatsapp_number: [],
					email_external: [],
				},
				modalNotification: {
					notification: [],
					email_cc: [],
					email_bcc: [],
					whatsapp_number: [],
					email_external: [],
				},
				columnsMyContract: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					//  {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Contract Owner",
					//   field: "contract_owner_nik",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsOnGoing: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsDraft: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsClosed: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					//  {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Closed At',
						field: 'closed_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsEarlyTermination: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					//  {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Terminated At',
						field: 'terminated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsExpiredSoon: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					//  {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Expired At',
						field: 'expired_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40  text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsExpired: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					//  {
					//   label: "Contract Value",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Budget Task",
					//   field: "name",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					//   label: "Scope Of Work",
					//   field: "scope_of_work",
					//   thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
					//   tdClass: "no-wrap color-secondary align-middle",
					// },
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Expired At',
						field: 'expired_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40  text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsValueWarning: [
					{
						label: 'Contract No',
						field: 'no',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Contract Value',
						field: (field) => `Rp. ${formatCurrency(field?.contract_value)}`,
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Remaining Budget',
						field: (field) => `Rp. ${formatCurrency(field?.remaining_budget)}`,
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Budget GL',
						field: 'budget_gl',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					// 	label: 'Budget Task',
					// 	field: 'name',
					// 	thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					// 	tdClass: 'no-wrap color-secondary align-middle',
					// },
					{
						label: 'Status',
						field: 'status',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Scope Of Work',
						field: 'scope_of_work',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Amendment',
						field: 'amandement',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Updated At',
						field: 'updated_at',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				columnsNotification: [
					{
						label: 'Notification Type',
						field: 'notification_type',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Email Subject',
						field: 'subject',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Email',
						field: 'email',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'WhatsApp',
						field: 'whatsapp',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					// {
					// 	label: 'Action',
					// 	field: 'action',
					// 	thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
					// 	tdClass: 'no-wrap color-secondary align-middle',
					// },
				],
				columnsBudgetGL: [
					{
						label: 'Budget Plan',
						field: 'budget_plan_title',
					},
					{
						label: 'Budget GL',
						field: 'budget_gl',
					},
					{
						label: 'Budget Task',
						field: 'budget_task_name',
					},
					{
						label: 'Remaining Budget',
						field: 'remaining_budget',
					},
					{
						label: 'Action',
						field: 'action',
						sortable: false,
					},
				],
				columnsBudgetGLAmandement: [
					{
						label: 'Budget Plan',
						field: 'budget_plan_title',
					},
					{
						label: 'Budget GL',
						field: 'budget_gl',
					},
					{
						label: 'Budget Task',
						field: 'budget_task_name',
					},
					{
						label: 'Remaining Budget',
						field: 'remaining_budget',
					},
				],
				columnsOA: [
					{
						label: 'No',
						field: 'no',
						width: '120px',
						thClass: 'text-center',
						tdClass: 'text-center',
						sortable: false,
					},
					{
						label: 'OA Number',
						field: 'oa_number',
						sortable: false,
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'text-center',
						sortable: false,
					},
				],
				columnsListPR: [
					{
						label: 'Budget GL',
						field: 'budget_gl',
						width: '350px',
					},
					{
						label: 'Budget Task',
						field: 'budget_task',
						width: '300px',
					},
					{
						label: 'PR Number',
						field: 'pr_number',
						width: '150px',
					},
					{
						label: 'PR Name',
						field: 'pr_name',
						width: '300px',
					},
					{
						label: 'PR Date',
						field: 'pr_date',
						width: '150px',
					},
					{
						label: 'PO Number',
						field: 'po_number',
						width: '150px',
					},
					{
						label: 'PO Date',
						field: 'po_date',
						width: '150px',
					},
					{
						label: 'Total DPP',
						field: 'total_dpp',
						width: '150px',
					},
					{
						label: 'Action',
						field: 'action',
						sortable: false,
					},
				],
				dummys: [
					{
						budget_plan: '2025 Digitech',
						budget_gl: '6480100 - 05.01 - Professional Fee',
						budget_task: 'Development Manage Service',
						remaining_budget: 'Rp. 52.900.200',
						oa_number: '1234567890',
					},
				],
				dummys2: [
					{
						budget_gl: '6480100 - 05.01 - Professional Fee',
						budget_task: 'Development Manage Service',
						pr_number: '00000000000',
						pr_name: 'PR Name 1',
						pr_date: '14-12-2024',
						po_number: '00000000000',
						po_date: '14-12-2025',
						total_dpp: 'Rp. 5.050.421',
					},
				],
				editGL: {
					index: '',
					budget_plan_id: '',
					budget_gl_id: '',
					budget_task_id: '',
					remaining_budget: '',
					fulldata: {},
				},
				saveContract: {
					no: '',
					name: '',
					department_id: '',
					type_contract: '',
					contract: 'New Contract',
					contract_owner: '',
					contract_owner_department: '',
					budget: '',
					remaining_budget: '',
					vendor: '',
					start_date: '',
					end_date: '',
					scope_of_work: '',
					list_budget_gl: [],
					term_of_payments: {
						fixed_assignment: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
						provision: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
					},
					list_budget_task: [],
					po_number: '',
					total_duration: 0,
					budget_plan: '',
					budget_task: '',
					contract_co_owner: '',
					contract_co_owner_department: '',
					contract_value: 0,
					oa_number: [],
					files: [],
					files_tor: [],
					files_boq: [],
					files_noa_spp: [],
					files_oe: [],
					files_bapp: [],
					files_fs: [],
					contract_duration_detail: {
						details: [],
					},
					budget_plan_id: '',
					budget_gl_id: '',
					budget_task_id: [],
					budget_gl: '',
					email_cc: [],
					email_bcc: [],
					whatsapp_number: [],
					email_external: [],
				},
				importPayload: [
					{
						// name: "Riwayat",
						file: null,
						sample: '/template/Template_Contract.xlsx',
					},
				],
				saveAmandement: {
					no: '',
					name: '',
					type_contract: '',
					contract: '',
					contract_owner: '',
					vendor: '',
					start_date: '',
					end_date: '',
					status: '',
					contract_value: 0,
					scope_of_work: '',
					term_of_payments: {
						fixed_assignment: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
						provision: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
					},
					total_duration: 0,
					budget_plan: '',
					budget_task: '',
					contract_co_owner: '',
					oa_number: [],
					files: [],
					files_tor: [],
					files_boq: [],
					files_noa_spp: [],
					files_oe: [],
					files_bapp: [],
					files_fs: [],
					contract_duration_detail: {
						details: [],
					},
					budget_plan_id: '',
					budget_gl_id: '',
					budget_task_id: [],
					budget_gl: '',
					list_budget_gl: [],
					list_pr_po: [],
					scope_of_renewal_contract: [],
				},
				canAdd: false,
				canEdit: false,
				canDelete: false,
				owner_department: '',
				co_owner_department: '',
				selectedTaskId: null,
				listContract: {},
				selectedDepartment: {},
				listUser: [],
			};
		},
		async mounted() {
			try {
				this.role_id = this.profile?.roles && this.profile?.roles?.length > 0 ? this.profile?.roles?.[0]?.id : 0;
				this.user_department = this.profile?.department ? this.profile?.department : this.profile?.roles?.[0]?.name;
				const targetTab = this.$route.params.data !== undefined ? this.$route.params.data : 'MyContract';
				await this.getListDepartment();
				if (this.body.department_id === '') {
					const digitech = this.listDepartments.find((e) => e.code == '7003.122');
					if (digitech) {
						this.body.department_id = digitech.id;
					} else if (this.listDepartments.length > 0) {
						this.body.department_id = this.listDepartments[0]?.id;
					}
				}
				await this.directTabs(targetTab);
				// Load all initial data in parallel
				await Promise.all([this.getListTypeContract(), this.getVendor(), this.getNotification(), this.getListBudgetPlan()]);

				// Load permissions
				const [canAdd, canEdit, canDelete] = await Promise.all([
					authorize('/listContract', 'create'),
					authorize('/listContract', 'update'),
					authorize('/listContract', 'delete'),
				]);

				this.canAdd = canAdd;
				this.canEdit = canEdit;
				this.canDelete = canDelete;

				// Handle URL parameters for auto-opening modal from ubudget
				const urlParams = new URLSearchParams(window.location.search);
				const shouldOpenContractForm = urlParams.get('openContractForm') === 'true';
				const departmentCode = urlParams.get('department');

				if (shouldOpenContractForm) {
					// Ensure listDepartments is fully loaded and available
					if (!this.listDepartments || this.listDepartments.length === 0) {
						console.warn('listDepartments not loaded yet, retrying...');
						await this.getListDepartment(); // Load again if missing
					}

					if (departmentCode) {
						const selectedDepartment = this.listDepartments.find((e) => e.code == departmentCode);
						if (selectedDepartment) {
							this.body.department_id = selectedDepartment.id;
							this.saveContract.department_id = selectedDepartment.id;
							this.setSelectedDepartment();
						} else {
							this.$swal.fire(
								'Department not found',
								'User department is not assigned, please contact admin for further assistance',
								'error'
							);
						}
					}
					this.openNewContract();
				}
			} catch (error) {
				console.error('Error in mounted hook:', error);
				this.$swal.fire('Initialization Error', 'Failed to load required data. Please refresh the page.', 'error');
			}
		},
		methods: {
			async coOwnerSearch(search) {
				if (!search) {
					return false;
				}
				const nik = {
					search: search,
					limit: 10,
					page: 1,
				};
				this.$store.dispatch('listContract/GET_USER_UENROLL', nik).then(() => {
					let data = this.$store.getters['listContract/userUenroll'];
					this.list_co_owner = data;
				});
			},
			async ownerSearch(search) {
				if (!search) {
					return false;
				}
				const nik = {
					search: search,
					limit: 10,
					page: 1,
				};
				this.$store.dispatch('listContract/GET_USER_UENROLL2', nik).then(() => {
					let data = this.$store.getters['listContract/userUenroll2'];
					this.list_owner = data;
				});
			},
			convertNumber(dat) {
				if (dat) {
					return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
				} else if (dat === 0) {
					return 0;
				} else {
					return '';
				}
			},
			handleInput(newValue) {
				const currentValue = this.saveContract.budget_gl_id;

				if (newValue == null || newValue == undefined) {
					this.$bvModal
						.msgBoxConfirm('Apakah Anda yakin ingin menghapus nilai ini?', {
							title: 'Konfirmasi',
							size: 'sm',
							buttonSize: 'sm',
							okVariant: 'danger',
							okTitle: 'Ya',
							cancelTitle: 'Batal',
							footerClass: 'p-2',
							hideHeaderClose: false,
							centered: true,
						})
						.then((confirmed) => {
							if (confirmed) {
								this.previousValue = null;
								this.saveContract.budget_gl_id = null;
							} else {
								this.saveContract.budget_gl_id = currentValue;
								this.previousValue = currentValue;
							}
						});
				} else {
					this.previousValue = newValue;
					this.saveContract.budget_gl_id = newValue;
					this.selectBudgetTask(newValue);
				}
			},
			// handleInput(newValue) {
			//   if (newValue === null || newValue === undefined) {
			//     // Jika nilai dihapus, tampilkan popup konfirmasi
			//     if (confirm("Apakah Anda yakin ingin menghapus nilai ini?")) {
			//       this.previousValue = null; // Set nilai sebelumnya ke null
			//       this.saveContract.budget_gl_id = null; // Hapus nilai
			//     } else {
			//       // Batalkan penghapusan dan kembalikan nilai sebelumnya
			//       this.saveContract.budget_gl_id = this.previousValue;
			//     }
			//   } else {
			//     // Jika nilai berubah (bukan dihapus), simpan nilai sebelumnya
			//     this.previousValue = newValue;
			//   }
			// },
			beforeTabChange(newIndex, oldIndex, evt) {
				if (oldIndex === 0) {
					// console.log(Object.values(this.listAmandement).length);
					// console.log(this.selectedAmandemenType);
					// console.log(this.selectedScopeRenewal);

					// if (Object.values(this.listAmandement).length > 0 && !this.selectedAmandemenType) {
					//   evt.preventDefault(); // Mencegah perpindahan tab
					//   this.$swal('Error', 'Type of Amandemen is required!', 'error');
					//   return false;
					// }
					this.appendDataAmandement();
					// console.log('appendDataAmandement executed');
				}

				// if (newIndex !== oldIndex) {
				//   console.log('after tab change, tabIndex:', this.tabIndex);
				// }
			},
			validateNumericOnly(input) {
				let newValue = input.replace(/[^0-9]/g, '');

				if (newValue !== input) {
					this.$swal('Warning', 'Please input number only', 'warning');
				}

				this.checkLengthValue(newValue);

				this.saveAmandement.contract_value = newValue;
			},
			checkLengthValue(input) {
				let newValue = input;
				if (input.length >= 1000) {
					this.$swal('Warning', 'Character limit exceeded (Max: 1000)', 'warning');
					newValue = newValue.slice(0, 1000); // Memotong agar tetap 1000 karakter
				}
			},
			isScopeNotSelected(scope) {
				return !this.selectedScopeRenewal.includes(scope);
			},
			limitPDF(event) {
				const file = event.target.files[0];
				const maxSize = 10 * 1024 * 1024;

				if (file && file.size > maxSize) {
					this.$swal({
						title: 'Error',
						text: 'File size exceeds 10MB. Please upload a smaller file.',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					event.target.value = '';
				}
			},
			removeRow(id) {
				const index = this.listBudgetTaskGL.findIndex((row) => row.budget_task_id == id);
				if (index > -1) {
					this.$swal({
						title: 'Are you sure?',
						text: "You won't be able to revert this!",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Yes',
					}).then((result) => {
						if (result.isConfirmed) {
							this.listBudgetTaskGL.splice(index, 1);
						}
					});
				}
			},
			editRow(data, type, typeamand) {
				this.typeEdit = type;
				this.isAmandement = typeamand;
				if (type == 'edit-gl') {
					this.editGL.index = data.originalIndex;
					this.editGL.budget_plan_id = data.budget_plan_id;
					this.editGL.budget_gl_id = data.budget_gl_id;
					this.editGL.budget_task_id = data.budget_task_id;
					this.selectedTaskId = data.budget_task_id;
					let body = {
						plan_budget_ids: [data.budget_task_id],
						oa_number: '',
					};
					this.$store.dispatch('listContract/GET_BUDGET_GL', data.budget_plan_id);
					this.$store.dispatch('listContract/GET_BUDGET_TASK', data.budget_gl_id);
					this.$store.dispatch('listContract/GET_BUDGET_TASK_DETAIL', body).then((resp) => {
						let data = this.$store.getters['listContract/listBudgetTaskDetail'];
						let remainingBudget = data[0].remaining_budget;

						this.editGL.remaining_budget = formatCurrency(remainingBudget);
						this.editGL.fulldata = data;
						this.$bvModal.show('modal-edit-gl');
					});
				} else if (type == 'edit-oa') {
					// console.log(data);
					this.indexOA = data.originalIndex;
					this.oaNumberedit.no = data.no;
					this.oaNumberedit.oa_number = data.oa_number;
					this.$bvModal.show('modal-edit-gl');
				}

			},
			updateGL() {
				if (this.$validator.errors.items.length > 0) {
					return;
				}
				this.$swal({
					title: 'Confirm Update?',
					text: 'Are you sure want to save this GL?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
				}).then((result) => {
					if (result.isConfirmed) {
						const existingIds = this.listBudgetTaskGL
							.filter((item) => item.budget_task_id !== this.selectedTaskId)
							.map((item) => item.budget_task_id);
						const duplicate = this.editGL.fulldata.some((item) => existingIds.includes(item.budget_task_id));

						if (duplicate) {
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'error',
									title: 'Duplicate budget task detected',
								});
							return;
						}
						this.$bvModal.hide('modal-edit-gl');
						this.$set(this.listBudgetTaskGL, this.editGL.index, this.editGL.fulldata[0]);
						this.$swal('Saved', 'Your input has been saved', 'success');
					}
				});
				// this.listBudgetTaskGL[0]
			},
			setActiveBudgetPlan() {
				const activePlan = this.ListBudgetPlan.find((plan) => plan.is_active);
				if (activePlan) {
					this.saveContract.budget_plan_id = activePlan.id;
				}
			},
			setYear() {
				const currentYear = new Date().getFullYear();

				let minYear = null;
				if (this.ListBudgetPlan.length > 0) {
					const years = this.ListBudgetPlan.map((plan) => parseInt(plan.year, 10));
					minYear = Math.min(...years);
				}

				let yearList = [];
				if (minYear !== null) {
					const endYear = currentYear + 10;
					for (let y = minYear; y <= endYear; y++) {
						let label = y.toString();
						yearList.push(label);
					}
					return yearList;
				}
			},
			isNumber(evt, action = null) {
				// Allow only 0-9 and comma
				let charCode = evt.which ? evt.which : evt.keyCode;
				const keyPressed = String.fromCharCode(charCode);
				if (
					(charCode < 48 || charCode > 57) && // not a digit
					charCode !== 44 // not a comma
				) {
					evt.preventDefault();
				}
				evt.target.value = evt.target.value.replace(/^0+/, '');

				// console.log('isNumber', action);
				// this.debounceRecalculateTop(action);
			},
			unformatIDR(value) {
				return onlyNumber(value, true);
			},
			// helper to calculate percentage
			calculatePercentage(amount, total) {
				if (total === 0) return 0;

				// Calculate and clamp between 0 and 100
				const percentage = Math.min(100, Math.max(0, (amount / total) * 100));

				// Check if it's an integer
				if (percentage % 1 === 0) {
					return parseInt(percentage);
				} else {
					const rounded = parseFloat(percentage.toFixed(2));
					return rounded % 1 === 0 ? parseInt(rounded) : rounded;
				}
			},
			calculatePercentFromAmount(type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const contractValue = this.unformatIDR(item.contract_value);
				const topKind = getTop(type);
				const amountValue = this.unformatIDR(topKind.amount);

				if (contractValue > 0) {
					topKind.percentage = this.calculatePercentage(amountValue, contractValue);
				}

				this.adjustAmount(type, action);
				// if has contract items
				if (topKind.contract_items.length > 0) {
					topKind.contract_items.forEach((contractItem, contractItemIndex) => {
						this.calculateAmountFromPercentage(contractItemIndex, type, action);
						if (contractItem?.terms?.length > 0) {
							contractItem?.terms?.forEach((term, termIndex) => {
								this.calculateTermAmountFromPercentage(contractItemIndex, termIndex, contractItem.contract_item, type, action);
							});
						}
					});
				}
			},
			adjustAmount(type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const MAX_CONTRACT_VALUE = this.unformatIDR(item.contract_value);

				const fixedAssignment = item.term_of_payments.fixed_assignment;
				const provision = item.term_of_payments.provision;

				// Get the amount of the field NOT being adjusted currently

				// Get reference to the currently being modified property
				const targetProperty = type === 'fixed_assignment' ? fixedAssignment : provision;
				const otherProperty = type === 'fixed_assignment' ? provision : fixedAssignment;
				let currentAmount = this.unformatIDR(targetProperty.amount || 0);

				// Calculate the maximum amount that can be allocated to the current field
				if (currentAmount > MAX_CONTRACT_VALUE) {
					currentAmount = MAX_CONTRACT_VALUE;
					targetProperty.amount = formatCurrency(MAX_CONTRACT_VALUE);
				}
				if (currentAmount < 0) {
					currentAmount = 0;
					targetProperty.amount = formatCurrency(0);
				}
				const targetPercentage = this.calculatePercentage(currentAmount, MAX_CONTRACT_VALUE);
				targetProperty.percentage = targetPercentage;
				if (otherProperty.contract_items.length > 0) {
					otherProperty.percentage = 100 - targetPercentage;
					otherProperty.amount = formatCurrency(MAX_CONTRACT_VALUE - currentAmount);
				}
			},
			calculateAmountFromPercent(type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const contractValue = this.unformatIDR(item.contract_value);

				const topKind = getTop(type);

				// Get the percentage value
				const percentage = parseFloat(topKind?.percentage);

				if (isNaN(percentage) || percentage < 0) {
					// Update the input field with the capped value
					topKind.percentage = 0;
				} else if (isNaN(percentage) || percentage > 100) {
					// Update the input field with the capped value
					topKind.percentage = 100;
				} else {
					// Update the input field with the capped value
					topKind.percentage = percentage;
				}

				if (contractValue > 0) {
					// Update the amount with calculated value
					let amount = (contractValue * parseFloat(percentage)) / 100;
					amount = Math.round(amount);
					topKind.amount = formatCurrency(amount);
				}

				this.adjustPercentage(type, action);
				// if has contract items
				if (topKind.contract_items.length > 0) {
					topKind.contract_items.forEach((contractItem, contractItemIndex) => {
						this.calculateAmountFromPercentage(contractItemIndex, type, action);
						if (contractItem?.terms?.length > 0) {
							contractItem?.terms.forEach((term, termIndex) => {
								this.calculateTermAmountFromPercentage(contractItemIndex, termIndex, contractItem.contract_item, type, action);
							});
						}
					});
				}
			},
			adjustPercentage(type, action = null) {
				const MAX_TOTAL = 100;
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;
				const MAX_CONTRACT_VALUE = this.unformatIDR(item.contract_value);

				const fixedAssignment = item.term_of_payments.fixed_assignment;
				const provision = item.term_of_payments.provision;

				// Get the amount of the field NOT being adjusted currently
				const targetProperty = type === 'fixed_assignment' ? fixedAssignment : provision;
				const otherProperty = type === 'fixed_assignment' ? provision : fixedAssignment;
				const currentPercentage = targetProperty.percentage || 0;
				const otherFieldPercentage = otherProperty.percentage || 0;

				// Calculate the maximum percentage that can be allocated to the current field
				if (currentPercentage > MAX_TOTAL) {
					targetProperty.percentage = MAX_TOTAL;
				}
				if (currentPercentage < 0) {
					targetProperty.percentage = 0;
				}
				let targetAmount = parseFloat(currentPercentage / 100) * MAX_CONTRACT_VALUE;
				targetAmount = Math.round(targetAmount);

				targetProperty.amount = formatCurrency(targetAmount);
				if (otherProperty.contract_items.length > 0) {
					otherProperty.percentage = 100 - currentPercentage;
					otherProperty.amount = formatCurrency(MAX_CONTRACT_VALUE - targetAmount);
				}
			},
			// Calculate amount based on percentage input
			// Updated calculation function
			calculateAmountFromPercentage(index, type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;
				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				const contractValue = this.unformatIDR(topKind.amount);

				// Get the percentage value
				let percentage = parseFloat(topKind?.contract_items[index].percentage_item);

				if (isNaN(percentage) || percentage < 0) {
					// Update the input field with the capped value
					percentage = 0;
				} else if (isNaN(percentage) || percentage > 100) {
					// Update the input field with the capped value
					percentage = 100;
				}
				// Update the input field with the capped value
				topKind.contract_items[index].percentage_item = percentage;

				const contractItem = topKind.contract_items[index];

				if (contractValue > 0) {
					// Update the amount with calculated value
					let amount = (contractValue * parseFloat(percentage)) / 100;
					amount = Math.round(amount);
					contractItem.amount_item = formatCurrency(amount);
					if (type == 'fixed_assignment') {
						this.$validator.validate(`Fixed Assignment Amount Item ${index + 1}`);
					} else {
						this.$validator.validate(`Provision Amount Item ${index + 1}`);
					}
				}

				this.adjustLastEnteredPercentageContract(type, contractValue, action);

				// if has contract terms
				if (topKind.contract_items[index]?.terms.length > 0) {
					topKind.contract_items[index]?.terms.forEach((term, termIndex) => {
						this.calculateTermAmountFromPercentage(
							index,
							termIndex,
							item.term_of_payments.fixed_assignment.contract_items[index].contract_item,
							type,
							action
						);
					});
				}
			},

			// Helper function to calculate new cursor position after formatting
			calculateNewCursorPosition(oldValue, newValue, oldPosition) {
				const diff = newValue.length - oldValue.length;
				return oldPosition + diff;
			},

			// Calculate percentage from amount (updated to work with formatted values)
			calculatePercentageFromAmount(index, type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				const contractValue = this.unformatIDR(topKind.amount);
				const topKindAmount = this.unformatIDR(topKind.amount);
				const contractItem = topKind.contract_items[index];
				let itemAmount = this.unformatIDR(topKind.contract_items[index].amount_item);

				if (topKindAmount > 0 && itemAmount > 0) {
					contractItem.percentage_item = this.calculatePercentage(itemAmount, topKindAmount);
				}
				if (itemAmount > topKindAmount) {
					itemAmount = topKindAmount;
				}

				contractItem.amount_item = formatCurrency(Math.round(itemAmount));

				this.adjustLastEnteredPercentageContract(type, contractValue, action);

				// if has contract terms
				if (topKind.contract_items[index]?.terms.length > 0) {
					topKind.contract_items[index]?.terms.forEach((term, termIndex) => {
						this.calculateTermAmountFromPercentage(
							index,
							termIndex,
							item.term_of_payments.fixed_assignment.contract_items[index].contract_item,
							type,
							action
						);
					});
				}
			},
			// Calculate term amount based on percentage of item amount
			calculateTermAmountFromPercentage(itemIndex, termIndex, contract_item, type, action = null) {
				const itemAction = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return itemAction.term_of_payments.fixed_assignment;
					} else {
						return itemAction.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				// console.log("Log input calculate", itemIndex, termIndex, type);
				const item = topKind.contract_items[itemIndex];
				const term = item?.terms[termIndex];
				const itemAmount = this.unformatIDR(item.amount_item);

				if (parseFloat(term.percentage) > 100) {
					term.percentage = 100;
				}
				if (parseFloat(term.percentage) < 0) {
					term.percentage = 0;
				}

				term.percentage = parseFloat(term.percentage.toString().replace(/^0+/, ''));

				this.adjustTermsPercentage(itemIndex, type, action);

				if (itemAmount > 0 && term.percentage > 0) {
					let amount = (itemAmount * parseFloat(term.percentage)) / 100;
					amount = Math.round(amount);
					term.amount = formatCurrency(amount);
				}
				/*
          type == 'fixed_assignment'
          ? this.$validator.validate(`FA Amount ${contract_item || 'item' + itemIndex + 1} ${termIndex + 1}`)
          : this.$validator.validate(`Amount ${contract_item || 'item' + itemIndex + 1} ${termIndex + 1}`);
          */
			},

			// Calculate term percentage based on item amount
			calculateTermPercentageFromAmount(itemIndex, termIndex, contract_item, type, action = null) {
				const itemAction = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return itemAction.term_of_payments.fixed_assignment;
					} else {
						return itemAction.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				// console.log("Log input calculate", itemIndex, termIndex, contract_item, type);
				const item = topKind.contract_items[itemIndex];
				const term = item?.terms[termIndex];
				const itemAmount = this.unformatIDR(item.amount_item);
				let termAmount = this.unformatIDR(term.amount);

				this.adjustTermsPercentage(itemIndex, type, action);

				if (itemAmount > 0 && termAmount > 0) {
					term.percentage = this.calculatePercentage(termAmount, itemAmount);
				}
				if (termAmount > itemAmount) {
					termAmount = itemAmount;
				}
				termAmount = Math.round(termAmount);
				term.amount = formatCurrency(termAmount);
				/*
          type == 'fixed_assignment'
          ? this.$validator.validate(`FA Percentage ${contract_item || 'item' + itemIndex + 1} ${termIndex + 1}`)
          : this.$validator.validate(`Percentage ${contract_item || 'item' + itemIndex + 1} ${termIndex + 1}`);
          */
			},

			adjustTermsAmount(itemIndex, type, action = null) {
				const itemAction = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return itemAction.term_of_payments.fixed_assignment;
					} else {
						return itemAction.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				// Get the correct item based on type
				const item = topKind.contract_items[itemIndex];

				// Get the maximum amount that all terms combined should not exceed
				const amountItem = this.unformatIDR(item.amount_item || 0);

				// Get all terms for this item
				const terms = item?.terms;

				// Calculate the current total of all term amounts
				let currentTotal = 0;
				terms.forEach((term) => {
					currentTotal += this.unformatIDR(term.amount || 0);
				});

				// If total exceeds the amountItem, adjust the last non-zero term
				if (currentTotal > amountItem) {
					const excess = currentTotal - amountItem;

					// Find the last non-zero term and adjust it
					for (let i = terms.length - 1; i >= 0; i--) {
						const term = terms[i];
						const termAmount = this.unformatIDR(term.amount || 0);

						if (termAmount > 0) {
							// Calculate new value after subtracting excess
							let newValue = termAmount - excess;
							if (newValue < 0) newValue = 0;

							// Update the term amount with formatted value
							term.amount = formatCurrency(Math.round(newValue));
							break; // Exit after adjustment
						}
					}
				}

				// Recalculate the total after adjustments (useful for logging or further processing)
				let totalAfterAdjustment = 0;
				terms.forEach((term) => {
					totalAfterAdjustment += this.unformatIDR(term.amount || 0);
					term.percentage = this.calculatePercentage(this.unformatIDR(term.amount || 0) / amountItem);
				});
			},

			openNewContract() {
				this.isAdd = true;
				this.saveContract.department_id = this.body.department_id;
				this.setSelectedDepartment().then(() => {
					this.saveContract.email_cc = [];
					this.$bvModal.show('modal-1');
				});
			},
			// resetLastEnteredPercentage() {
			//   // Iterate through fixed_assignment first
			//   for (let i = this.saveContract.term_of_payments.fixed_assignment.length - 1; i >= 0; i--) {
			//     let terms = this.saveContract.term_of_payments.fixed_assignment[i].terms;
			//     for (let j = terms.length - 1; j >= 0; j--) {
			//       if (terms[j].percentage > 0) {
			//         terms[j].percentage = 0; // Reset last entered percentage
			//         return; // Exit loop after resetting
			//       }
			//     }
			//   }

			//   // If no values found in fixed_assignment, check provision
			//   for (let i = this.saveContract.term_of_payments.provision.length - 1; i >= 0; i--) {
			//     let terms = this.saveContract.term_of_payments.provision[i].terms;
			//     for (let j = terms.length - 1; j >= 0; j--) {
			//       if (terms[j].percentage > 0) {
			//         terms[j].percentage = 0; // Reset last entered percentage
			//         return; // Exit loop after resetting
			//       }
			//     }
			//   }
			// },
			adjustLastEnteredAmountItem(type, action = null) {
				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				// Get contract value for the specific type
				const contractValue = this.unformatIDR(item.contract_value);

				// Calculate total for the specific type only
				let currentTotal = topKind.contract_items.reduce((sum, item) => {
					const itemValue = this.unformatIDR(item.amount_item || 0);
					return sum + itemValue;
				});

				// console.log(`Current total for ${type}:`, currentTotal);

				// Check if total exceeds contract value for this specific type
				if (currentTotal > contractValue) {
					const excess = currentTotal - contractValue;
					this.isAmountItemExceedingContractValue = true;

					// Adjust only the items of the current type being edited
					const items = topKind.contract_items;

					// Try adjusting from the last non-zero item of this type
					for (let i = items.length - 1; i >= 0; i--) {
						const amount = this.unformatIDR(items[i].amount_item || 0);

						if (amount > 0) {
							const adjusted = Math.max(0, amount - excess);

							// Update the value with proper formatting
							items[i].amount_item = formatCurrency(Math.round(adjusted));

							// Force UI update in Vue
							this.$set(items, i, { ...items[i], amount_item: formatCurrency(Math.round(adjusted)) });

							// Recalculate percentages
							this.$nextTick(() => {
								this.calculatePercentageFromAmount(i, type, action);
							});

							// console.log(`Adjusted item ${i} of ${type} from ${format(amount)} to ${format(adjusted)}`);
							return; // Exit after successful adjustment
						}
					}
				} else {
					this.isAmountItemExceedingContractValue = false;
				}
			},
			adjustLastEnteredPercentageContract(type, contractValue, action = null) {
				const MAX_TOTAL = 100;
				let currentTotal = 0;

				const item = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return item.term_of_payments.fixed_assignment;
					} else {
						return item.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				const itemType = topKind.contract_items;

				// Calculate the current total percentage
				itemType.forEach((contractItem) => {
					currentTotal += parseFloat(contractItem.percentage_item || 0);
				});

				if (currentTotal > MAX_TOTAL) {
					const excess = currentTotal - MAX_TOTAL;
					for (let i = itemType.length - 1; i >= 0; i--) {
						const contractItem = itemType[i];
						const itemPercentage = parseFloat(contractItem.percentage_item || 0);

						if (itemPercentage > 0) {
							// Calculate new value after subtracting excess
							let newValue = itemPercentage - excess;
							if (newValue < 0) newValue = 0;

							// Update the term percentage, remove trailing zeros
							contractItem.percentage_item = newValue.toFixed(2).replace(/\.?0+$/, '');

							let amount = (contractValue * parseFloat(contractItem.percentage_item)) / 100;
							amount = Math.round(amount);
							contractItem.amount_item = formatCurrency(amount);
							break; // Exit after adjustment
						}
					}
				}
			},
			adjustTermsPercentage(itemIndex, type, action = null) {
				const MAX_TOTAL = 100;

				const itemAction = action == 'amandement' ? this.saveAmandement : this.saveContract;

				const getTop = (type) => {
					if (type == 'fixed_assignment') {
						return itemAction.term_of_payments.fixed_assignment;
					} else {
						return itemAction.term_of_payments.provision;
					}
				};

				const topKind = getTop(type);

				// Get the correct item based on type
				const item = topKind.contract_items[itemIndex];

				// Get all terms for this item
				const terms = item?.terms;

				// Calculate the current total percentage
				let currentTotal = 0;
				terms.forEach((term) => {
					currentTotal += parseFloat(term.percentage || 0);
				});

				// If total exceeds the MAX_TOTAL, adjust the last non-zero term
				if (currentTotal > MAX_TOTAL) {
					const excess = currentTotal - MAX_TOTAL;

					// Find the last non-zero term and adjust it
					for (let i = terms.length - 1; i >= 0; i--) {
						const term = terms[i];
						const termPercentage = parseFloat(term.percentage || 0);

						if (termPercentage > 0) {
							// Calculate new value after subtracting excess
							let newValue = termPercentage - excess;
							if (newValue < 0) newValue = 0;

							// Update the term percentage, remove trailing zeros
							term.percentage = newValue.toFixed(2).replace(/\.?0+$/, '');
							break; // Exit after adjustment
						}
					}
				}

				// Recalculate the total after adjustments (useful for logging or further processing)
				let totalAfterAdjustment = 0;
				terms.forEach((term) => {
					totalAfterAdjustment += parseFloat(term.percentage || 0);
					let amount = (this.unformatIDR(item.amount_item) * parseFloat(term.percentage)) / 100;
					amount = Math.round(amount);
					term.amount = formatCurrency(amount);
				});

				// console.log("Total percentage after adjustment:", totalAfterAdjustment, "Maximum allowed:", MAX_TOTAL);
			},
			adjustLastEnteredPercentageAmandement() {
				const MAX_TOTAL = 100;
				let currentTotal = 0;

				// Calculate current total percentage
				// Sum fixed_assignment percentages
				this.saveAmandement.term_of_payments.fixed_assignment.forEach((item) => {
					item.terms.forEach((term) => {
						currentTotal += parseFloat(term.percentage || 0);
					});
				});

				// Add provision percentages
				this.saveAmandement.term_of_payments.provision.forEach((item) => {
					item.terms.forEach((term) => {
						currentTotal += parseFloat(term.percentage || 0);
					});
				});

				// If total exceeds 100%, adjust last non-zero entry
				if (currentTotal > MAX_TOTAL) {
					const excess = parseFloat((currentTotal - MAX_TOTAL).toFixed(2));

					// Try to adjust in provision first (assuming it's typically entered last)
					for (let i = this.saveAmandement.term_of_payments.provision.length - 1; i >= 0; i--) {
						let terms = this.saveAmandement.term_of_payments.provision[i].terms;
						for (let j = terms.length - 1; j >= 0; j--) {
							if (parseFloat(terms[j].percentage) > 0) {
								// Adjust value but don't go below zero
								let newValue = parseFloat(terms[j].percentage) - excess;
								if (newValue < 0) newValue = 0;
								terms[j].percentage = newValue.toFixed(2).replace(/\.?0+$/, ''); // Remove trailing zeros
								return; // Exit after adjustment
							}
						}
					}

					// If no adjustment made in provision, try fixed_assignment
					for (let i = this.saveAmandement.term_of_payments.fixed_assignment.length - 1; i >= 0; i--) {
						let terms = this.saveAmandement.term_of_payments.fixed_assignment[i].terms;
						for (let j = terms.length - 1; j >= 0; j--) {
							if (parseFloat(terms[j].percentage) > 0) {
								// Adjust value but don't go below zero
								let newValue = parseFloat(terms[j].percentage) - excess;
								if (newValue < 0) newValue = 0;
								terms[j].percentage = newValue.toFixed(2).replace(/\.?0+$/, ''); // Remove trailing zeros
								return; // Exit after adjustment
							}
						}
					}
				}
			},
			modalClose(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.$swal({
						title: 'Confirm Close?',
						text: 'Are you sure want to close this modal?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Yes',
					}).then((result) => {
						if (result.isConfirmed) {
							this.$bvModal.hide('modal-1');
							this.isAdd = false;
							this.listBudgetTaskGL = [];
							this.resetSaveContract();
						}
					});
				}
			},
			// formatPercentageInputContract(event, item) {
			//   // Get the input value
			//   let value = event.target.value;

			//   // Check if it has more than 3 decimal places
			//   if (value.includes('.')) {
			//     const parts = value.split('.');
			//     if (parts[1] && parts[1].length > 3) {
			//       // Truncate to 3 decimal places
			//       event.target.value = `${parts[0]}.${parts[1].substring(0, 3)}`;
			//       // Update the data model
			//       item.percentage = event.target.value;
			//     }
			//   }

			//   // Call the adjustment function after validation
			//   this.adjustLastEnteredPercentageContract();
			// },
			formatPercentageInputAmandement(event, item) {
				// Get the input value
				let value = event.target.value;

				// Check if it has more than 3 decimal places
				if (value.includes('.')) {
					const parts = value.split('.');
					if (parts[1] && parts[1].length > 3) {
						// Truncate to 3 decimal places
						event.target.value = `${parts[0]}.${parts[1].substring(0, 3)}`;
						// Update the data model
						item.percentage = event.target.value;
					}
				}

				// Call the adjustment function after validation
				this.adjustLastEnteredPercentageAmandement();
			},
			async directTabs(data) {
				if (data === 'MyContract') {
					this.direct = 'MyContract';
					this.breadcrumb = 'All Contract';
					delete this.body.type;
					this.body.page = 1;
				} else if (data === 'draft') {
					this.direct = 'draft';
					this.breadcrumb = 'Draft';
					this.body.page = 1;
					this.body.type = 'DRAFT';
				} else if (data === 'onGoing') {
					this.direct = 'onGoing';
					this.breadcrumb = 'On Going';

					this.body.page = 1;
					this.body.type = 'ON_GOING';
				} else if (data === 'closed') {
					this.direct = 'closed';
					this.breadcrumb = 'Closed';
					this.body.page = 1;
					this.body.type = 'CLOSED';
				} else if (data === 'earlyTermination') {
					this.direct = 'earlyTermination';
					this.breadcrumb = 'Early Terminated';

					this.body.page = 1;
					this.body.type = 'EARLY_TERMINATED';
				} else if (data === 'expiredSoon') {
					this.direct = 'expiredSoon';
					this.breadcrumb = 'Expired Soon';
					this.body.page = 1;
					this.body.type = 'EXPIRED_SOON';
				} else if (data === 'expired') {
					this.direct = 'expired';
					this.breadcrumb = 'Expired';
					this.search = '';
					this.body.page = 1;
					this.body.type = 'EXPIRED';
				} else if (data === 'valueWarning') {
					this.direct = 'valueWarning';
					this.breadcrumb = 'Value Warning';
					this.search = '';
					this.body.page = 1;
					this.body.type = 'VALUE_WARNING';
				}
				await this.filterPage();
			},
			chnageEmail(data) {
				this.modalCreate.notification.map((item) => {
					if (item.notification_id === data.id) {
						item.email_active = data.email;
					}
				});
			},
			chnageWA(data) {
				this.modalCreate.notification.map((item) => {
					if (item.notification_id === data.id) {
						item.whatsapp_active = data.whatsapp;
					}
				});
			},
			// selectionAdd(params) {
			//   let data = [];
			//   for (let index = 0; index < params.selectedRows.length; index++) {
			//     let row = params.selectedRows[index];

			//     // Ensure additionalDatas exists
			//     row.additionalDatas = row.additionalDatas || {};

			//     // Sync whatsapp value
			//     row.additionalDatas.whatsapp = row.whatsapp;

			//     data.push(row);
			//   }
			//   console.log(data);

			//   this.modalCreate.notification = data;
			// },
			selectionAdd(params) {
				let data = [];
				for (let index = 0; index < params.selectedRows.length; index++) {
					data.push({
						notification_id: Number(params.selectedRows[index].id),
						email_active: params.selectedRows[index].email,
						whatsapp_active: params.selectedRows[index].whatsapp,
					});
				}
				this.modalNotification.notification = data;
				// console.log(this.modalNotification.notification);
			},

			chnageEmailUpdate(data) {
				this.modalUpdate.notification.map((item) => {
					if (item.notification_id === data.id) {
						item.email_active = data.email;
					}
				});
			},
			chnageWAUpdate(data) {
				this.modalUpdate.notification.map((item) => {
					if (item.notification_id === data.id) {
						item.whatsapp_active = data.whatsapp;
					}
				});
			},

			selectionUpdate(params) {
				let data = [];
				for (let index = 0; index < params.selectedRows.length; index++) {
					data.push({
						notification_id: Number(params.selectedRows[index].id),
						email_active: params.selectedRows[index].email,
						whatsapp_active: params.selectedRows[index].whatsapp,
					});
				}
				this.modalUpdate.notification = data;
			},

			onSearch() {
				this.body.page = 1;
				this.body.search = this.search;
				this.getListContract();
			},
			downloadAll() {
				let body = '';

				if (this.direct == 'onGoing') {
					body = {
						filename: 'Contract On Going',
						type: 'ON_GOING',
					};
				} else if (this.direct == 'closed') {
					body = {
						filename: 'Contract Closed & Terminate',
						type: 'CLOSED_ALL',
					};
				} else {
					body = {
						filename: 'My Contract',
						type: 'MY_CONTRACT',
					};
				}

				this.$store.dispatch('listContract/downloadExcel', body);
			},
			async importFileUpload(event) {
				this.files = event.target.files[0];
			},

			importData() {
				try {
					this.isLoading = true;
					const formData = new FormData();
					formData.append('files', this.files);
					this.$store
						.dispatch('listContract/IMPORT_DATA', formData)
						.then((resp) => {
							if (resp.data.error.length > 0) {
								this.isLoading = false;
								const dataFirst = resp.data.error;
								const formattedResponse = dataFirst.map((item) => `<br>- ${item}`).join('\n');
								this.$swal({
									title: 'Rejected!',
									icon: 'error',
									html: `Your input has been Reject: <br>${formattedResponse}`,
									showCloseButton: false,
									showCancelButton: false,
									focusConfirm: false,
								});
							} else {
								this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
									this.isLoading = false;
									this.files = '';
									this.getListContract();
									this.$bvModal.hide('importFile');
								});
							}
						})
						.catch((err) => {
							this.isLoading = false;
							this.$swal('Error', err.response.data.error, 'error');
						});
				} catch (err) {
					console.log('Error while importing mcu record', err);
				}
			},
			async fileUploader(event) {
				this.modalCreate.files = event.target.files;
			},
			// addNumber(index) {
			//   this.modalCreate.notification[index].additionalDatas.whatsapp_number.push(+1);
			// },
			// removeAddNumber(index, indexx) {
			//   this.modalCreate.notification[index].additionalDatas.whatsapp_number.splice(indexx, 1);
			// },
			addNumber() {
				this.whatsapp_number.push(+1);
			},
			removeAddNumber(index) {
				this.whatsapp_number.splice(index, 1);
			},

			async amandemenSetFileTor(event) {
				this.limitPDF(event);
				this.saveAmandement.files_tor = event.target.files;
			},
			async amandemenSetFileBoq(event) {
				this.limitPDF(event);
				this.saveAmandement.files_boq = event.target.files;
			},
			async amandemenSetFileNoa(event) {
				this.limitPDF(event);
				this.saveAmandement.files_noa_spp = event.target.files;
			},
			async amandemenSetFileOe(event) {
				this.limitPDF(event);
				this.saveAmandement.files_oe = event.target.files;
			},
			async amandemenSetFileFs(event) {
				this.limitPDF(event);
				this.saveAmandement.files_fs = event.target.files;
			},
			async amandemenSetFileBapp(event) {
				this.limitPDF(event);
				this.saveAmandement.files_bapp = event.target.files;
			},
			async amandemenSetFileOthers(event) {
				this.limitPDF(event);
				this.saveAmandement.files = event.target.files;
			},
			async setFileTor(event) {
				this.limitPDF(event);
				this.saveContract.files_tor = event.target.files;
				this.filesName.tor = this.saveContract.files_tor ? this.saveContract.files_tor.name : '';
			},
			async setFileBoq(event) {
				this.limitPDF(event);
				this.saveContract.files_boq = event.target.files;
			},
			async setFileNoa(event) {
				this.limitPDF(event);
				this.saveContract.files_noa_spp = event.target.files;
			},
			async setFileOe(event) {
				this.limitPDF(event);
				this.saveContract.files_oe = event.target.files;
			},
			async setFileFs(event) {
				this.limitPDF(event);
				this.saveContract.files_fs = event.target.files;
			},
			async setFileBapp(event) {
				this.limitPDF(event);
				this.saveContract.files_bapp = event.target.files;
			},
			async setFileOthers(event) {
				this.limitPDF(event);
				this.saveContract.files = event.target.files;
			},
			addDurationDetail() {
				let bodyMyContract = {
					detail_name: '',
					items: [],
				};
				this.saveContract.contract_duration_detail.details.push(bodyMyContract);
			},
			removeDurationDetail(index) {
				this.saveContract.contract_duration_detail.details.splice(index, 1);
			},
			addDurationDetailItems(index) {
				let bodyMyContract = {
					item_name: '',
					work_duration: '',
					description: '',
				};
				this.saveContract.contract_duration_detail.details[index].items.push(bodyMyContract);
			},
			removeDurationDetailItems(index, itemIndx) {
				this.saveContract.contract_duration_detail.details[index].items.splice(itemIndx, 1);
			},
			addDurationDetailAmandement() {
				let bodyMyContract = {
					detail_name: '',
					items: [],
				};
				this.saveAmandement.contract_duration_detail.details.push(bodyMyContract);
			},
			removeDurationDetailAmandement(index) {
				this.saveAmandement.contract_duration_detail.details.splice(index, 1);
			},
			addDurationDetailItemsAmandement(index) {
				let bodyMyContract = {
					item_name: '',
					work_duration: '',
					description: '',
				};
				this.saveAmandement.contract_duration_detail.details[index].items.push(bodyMyContract);
			},
			removeDurationDetailItemsAmandement(index, itemIndx) {
				this.saveAmandement.contract_duration_detail.details[index].items.splice(itemIndx, 1);
			},
			addFixedAssigmentAmandement() {
				let bodyAmandement = {
					contract_item: '',
					terms: [],
					total_percentage: '',
					percentage_item: null,
					amount_item: null,
				};
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items.push(bodyAmandement);
			},
			removeFixedAssigmentAmandement(index) {
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items.splice(index, 1);
				if (this.saveAmandement.term_of_payments.fixed_assignment.contract_items.length == 0) {
					this.saveAmandement.term_of_payments.fixed_assignment.percentage = '';
					this.saveAmandement.term_of_payments.fixed_assignment.amount = '';
				}
			},
			addFixedAssigmentAmandementItems(index) {
				let bodyAmandement = {
					term: '',
					percentage: '',
					amount: null,
					details: [],
					description: '',
				};
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms.push(bodyAmandement);
			},
			removeFixedAssigmentAmandementItems(index, itemIndx) {
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms.splice(itemIndx, 1);
			},
			addFixedAssigmentAmandementItemsDetail(index, itemIndx) {
				let bodyMyContract = '';
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms[itemIndx].details.push(
					bodyMyContract
				);
			},
			removeFixedAssigmentAmandementItemsDetail(index, itemIndx, detailIndx) {
				this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms[itemIndx].details.splice(
					detailIndx,
					1
				);
			},
			addProvisionAmandement() {
				let bodyMyContract = {
					contract_item: '',
					terms: [],
					amount_item: null,
					percentage_item: null,
					total_percentage: '',
				};
				this.saveAmandement.term_of_payments.provision.contract_items.push(bodyMyContract);
			},
			removeProvisionAmandement(index) {
				this.saveAmandement.term_of_payments.provision.contract_items.splice(index, 1);
				if (this.saveAmandement.term_of_payments.provision.contract_items.length == 0) {
					this.saveAmandement.term_of_payments.provision.percentage = '';
					this.saveAmandement.term_of_payments.provision.amount = '';
				}
			},
			addProvisionAmandementItems(index) {
				let bodyMyContract = {
					term: '',
					percentage: '',
					details: [],
					description: '',
				};
				this.saveAmandement.term_of_payments.provision.contract_items[index].terms.push(bodyMyContract);
			},
			removeProvisionAmandementItems(index, itemIndx) {
				this.saveAmandement.term_of_payments.provision.contract_items[index].terms.splice(itemIndx, 1);
			},
			addProvisionAmandementItemsDetail(index, itemIndx) {
				let bodyMyContract = '';
				this.saveAmandement.term_of_payments.provision.contract_items[index].terms[itemIndx].details.push(bodyMyContract);
			},
			removeProvisionAmandementItemsDetail(index, itemIndx, detailIndx) {
				this.saveAmandement.term_of_payments.provision.contract_items[index].terms[itemIndx].details.splice(detailIndx, 1);
			},
			changesPercentageFAAmandement(event, index, itmIndex) {
				let inputValue = Number(event.target.value); // Convert input value to number

				if (isNaN(inputValue) || inputValue < 0) {
					// Prevent negative or invalid values
					this.$set(
						this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms[itmIndex],
						'percentage',
						0
					);
				} else {
					// Ensure value does not exceed 100
					this.$set(
						this.saveAmandement.term_of_payments.fixed_assignment.contract_items[index].terms[itmIndex],
						'percentage',
						Math.min(inputValue, 100)
					);
				}

				// Update total percentage
				this.updateTotalPercentageAmandement(index, itmIndex);
			},

			updateTotalPercentageAmandement(index, itmIndex) {
				// Calculate total percentage dynamically based on term percentages
				let total = this.saveAmandement.term_of_payments.fixed_assignment[index].terms.reduce(
					(sum, item) => sum + Number(item.percentage || 0),
					0
				);

				if (total > 100) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total Percentage cannot exceed 100%',
						});

					// Reset the last entered value to 0
					this.$set(this.saveAmandement.term_of_payments.fixed_assignment[index].terms[itmIndex], 'percentage', 0);

					// Recalculate total after resetting value
					total = this.saveAmandement.term_of_payments.fixed_assignment[index].terms.reduce(
						(sum, item) => sum + Number(item.percentage || 0),
						0
					);
				}

				this.$set(this.saveAmandement.term_of_payments.fixed_assignment[index], 'total_percentage', total);
			},

			changesPercentageProAmandement(event, index, itmIndex) {
				let inputValue = Number(event.target.value); // Convert input value to number

				if (isNaN(inputValue) || inputValue < 0) {
					// Prevent negative or invalid values
					this.$set(this.saveAmandement.term_of_payments.provision.contract_items[index].terms[itmIndex], 'percentage', 0);
				} else {
					// Ensure value does not exceed 100
					this.$set(
						this.saveAmandement.term_of_payments.provision.contract_items[index].terms[itmIndex],
						'percentage',
						Math.min(inputValue, 100)
					);
				}

				// Update total percentage
				this.updateTotalPercentageProAmandement(index, itmIndex);
			},
			updateTotalPercentageProAmandement(index, itmIndex) {
				// Calculate total percentage dynamically based on term percentages
				let total = this.saveAmandement.term_of_payments.provision.contract_items[index].terms.reduce(
					(sum, item) => sum + Number(item.percentage || 0),
					0
				);

				if (total > 100) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total Percentage cannot exceed 100%',
						});

					// Reset the last entered value to 0
					this.$set(this.saveAmandement.term_of_payments.provision.contract_items[index].terms[itmIndex], 'percentage', 0);

					// Recalculate total after resetting value
					total = this.saveAmandement.term_of_payments.provision.contract_items[index].terms.reduce(
						(sum, item) => sum + Number(item.percentage || 0),
						0
					);
				}

				this.$set(this.saveAmandement.term_of_payments.provision.contract_items[index], 'total_percentage', total);
			},
			addFixedAssigment() {
				let bodyMyContract = {
					contract_item: '',
					terms: [],
					total_percentage: '',
					percentage_item: null,
					amount_item: null,
				};
				this.saveContract.term_of_payments.fixed_assignment.contract_items.push(bodyMyContract);
			},
			removeFixedAssigment(index) {
				this.saveContract.term_of_payments.fixed_assignment.contract_items.splice(index, 1);
				if (this.saveContract.term_of_payments.fixed_assignment.contract_items.length === 0) {
					this.saveContract.term_of_payments.fixed_assignment.percentage = '';
					this.saveContract.term_of_payments.fixed_assignment.amount = '';
				}
			},
			addFixedAssigmentItems(index) {
				let bodyMyContract = {
					term: '',
					percentage: '',
					amount: null,
					details: [],
					description: '',
				};
				this.saveContract.term_of_payments.fixed_assignment.contract_items[index].terms.push(bodyMyContract);
			},
			removeFixedAssigmentItems(index, itemIndx) {
				this.saveContract.term_of_payments.fixed_assignment.contract_items[index].terms.splice(itemIndx, 1);
			},
			addFixedAssigmentItemsDetail(index, itemIndx) {
				let bodyMyContract = '';
				this.saveContract.term_of_payments.fixed_assignment.contract_items[index].terms[itemIndx].details.push(
					bodyMyContract
				);
			},
			removeFixedAssigmentItemsDetail(index, itemIndx, detailIndx) {
				this.saveContract.term_of_payments.fixed_assignment.contract_items[index].terms[itemIndx].details.splice(
					detailIndx,
					1
				);
			},

			addProvision() {
				let bodyMyContract = {
					contract_item: '',
					terms: [],
					amount_item: null,
					percentage_item: null,
					total_percentage: '',
				};
				this.saveContract.term_of_payments.provision.contract_items.push(bodyMyContract);
			},
			removeProvision(index) {
				this.saveContract.term_of_payments.provision.contract_items.splice(index, 1);
				if (this.saveContract.term_of_payments.provision.contract_items.length === 0) {
					this.saveContract.term_of_payments.provision.percentage = '';
					this.saveContract.term_of_payments.provision.amount = '';
				}
			},
			addProvisionItems(index) {
				let bodyMyContract = {
					term: '',
					percentage: '',
					amount: null,
					details: [],
					description: '',
				};
				this.saveContract.term_of_payments.provision.contract_items[index].terms.push(bodyMyContract);
			},
			removeProvisionItems(index, itemIndx) {
				this.saveContract.term_of_payments.provision.contract_items[index].terms.splice(itemIndx, 1);
			},
			addProvisionItemsDetail(index, itemIndx) {
				let bodyMyContract = '';
				this.saveContract.term_of_payments.provision.contract_items[index].terms[itemIndx].details.push(bodyMyContract);
			},
			removeProvisionItemsDetail(index, itemIndx, detailIndx) {
				this.saveContract.term_of_payments.provision.contract_items[index].terms[itemIndx].details.splice(detailIndx, 1);
			},

			updateOptions() {
				let bodyMyContract = {
					term: '',
					percentage: '',
				};
				this.modalUpdate.term_of_payments.push(bodyMyContract);
			},

			removeAdd(index) {
				this.modalCreate.term_of_payments.splice(index, 1);
			},
			removeUpdate(index) {
				this.modalCreate.term_of_payments.splice(index, 1);
			},
			changePercenAdd() {
				var data = this.modalCreate.term_of_payments;
				var percen = 0;
				for (let index = 0; index < data.length; index++) {
					const element = data[index].percentage;
					percen += Number(element);
				}
				this.percentage = Number(percen);
			},
			changePercenUpdate() {
				var data = this.modalUpdate.term_of_payments;
				var percen = 0;
				for (let index = 0; index < data.length; index++) {
					const element = data[index].percentage;
					percen += Number(element);
				}
				this.percentage = Number(percen);
			},
			async saveAdd(type) {
				this.isLoading = true;
				if (type == 'submit') {
					if (this.totalOverallPercentage < 100) {
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'error',
								title: 'Total Percentage is less than 100%',
							});
						this.isLoading = false;
						return false;
					}
					if (
						this.saveContract.term_of_payments.provision.length < 0 ||
						this.saveContract.term_of_payments.fixed_assignment.length < 0 ||
						this.saveContract.contract_duration_detail.length < 0
					) {
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'error',
								title: 'Mandatory field cannot be empty',
							});
						this.isLoading = false;
						return false;
					}
					this.$validator.validateAll().then(async (res) => {
						if (!res) {
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'error',
									title: 'Mandatory field cannot be empty',
								});
							this.tabIndex = 0;
							console.log('errors', this.$validator.errors);
							this.isLoading = false;
							return false;
						}
						let top = JSON.stringify(this.saveContract.term_of_payments);
						let contract_duration = JSON.stringify(this.saveContract.contract_duration_detail);
						this.saveContract.list_budget_gl = this.listBudgetTaskGL;
						let oa_num = JSON.stringify(this.saveContract.oa_number);
						let budgetGl = JSON.stringify(this.saveContract.list_budget_gl);
						// this.isLoading = true

						const formData = new FormData();
						formData.append('no', this.saveContract.no);
						formData.append('name', this.saveContract.name);
						formData.append('type_contract', this.saveContract.type_contract);
						formData.append('contract', this.saveContract.contract);
						formData.append('contract_owner', this.saveContract.contract_owner);
						// formData.append("budget", this.saveContract.budget)
						// formData.append("remaining_budget", this.saveContract.remaining_budget)
						formData.append('department_id', this.saveContract.department_id);
						formData.append('vendor', this.saveContract.vendor);
						formData.append('start_date', this.saveContract.start_date);
						formData.append('end_date', this.saveContract.end_date);
						formData.append('oa_number', oa_num);
						formData.append('scope_of_work', this.saveContract.scope_of_work);
						formData.append('term_of_payments', top);
						formData.append('total_duration', this.saveContract.total_duration);
						formData.append('contract_co_owner', this.saveContract.contract_co_owner);
						formData.append('contract_value', this.unformatIDR(this.saveContract.contract_value));

						formData.append('list_budget_gl', budgetGl);
						for (let file of this.saveContract.files || []) {
							formData.append('files', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_tor || []) {
							formData.append('files_tor', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_boq || []) {
							formData.append('files_boq', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_noa_spp || []) {
							formData.append('files_noa_spp', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_oe || []) {
							formData.append('files_oe', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_bapp || []) {
							formData.append('files_bapp', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_fs || []) {
							formData.append('files_fs', file); // note, no square-brackets
						}
						formData.append('contract_duration_detail', contract_duration);
						formData.append('budget_plan_id', this.saveContract.budget_plan_id);
						formData.append('budget_gl_id', this.saveContract.budget_gl_id);
						formData.append('budget_gl', this.saveContract.budget_gl);
						formData.append('budget_task_id', this.saveContract.budget_task_id);

						// notification section
						// console.log(this.defaultRecipient);
						const email_cc =
							this.saveContract.email_cc.length < 1
								? [
										...new Set([
											// ...this.defaultRecipient,
											this.listUser.find((user) => user.id == this.saveContract.contract_owner)?.email,
											this.listUser.find((user) => user.id == this.saveContract.contract_co_owner)?.email,
										]),
								  ]
								: this.saveContract.email_cc;
						formData.append('email_cc', JSON.stringify(email_cc.filter((email) => email)));
						formData.append('email_bcc', JSON.stringify(this.saveContract.email_bcc.filter((email) => email)));
						formData.append('email_external', JSON.stringify(this.saveContract.email_external));
						let wa_number = this.saveContract.whatsapp_number.map((num) => {
							let sanitized = num.replace(/^0+/, '');
							return `62${sanitized}`;
						});
						formData.append('whatsapp_number', JSON.stringify(wa_number));

						try {
							this.$store
								.dispatch('listContract/saveContract', {
									bodys: formData,
									type: type,
								})
								.then((resp) => {
									this.isLoading = false;
									this.$swal('Success', 'Success add data', 'success');
									this.$bvModal.hide('modal-1');
									this.getListContract();
									this.resetSaveContract();
									this.isLoading = false;
								})
								.catch((err) => {
									this.isLoading = false;
									this.$swal('Error', err.response.data.error, 'error');
									this.isLoading = false;
								});
						} catch (error) {
							this.isLoading = false;
							this.$swal('Error', 'Error while add data', 'error');
							this.isLoading = false;
						}
					});
				} else {
					// contract number must be provided to ensure uniqueness
					// const validateContractNumber = await this.$validator.validate('Contract Number');
					// const validateTypeOfContract = await this.$validator.validate('Type Of Contract');
					// if (!validateContractNumber || !validateTypeOfContract) {
					// 	this.$swal
					// 		.mixin({
					// 			toast: true,
					// 			position: 'top-end',
					// 			showConfirmButton: false,
					// 			timer: 3000,
					// 			timerProgressBar: true,
					// 			didOpen: (toast) => {
					// 				toast.addEventListener('mouseenter', this.$swal.stopTimer);
					// 				toast.addEventListener('mouseleave', this.$swal.resumeTimer);
					// 			},
					// 		})
					// 		.fire({
					// 			icon: 'error',
					// 			title: 'At least contract number and type of contract must be provided',
					// 		});
					// 	this.tabIndex = 0;
					// 	return;
					// }

					let top = JSON.stringify(this.saveContract.term_of_payments);
					let contract_duration = JSON.stringify(this.saveContract.contract_duration_detail);
					this.saveContract.list_budget_gl = this.listBudgetTaskGL;
					let oa_num = JSON.stringify(this.saveContract.oa_number);
					let budgetGl = JSON.stringify(this.saveContract.list_budget_gl);
					// this.isLoading = true
					const formData = new FormData();
					formData.append('no', this.saveContract.no);
					formData.append('name', this.saveContract.name);
					formData.append('type_contract', this.saveContract.type_contract);
					formData.append('contract', this.saveContract.contract);
					formData.append('contract_owner', this.saveContract.contract_owner);
					// formData.append("budget", this.saveContract.budget)
					// formData.append("remaining_budget", this.saveContract.remaining_budget)
					formData.append('department_id', this.saveContract.department_id);
					formData.append('vendor', this.saveContract.vendor);
					formData.append('start_date', this.saveContract.start_date);
					formData.append('end_date', this.saveContract.end_date);
					formData.append('oa_number', oa_num);
					formData.append('scope_of_work', this.saveContract.scope_of_work);
					formData.append('term_of_payments', top);
					formData.append('total_duration', this.saveContract.total_duration);
					formData.append('contract_co_owner', this.saveContract.contract_co_owner);
					formData.append('contract_value', this.unformatIDR(this.saveContract.contract_value));

					formData.append('list_budget_gl', budgetGl);
					for (let file of this.saveContract.files || []) {
						formData.append('files', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_tor || []) {
						formData.append('files_tor', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_boq || []) {
						formData.append('files_boq', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_noa_spp || []) {
						formData.append('files_noa_spp', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_oe || []) {
						formData.append('files_oe', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_bapp || []) {
						formData.append('files_bapp', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_fs || []) {
						formData.append('files_fs', file); // note, no square-brackets
					}
					formData.append('contract_duration_detail', contract_duration);
					formData.append('budget_plan_id', this.saveContract.budget_plan_id);
					formData.append('budget_gl_id', this.saveContract.budget_gl_id);
					formData.append('budget_gl', this.saveContract.budget_gl);
					formData.append('budget_task_id', this.saveContract.budget_task_id);

					// notification section
					// console.log(this.defaultRecipient);
					const email_cc =
						this.saveContract.email_cc.length < 1
							? [
									...new Set([
										// ...this.defaultRecipient,
										this.listUser.find((user) => user.id == this.saveContract.contract_owner)?.email,
										this.listUser.find((user) => user.id == this.saveContract.contract_co_owner)?.email,
									]),
							  ]
							: this.saveContract.email_cc;
					formData.append('email_cc', JSON.stringify(email_cc.filter((email) => email)));
					formData.append('email_bcc', JSON.stringify(this.saveContract.email_bcc.filter((email) => email)));
					formData.append('email_external', JSON.stringify(this.saveContract.email_external));
					let wa_number = this.saveContract?.whatsapp_number?.map((num) => {
						let sanitized = num.replace(/^0+/, '');
						return `62${sanitized}`;
					});
					formData.append('whatsapp_number', JSON.stringify(wa_number));

					try {
						this.$store
							.dispatch('listContract/saveContract', {
								bodys: formData,
								type: type,
							})
							.then((resp) => {
								this.$swal('Success', 'Success add data', 'success');
								this.$bvModal.hide('modal-1');
								this.isLoading = false;
								this.getListContract();
								this.resetSaveContract();
								this.isLoading = false;
							})
							.catch((err) => {
								this.isLoading = false;
								this.$swal('Error', err.response.data.error, 'error');
								this.isLoading = false;
							});
					} catch (error) {
						this.isLoading = false;
						this.$swal('Error', 'Error while add data', 'error');
						this.isLoading = false;
					}
				}
			},

			async saveUpdate(status) {
				console.log(status);
				this.isLoading = true;
				if (status == 'existing') {
					if (this.totalOverallPercentage < 100) {
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'error',
								title: 'Total Percentage is less than 100%',
							});
						this.isLoading = false;
						return false;
					}
					if (
						this.saveContract.term_of_payments.provision.length < 0 ||
						this.saveContract.term_of_payments.fixed_assignment.length < 0 ||
						this.saveContract.contract_duration_detail.length < 0
					) {
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'error',
								title: 'Mandatory field cannot be empty',
							});
						this.isLoading = false;
						return false;
					}
					this.$validator.validateAll().then(async (res) => {
						if (!res) {
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'error',
									title: 'Mandatory field cannot be empty',
								});
							this.tabIndex = 0;
							console.log('errors', this.$validator.errors);
							this.isLoading = false;
							return false;
						}
						let top = JSON.stringify(this.saveContract.term_of_payments);
						let contract_duration = JSON.stringify(this.saveContract.contract_duration_detail);
						this.saveContract.list_budget_gl = this.listBudgetTaskGL;
						let budgetGl = JSON.stringify(this.saveContract.list_budget_gl);
						let po_number = JSON.stringify(this.saveContract.po_number);
						// this.isLoading = true
						let oa_num = JSON.stringify(this.saveContract.oa_number);
						const formData = new FormData();
						formData.append('no', this.saveContract.no);
						formData.append('name', this.saveContract.name);
						formData.append('type_contract', this.saveContract.type_contract || '');
						formData.append('contract', this.saveContract.contract);
						formData.append('contract_owner', this.saveContract.contract_owner || '');
						// formData.append("budget", this.saveContract.budget)
						// formData.append("remaining_budget", this.saveContract.remaining_budget)
						formData.append('oa_number', oa_num);
						formData.append('vendor', this.saveContract.vendor);
						formData.append('start_date', this.saveContract.start_date);
						formData.append('end_date', this.saveContract.end_date);
						formData.append('scope_of_work', this.saveContract.scope_of_work);
						formData.append('term_of_payments', top);
						formData.append('po_number', po_number);
						formData.append('total_duration', this.saveContract.total_duration);
						formData.append('contract_co_owner', this.saveContract.contract_co_owner || '');
						formData.append('contract_value', this.unformatIDR(this.saveContract.contract_value));
						formData.append('list_budget_gl', budgetGl);
						for (let file of this.saveContract.files || []) {
							formData.append('files', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_tor || []) {
							formData.append('files_tor', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_boq || []) {
							formData.append('files_boq', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_noa_spp || []) {
							formData.append('files_noa_spp', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_oe || []) {
							formData.append('files_oe', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_bapp || []) {
							formData.append('files_bapp', file); // note, no square-brackets
						}
						for (let file of this.saveContract.files_fs || []) {
							formData.append('files_fs', file); // note, no square-brackets
						}
						formData.append('contract_duration_detail', contract_duration);
						formData.append('budget_plan_id', this.saveContract.budget_plan_id);
						formData.append('budget_gl_id', this.saveContract.budget_gl_id);
						formData.append('budget_task_id', this.saveContract.budget_task_id);

						// notification section
						// console.log(this.defaultRecipient);
						const email_cc =
							this.saveContract.email_cc.length < 1
								? [
										...new Set([
											// ...this.defaultRecipient,
											this.listUser.find((user) => user.id == this.saveContract.contract_owner)?.email,
											this.listUser.find((user) => user.id == this.saveContract.contract_co_owner)?.email,
										]),
								  ]
								: this.saveContract.email_cc;
						formData.append('email_cc', JSON.stringify(email_cc));
						formData.append('email_bcc', JSON.stringify(this.saveContract.email_bcc));
						formData.append('email_external', JSON.stringify(this.saveContract.email_external));
						let wa_number = this.saveContract?.whatsapp_number?.map((num) => {
							let sanitized = num.replace(/^0+/, '');
							return `62${sanitized}`;
						});
						formData.append('whatsapp_number', JSON.stringify(wa_number));

						try {
							this.$store
								.dispatch('listContract/updateContract', {
									bodys: formData,
									id: this.modalUpdate.id,
									status: status,
								})
								.then((resp) => {
									this.$swal('Success', 'Success update data', 'success');
									this.$bvModal.hide('modal-1');
									this.isLoading = false;
									this.getListContract();
									this.resetSaveContract();
								})
								.catch((err) => {
									this.isLoading = false;
									this.$swal('Error', err.response.data.error, 'error');
								});
						} catch (error) {
							this.isLoading = false;
							this.$swal('Error', 'Error while add data', 'error');
						}
					});
				} else {
					// contract number must be provided to ensure uniqueness
					// const validateContractNumber = await this.$validator.validate('Contract Number');
					// const validateTypeOfContract = await this.$validator.validate('Type Of Contract');
					// if (!validateContractNumber || !validateTypeOfContract) {
					// 	this.$swal
					// 		.mixin({
					// 			toast: true,
					// 			position: 'top-end',
					// 			showConfirmButton: false,
					// 			timer: 3000,
					// 			timerProgressBar: true,
					// 			didOpen: (toast) => {
					// 				toast.addEventListener('mouseenter', this.$swal.stopTimer);
					// 				toast.addEventListener('mouseleave', this.$swal.resumeTimer);
					// 			},
					// 		})
					// 		.fire({
					// 			icon: 'error',
					// 			title: 'At least contract number and type of contract must be provided',
					// 		});
					// 	this.tabIndex = 0;
					// 	return;
					// }
					let top = JSON.stringify(this.saveContract.term_of_payments);
					let contract_duration = JSON.stringify(this.saveContract.contract_duration_detail);
					this.saveContract.list_budget_gl = this.listBudgetTaskGL;
					let budgetGl = JSON.stringify(this.saveContract.list_budget_gl);
					let po_number = JSON.stringify(this.saveContract.po_number);
					// this.isLoading = true
					let oa_num = JSON.stringify(this.saveContract.oa_number);
					const formData = new FormData();
					formData.append('no', this.saveContract.no);
					formData.append('name', this.saveContract.name);
					formData.append('type_contract', this.saveContract.type_contract || '');
					formData.append('contract', this.saveContract.contract);
					formData.append('contract_owner', this.saveContract.contract_owner || '');
					// formData.append("budget", this.saveContract.budget)
					// formData.append("remaining_budget", this.saveContract.remaining_budget)
					formData.append('oa_number', oa_num);
					formData.append('vendor', this.saveContract.vendor);
					formData.append('start_date', this.saveContract.start_date);
					formData.append('end_date', this.saveContract.end_date);
					formData.append('scope_of_work', this.saveContract.scope_of_work);
					formData.append('term_of_payments', top);
					formData.append('po_number', po_number);
					formData.append('total_duration', this.saveContract.total_duration);
					formData.append('contract_co_owner', this.saveContract.contract_co_owner || '');
					formData.append('contract_value', this.unformatIDR(this.saveContract.contract_value));
					formData.append('list_budget_gl', budgetGl);
					for (let file of this.saveContract.files || []) {
						formData.append('files', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_tor || []) {
						formData.append('files_tor', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_boq || []) {
						formData.append('files_boq', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_noa_spp || []) {
						formData.append('files_noa_spp', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_oe || []) {
						formData.append('files_oe', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_bapp || []) {
						formData.append('files_bapp', file); // note, no square-brackets
					}
					for (let file of this.saveContract.files_fs || []) {
						formData.append('files_fs', file);
					}

					formData.append('contract_duration_detail', contract_duration);
					formData.append('budget_plan_id', this.saveContract.budget_plan_id);
					formData.append('budget_gl_id', this.saveContract.budget_gl_id);
					formData.append('budget_task_id', this.saveContract.budget_task_id);

					// notification section
					// console.log(this.defaultRecipient);
					const email_cc =
						this.saveContract.email_cc.length < 1
							? [
									...new Set([
										// ...this.defaultRecipient,
										this.listUser.find((user) => user.id == this.saveContract.contract_owner)?.email,
										this.listUser.find((user) => user.id == this.saveContract.contract_co_owner)?.email,
									]),
							  ]
							: this.saveContract.email_cc;
					formData.append('email_cc', JSON.stringify(email_cc.filter((email) => email)));
					formData.append('email_bcc', JSON.stringify(this.saveContract.email_bcc.filter((email) => email)));
					formData.append('email_external', JSON.stringify(this.saveContract.email_external));
					let wa_number = this.saveContract?.whatsapp_number?.map((num) => {
						let sanitized = num.replace(/^0+/, '');
						return `62${sanitized}`;
					});
					formData.append('whatsapp_number', JSON.stringify(wa_number));

					try {
						this.$store
							.dispatch(
								'listContract/updateContract',
								{
									bodys: formData,
									id: this.modalUpdate.id,
								},
								status,
								this.latestStatus
							)
							.then((resp) => {
								this.$swal('Success', 'Success update data', 'success');
								this.$bvModal.hide('modal-1');
								this.isLoading = false;
								this.getListContract();
								this.resetSaveContract();
							})
							.catch((err) => {
								this.isLoading = false;
								this.$swal('Error', err.response.data.error, 'error');
							});
					} catch (error) {
						this.isLoading = false;
						this.$swal('Error', 'Error while add data', 'error');
					}
				}
			},

			saveRenewalAmandement() {
				this.isLoading = true;
				let top = JSON.stringify(this.saveAmandement.term_of_payments);
				let contract_duration = JSON.stringify(this.saveAmandement.contract_duration_detail);
				let budgetGl = JSON.stringify(this.saveAmandement.list_budget_gl);
				let list_pr_po = JSON.stringify(this.saveAmandement.list_pr_po);
				let po_number = JSON.stringify(this.saveAmandement.po_number);
				let oa_number = JSON.stringify(this.saveAmandement.oa_number);

				// Add scope renewal status object
				let scopeRenewalStatus = {
					scope_of_work: this.scopeOfRenewalContractStatus.scope_of_work,
					contract_value: this.scopeOfRenewalContractStatus.contract_value,
					contract_duration: this.scopeOfRenewalContractStatus.contract_duration,
					term_of_payment: this.scopeOfRenewalContractStatus.term_of_payment,
					oa_number: this.scopeOfRenewalContractStatus.oa_number,
				};

				const formData = new FormData();
				formData.append('no', this.saveAmandement.no);
				formData.append('name', this.saveAmandement.name);
				formData.append('type_contract', this.saveAmandement.type_contract);
				formData.append('contract', this.saveAmandement.contract);
				formData.append('contract_owner', this.saveAmandement.contract_owner);
				formData.append('vendor', this.saveAmandement.vendor);
				formData.append('start_date', this.saveAmandement.start_date);
				formData.append('end_date', this.saveAmandement.end_date);
				formData.append('status', this.saveAmandement.status);
				formData.append('scope_of_work', this.saveAmandement.scope_of_work);
				formData.append('po_number', po_number);
				formData.append('term_of_payments', top);
				formData.append('total_duration', this.saveAmandement.total_duration);
				formData.append('budget_plan', this.saveAmandement.budget_plan);
				formData.append('budget_task', this.saveAmandement.budget_task);
				formData.append('contract_co_owner', this.saveAmandement.contract_co_owner);
				formData.append('contract_value', this.unformatIDR(this.saveAmandement.contract_value));
				formData.append('oa_number', oa_number);

				// Menambahkan file ke formData dengan validasi
				this.appendFilesIfNotEmpty(formData, 'files', this.saveAmandement.files);
				this.appendFilesIfNotEmpty(formData, 'files_tor', this.saveAmandement.files_tor);
				this.appendFilesIfNotEmpty(formData, 'files_boq', this.saveAmandement.files_boq);
				this.appendFilesIfNotEmpty(formData, 'files_noa_spp', this.saveAmandement.files_noa_spp);
				this.appendFilesIfNotEmpty(formData, 'files_oe', this.saveAmandement.files_oe);
				this.appendFilesIfNotEmpty(formData, 'files_bapp', this.saveAmandement.files_bapp);
				this.appendFilesIfNotEmpty(formData, 'files_fs', this.saveAmandement.files_fs);

				formData.append('contract_duration_detail', contract_duration);
				formData.append('budget_plan_id', this.saveAmandement.budget_plan_id);
				formData.append('budget_gl_id', this.saveAmandement.budget_gl_id);
				formData.append('budget_task_id', this.saveAmandement.budget_task_id);
				formData.append('budget_gl', this.saveAmandement.budget_gl);
				formData.append('list_budget_gl', budgetGl);
				formData.append('list_pr_po', list_pr_po);
				formData.append('scope_of_renewal_contract', JSON.stringify(scopeRenewalStatus));

				if (this.totalOverallPercentageAmandement != 100) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Total Percentage is less than 100%',
						});
					this.isLoading = false;
					return false;
				}

				this.$validator.validateAll().then(async (res) => {
					console.log(this.$validator.errors);
					if (!res) {
						this.$swal
							.mixin({
								toast: true,
								position: 'top-end',
								showConfirmButton: false,
								timer: 3000,
								timerProgressBar: true,
								didOpen: (toast) => {
									toast.addEventListener('mouseenter', this.$swal.stopTimer);
									toast.addEventListener('mouseleave', this.$swal.resumeTimer);
								},
							})
							.fire({
								icon: 'error',
								title: 'Mandatory field cannot be empty',
							});
						this.isLoading = false;
						return false;
					}
					try {
						this.$store
							.dispatch('listContract/UPDATE_AMANDEMENT', {
								bodys: formData,
								id: this.contractId,
							})
							.then((resp) => {
								this.$swal('Success', 'Success add amendment', 'success');
								this.$bvModal.hide('modal-amandemen');
								this.getListContract();
								this.isLoading = false;
								this.resetAllData();
							})
							.catch((err) => {
								this.isLoading = false;
								this.$swal('Error', err.response.data.error, 'error');
							});
					} catch (error) {
						this.isLoading = false;
						this.$swal('Error', 'Error while adding amendment', 'error');
					}
				});
			},
			appendFilesIfNotEmpty(formData, key, files) {
				if (files && files.length > 0) {
					for (let file of files) {
						formData.append(key, file);
					}
				}
			},
			getListContractByAmandement() {
				this.loading = true;
				this.$store
					.dispatch('listContract/GET_CONTRACT_BY_AMANDEMENT', {
						contractId: this.contractId,
						amandementNumber: this.selectedAmandemenType,
					})
					.then((resp) => {
						this.amandementDetail = resp.data;
						// console.log('Amandement Detail:', amandementDetail);
						this.loading = false;
					})
					.catch((err) => {
						console.error('Error fetching contract by amandement:', err);
						this.loading = false;
					});
			},
			resetSaveContract() {
				this.saveContract = {
					no: '',
					name: '',
					type_contract: '',
					contract: 'New Contract',
					contract_owner: '',
					budget: '',
					remaining_budget: '',
					vendor: '',
					start_date: '',
					end_date: '',
					scope_of_work: '',
					list_budget_gl: [],
					term_of_payments: {
						fixed_assignment: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
						provision: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
					},
					list_budget_task: [],
					po_number: '',
					total_duration: 0,
					budget_plan: '',
					budget_task: '',
					contract_co_owner: '',
					contract_value: '',
					oa_number: [],
					files: [],
					files_tor: [],
					files_boq: [],
					files_noa_spp: [],
					files_oe: [],
					files_bapp: [],
					files_fs: [],
					contract_duration_detail: {
						details: [],
					},
					budget_plan_id: '',
					budget_gl_id: '',
					budget_task_id: [],
					budget_gl: '',
					department_id: this.selectedDepartment?.id,
					email_cc: [],
					email_bcc: [],
					email_external: [],
					whatsapp_number: [],
				};
			},
			resetAfterChangeDepartment() {
				this.saveContract.list_budget_gl = [];
				this.saveContract.list_budget_task = [];
				this.saveContract.budget_plan_id = '';
				this.saveContract.budget_gl_id = '';
				this.saveContract.budget_task_id = [];
				this.saveContract.budget_gl = '';
				this.saveContract.contract_owner = '';
				this.saveContract.contract_co_owner = '';
				this.saveContract.contract_value = 0;
				this.saveContract.oa_number = [];
				this.listBudgetTaskGL = [];
				this.unsaveListBudgetTaskGL = [];
				this.saveContract.email_cc = [];
				this.saveContract.email_bcc = [];
				this.saveContract.email_external = [];
				this.saveContract.whatsapp_number = [];
			},
			resetAllData() {
				this.listAmandement = {};
				this.amandementDetail = {};
				this.selectedAmandemenType = '';
				this.selectedScopeRenewal = [];
				this.scopeOfRenewalContractStatus = {
					scope_of_work: false,
					contract_value: false,
					contract_duration: false,
					term_of_payment: false,
					oa_number: false,
				};
				this.saveAmandement = {
					no: '',
					name: '',
					type_contract: '',
					contract: '',
					contract_owner: '',
					vendor: '',
					start_date: '',
					end_date: '',
					status: '',
					contract_value: 0,
					scope_of_work: '',
					term_of_payments: {
						fixed_assignment: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
						provision: {
							percentage: '',
							amount: '',
							contract_items: [],
						},
					},
					total_duration: 0,
					budget_plan: '',
					budget_task: '',
					contract_co_owner: '',
					oa_number: [],
					files: [],
					files_tor: [],
					files_boq: [],
					files_noa_spp: [],
					files_oe: [],
					files_bapp: [],
					files_fs: [],
					contract_duration_detail: {
						details: [],
					},
					budget_plan_id: '',
					budget_gl_id: '',
					budget_task_id: [],
					budget_gl: '',
					list_budget_gl: [],
					list_pr_po: [],
					scope_of_renewal_contract: [],
				};
			},
			confirmClose(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.$swal({
						title: 'Confirm Close?',
						text: 'Are you sure want to close this page?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Yes',
					}).then((result) => {
						if (result.isConfirmed) {
							this.resetAllData();
							this.$bvModal.hide('modal-amandemen');
						}
					});
				}
			},
			getNotification() {
				this.$store.dispatch('notification/GET_LIST', this.bodyEmail);
			},
			closeNotification(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.$swal({
						title: 'Confirm Close?',
						text: 'Are you sure want to close this page?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Yes',
					}).then((result) => {
						if (result.isConfirmed) {
							this.$bvModal.hide('modal-notification');
							this.modalNotification.notification = [];
							this.modalNotification.email_cc = [];
							this.modalNotification.email_bcc = [];
							this.modalNotification.whatsapp_number = [];
							this.modalNotification.email_external = [];
						}
					});
				}
			},
			submitNotification() {
				if (this.modalNotification.notification.length === 0) {
					this.$swal('Validation Error', 'Please select at least one notification', 'error');
					return;
				}
				// Cek apakah ada notifikasi email yang dipilih (yang memiliki email=true)
				const emailNotificationSelected = this.modalNotification.notification.some((notif) => notif.email === true);
				console.log('emailNotificationSelected', emailNotificationSelected);

				// Cek apakah ada notifikasi WhatsApp yang dipilih (yang memiliki whatsapp=true)
				const whatsappNotificationSelected = this.modalNotification.notification.some((notif) => notif.whatsapp === true);

				// Validasi jika notifikasi email dipilih, maka harus ada email yang diisi
				if (this.emailActive && this.notificationRecipientEmails.length < 1) {
					this.$swal(
						'Validation Error',
						'You have selected email notification, please fill in at least one email address in CC or BCC',
						'error'
					);
					return;
				}

				// Validasi jika notifikasi WhatsApp dipilih, maka harus ada nomor yang diisi
				if (this.whatsappActive) {
					if (this.modalNotification.whatsapp_number.length === 0) {
						this.$swal(
							'Validation Error',
							'You have selected WhatsApp notification, please fill in at least one WhatsApp number',
							'error'
						);
						return;
					}

					// Validasi nilai nomor WhatsApp tidak boleh kosong
					const emptyNumberIndex = this.modalNotification.whatsapp_number.findIndex((num) => !num || num.trim() === '');
					if (emptyNumberIndex !== -1) {
						this.$swal('Validation Error', `WhatsApp number ${emptyNumberIndex + 1} cannot be empty`, 'error');
						return;
					}
				}

				this.$validator.validateAll().then(async (res) => {
					if (!res) {
						this.$swal('Validation Error', 'Please check and fill in all required fields', 'error');
						return false;
					}
					let wa_number = this.modalNotification.whatsapp_number.map((num) => {
						let sanitized = num.replace(/^0+/, '');
						return `62${sanitized}`;
					});
					const formData = {
						notification: this.modalNotification.notification,
						email_cc: this.modalNotification.email_cc,
						email_bcc: this.modalNotification.email_bcc,
						whatsapp_number: wa_number,
						email_external: this.modalNotification.email_external,
					};

					// new FormData();
					// formData.append('notification', JSON.stringify(this.modalCreate.notification));
					// formData.append('email_cc', JSON.stringify(this.modalCreate.email_cc));
					// formData.append('email_bcc', JSON.stringify(this.modalCreate.email_bcc));
					// formData.append('whatsapp_number', JSON.stringify(wa_number));
					// formData.append('email_external', JSON.stringify(this.modalCreate.email_external));
					let data = {
						id: this.modalUpdate.id,
						body: JSON.stringify(formData),
					};
					this.isLoading = true;
					this.$store
						.dispatch('listContract/SEND_NOTIFICATION', data)
						.then((resp) => {
							this.$bvModal.hide('modal-notification');
							this.modalNotification.notification = [];
							this.modalNotification.email_cc = [];
							this.modalNotification.email_bcc = [];
							this.modalNotification.whatsapp_number = [];
							this.modalNotification.email_external = [];
							this.$swal('Success Send!', 'Success send notification', 'success');
						})
						.catch((err) => {
							this.$swal('Error', err.response.data.error, 'error');
						});
					this.isLoading = false;
				});
			},

			// submitNotification() {
			//   this.$validator.validateAll().then(async (res) => {
			//     if (!res) {
			//       this.$swal("Validasi Error", "Harap periksa dan perbaiki semua field yang ditandai error", "error");
			//       return false;
			//     }
			//     const updatedAdditionalDatas = this.modalCreate.notification.map(n => {
			//       const numbers = n.additionalDatas.whatsapp_number || [];
			//       const updatedNumbers = numbers.map(num => {
			//         const str = String(num);
			//         return str.startsWith('62') ? str : '62' + str;
			//       });

			//       return {
			//         ...n.additionalDatas,
			//         whatsapp_number: updatedNumbers
			//       };
			//     });
			//     let data = {
			//       id: this.modalUpdate.id,
			//       body: updatedAdditionalDatas
			//     };

			//     this.isLoading = true;
			//     this.$store.dispatch("listContract/SEND_NOTIFICATION", data).then((resp) => {
			//       this.$bvModal.hide("modal-notification")
			//       this.isLoading = false;
			//       this.modalCreate.notification = [];
			//       this.$swal("Success Send!", "Success send notification", "success");
			//     }).catch((err) => {
			//       this.isLoading = false;
			//     });
			//   });
			// },
			async getListTypeContract() {
				let body = {
					page: 1,
					limit: 10,
					order: '',
				};
				await this.$store.dispatch('type_contract/GET_LIST', body);
			},
			async getVendor() {
				if (this.listVendor.length > 0) return;
				await this.$store.dispatch('listContract/GET_VENDOR', this.bodyMyContract);
			},
			async getPO() {
				await this.$store.dispatch('listContract/GET_PO');
			},
			async getUser() {
				await this.$store.dispatch('listContract/GET_USER', { department_id: this.saveContract.department_id }).then(() => {
					this.listUser = this.$store.getters['listContract/listUser'] || [];
				});
			},
			async getListContract() {
				this.load = true;
				if (this.$route.params.id) {
					await this.$store.dispatch('listContract/GET_BY_ID', this.$route.params.id).then(() => {
						const data = this.$store.getters['listContract/detail'];
						this.listContract = {
							data: [data],
							totalItems: 1,
						};
						this.load = false;
					});
				} else {
					await this.$store.dispatch('listContract/GET_LIST', this.body).then(() => {
						const data = this.$store.getters['listContract/list'];
						this.listContract = data;
						this.load = false;
					});
				}
			},
			async getListAmandement(id) {
				this.load = true;
				await this.$store
					.dispatch('listContract/GET_AMANDEMENT_LIST_BY_ID', id)
					.then(() => {
						const data = this.$store.getters['listContract/listAmandement'];
						this.listAmandement = data;
						if (this.listAmandement && this.listAmandement.length >= 5) {
							this.resetAllData();
							this.load = false;
							this.$bvModal.hide('modal-amandemen');
							return this.$swal('Error', 'Contract amendment is not allowed more than 5 times.', 'error');
						} else if (this.listAmandement && this.listAmandement.length > 0) {
							this.selectedAmandemenType = this.listAmandement[0].amandement;
						} else {
							this.selectedAmandemenType = null;
						}
						// this.postgetListContractByAmandement(id, this.selectedAmandemenType);
						this.load = false;
					})
					.catch((resp) => {
						this.load = false;
					});
			},
			async postgetListContractByAmandement(contract_id, amandement_number) {
				this.load = true;
				const body = {
					contractId: contract_id,
					amandementNumber: amandement_number,
				};
				try {
					await this.$store.dispatch('listContract/GET_CONTRACT_BY_AMANDEMENT', body);
					this.amandementDetail = this.$store.getters['listContract/amandementDetail'];
					if (!this.amandementDetail) {
						console.warn('No amandementDetail returned from store');
					} else {
						// console.log("POST GET amandement type", this.amandementDetail);
					}
				} catch (error) {
					console.error('ERROR GET CONTRACT BY AMANDEMENT', error);
					this.amandementDetail = null;
				} finally {
					this.load = false;
				}
			},

			async getListContractById(id) {
				this.load = true;
				try {
					await this.$store.dispatch('listContract/GET_FOR_EDIT', id);
					const data = this.$store.getters['listContract/detail'];
					this.detailContract = data;
				} catch (error) {
					console.error('Error fetching contract by ID:', error);
				} finally {
					this.load = false;
				}
			},
			normalizeOAResponse(data) {
				if (Array.isArray(data)) {
					return data.map((item, index) => ({
						no: item.no || index + 1,
						oa_number: typeof item === 'object' ? item.oa_number : item,
						...item,
					}));
				}

				if (data !== null && data !== undefined) {
					return [
						{
							no: 1,
							oa_number: data,
						},
					];
				}

				return [];
			},
			async amandementContract(props) {
				this.contractId = props.id;
				// this.getListAmandement(props.id);
				await this.getListContractById(props.id).then(() => {
					this.$bvModal.show('modal-amandemen');
				});
				// this.detailContract = props;
				// this.amandementDetail = props;
				console.log('detail contract amandement', this.detailContract);
			},
			async appendDataAmandement() {
				// if (Object.values(this.listAmandement).length > 0 && !this.selectedAmandemenType) {
				//   return this.$swal("Error", "Amandemen type must be selected", "error");
				// }

				if (!this.detailContract) {
					console.error('No detail contract found for contractId:', this.contractId);
					return;
				}

				// Tentukan sumber data
				let sourceData = this.detailContract;
				let normalizedOaNumber = this.normalizeOAResponse(sourceData.oa_number);

				this.saveAmandement.budget_task = sourceData?.list_budget_gl?.map((item) => item.budget_task_name);
				// if (Object.values(this.listAmandement).length == 0 || !this.listAmandement) {
				//   sourceData = this.detailContract;
				//   this.saveAmandement.budget_task = sourceData.list_budget_gl.map(item => item.budget_task_name);
				// } else {
				//   sourceData = this.amandementDetail;
				//   this.saveAmandement.budget_task = sourceData.budget_task && sourceData.budget_task.length > 0 ? sourceData.budget_task : this.detailContract.list_budget_gl.map(item => item.budget_task_name);
				//   this.saveAmandement.list_budget_gl = sourceData.list_budget_gl && sourceData.list_budget_gl.length > 0
				//   ? sourceData.list_budget_gl
				//   : this.detailContract.list_budget_gl;
				// }

				// Append semua field ke saveAmandement
				// this.$store.dispatch("listContract/GET_USER_UENROLL", {
				//   search: sourceData.owner.email,
				//   limit: 10,
				//   page: 1
				// }).then(() => {
				//       let data = this.$store.getters["listContract/userUenroll"];
				//       this.list_owner = data
				//   });
				// this.$store.dispatch("listContract/GET_USER_UENROLL", {
				//   search: sourceData.co_owner.email,
				//   limit: 10,
				//   page: 1
				// }).then(() => {
				//       let data = this.$store.getters["listContract/userUenroll"];
				//       this.list_co_owner = data
				// });
				this.saveAmandement.no = sourceData.no;
				this.saveAmandement.name = sourceData.name;
				this.saveAmandement.tipe_contract = this.detailContract.typeContract.name;
				this.saveAmandement.type_contract = sourceData.type_contract;
				this.saveAmandement.contract = sourceData.contract;
				this.saveAmandement.contract_owner = sourceData.owner.id;
				this.saveAmandement.owner = this.detailContract.owner.fullname;
				this.saveAmandement.vendor = sourceData.vendor;
				this.saveAmandement.start_date = sourceData.start_date;
				this.saveAmandement.end_date = sourceData.end_date;
				this.saveAmandement.status = sourceData.status;
				this.saveAmandement.contract_value = formatCurrency(sourceData.contract_value);
				this.saveAmandement.scope_of_work = sourceData.scope_of_work;
				this.saveAmandement.po_number = sourceData.po_number;

				if (
					!sourceData.term_of_payments.fixed_assignment.contract_items &&
					!sourceData.term_of_payments.provision.contract_items
				) {
					this.saveAmandement.term_of_payments.fixed_assignment.contract_items =
						sourceData.term_of_payments.fixed_assignment;
					this.saveAmandement.term_of_payments.provision.contract_items = sourceData.term_of_payments.provision;
				} else {
					this.saveAmandement.term_of_payments.fixed_assignment = sourceData.term_of_payments.fixed_assignment;
					this.saveAmandement.term_of_payments.provision = sourceData.term_of_payments.provision;
				}

				// this.saveAmandement.term_of_payments.fixed_assignment = sourceData.term_of_payments.fixed_assignment;
				// this.saveAmandement.term_of_payments.provision = sourceData.term_of_payments.provision;
				this.saveAmandement.total_duration = sourceData.total_duration;
				this.saveAmandement.budget_plan = sourceData.budget_plan;
				// this.saveAmandement.budget_task = sourceData.budget_task;
				this.saveAmandement.contract_co_owner = sourceData.co_owner.id;
				this.saveAmandement.co_owner = this.detailContract.co_owner.fullname;
				this.saveAmandement.oa_number = normalizedOaNumber;

				// Append field tambahan
				this.saveAmandement.contract_duration_detail.details = sourceData.contract_duration_detail?.details;
				this.saveAmandement.budget_plan_id = sourceData.budget_plan_id;
				this.saveAmandement.budget_gl_id = sourceData.budget_gl_id;
				this.saveAmandement.budget_task_id = sourceData.budget_task_id;
				this.saveAmandement.budget_gl = sourceData.budget_gl;
				this.saveAmandement.list_budget_gl = sourceData.list_budget_gl;
				this.saveAmandement.list_pr_po = sourceData.list_pr_po;

				// Proses semua file
				const tipeFile = [
					{
						key: 'files',
						sourceKey: 'files',
					},
					{
						key: 'files_tor',
						sourceKey: 'upload_tor',
					},
					{
						key: 'files_boq',
						sourceKey: 'upload_boq',
					},
					{
						key: 'files_noa_spp',
						sourceKey: 'upload_noa_spp',
					},
					{
						key: 'files_oe',
						sourceKey: 'upload_oe',
					},
					{
						key: 'files_bapp',
						sourceKey: 'upload_bapp',
					},
					{
						key: 'files_fs',
						sourceKey: 'upload_fs',
					},
				];

				for (const { key, sourceKey } of tipeFile) {
					const filesArray = [];
					const container = new DataTransfer();
					const sourceFiles = sourceData[sourceKey] || [];
					// console.log("Source Files:", sourceFiles);

					for (let i = 0; i < sourceFiles.length; i++) {
						const { name, file: image_url } = sourceFiles[i];
						try {
							const response = await fetch(image_url, {
								headers: {
									'Access-Control-Allow-Origin': '*',
								},
							});
							if (!response.ok) throw new Error(`Gagal mengambil file ${name}`);
							const blob = await response.blob();
							const file = new File([blob], name, {
								type: blob.type,
							});
							filesArray.push(file);
							container.items.add(file);
							// console.log("File:", file);
						} catch (error) {
							console.error(`Error mengambil file ${name}:`, error);
						}
					}

					this.saveAmandement[key] = container.files;
					this.$refs[`amandement_${key}`].files = container.files;
				}

				// console.log("Data Save Amandemen:", this.saveAmandement);
				// console.log("Files dari Save Amandement", this.saveAmandement.files, this.saveAmandement.files_bapp, this.saveAmandement.files_boq, this.saveAmandement.files_fs, this.saveAmandement.files_noa_spp, this.saveAmandement.files_oe, this.saveAmandement.files_tor, this.saveAmandement.files);
			},
			// modalClose() {

			// },
			getListBudgetPlan() {
				this.$store.dispatch('listContract/GET_BUDGET_PLAN');
			},
			getListBudgetTask() {
				this.saveContract.budget_gl_id = '';
				this.saveContract.budget_task_id = '';
				this.remainingBudgets = '';
				if (this.saveContract.budget_plan_id)
					this.$store.dispatch('listContract/GET_BUDGET_GL', this.saveContract.budget_plan_id);
			},
			getListBudgetTaskforEdit() {
				this.editGL.budget_gl_id = '';
				this.editGL.budget_task_id = '';
				this.remainingBudgets = '';
				this.$store.commit('listContract/SET_BUDGET_GL', []);
				this.$store.commit('listContract/SET_BUDGET_TASK', []);
				if (this.editGL.budget_plan_id) this.$store.dispatch('listContract/GET_BUDGET_GL', this.editGL.budget_plan_id);
			},
			async sendNotification(props) {
				await this.getListContractById(props.id).then(async () => {
					await this.setSelectedDepartment();
					const data = this.$store.getters['listContract/detail'];
					props = data;
				});
				this.modalUpdate.id = props.id;
				this.modalNotification.email_cc =
					Array.isArray(props.notification_config?.notification?.email_cc) &&
					props.notification_config?.notification?.email_cc.length > 0
						? props.notification_config?.notification?.email_cc
						: [
								...new Set([
									// ...this.defaultRecipient,
									this.listUser.find((user) => user.id == props.owner.id)?.email,
									this.listUser.find((user) => user.id == props.co_owner.id)?.email,
								]),
						  ];

				this.modalNotification.email_bcc =
					Array.isArray(props.notification_config?.notification?.email_bcc) &&
					props.notification_config?.notification?.email_bcc.length > 0
						? props.notification_config?.notification?.email_bcc
						: [];
				this.modalNotification.email_external =
					Array.isArray(props.notification_config?.notification?.email_external) &&
					props.notification_config?.notification?.email_external.length > 0
						? props.notification_config?.notification?.email_external
						: [];
				this.modalNotification.whatsapp_number =
					Array.isArray(props.notification_config?.notification?.whatsapp_number) &&
					props.notification_config?.notification?.whatsapp_number.length > 0
						? props.notification_config?.notification?.whatsapp_number.map((num) => '0' + num.slice(2))
						: [];
				this.$bvModal.show('modal-notification');
			},
			async updateMyContract(props) {
				try {
					await this.getListContractById(props.id).then(() => {
						const data = this.$store.getters['listContract/detail'];
						props = data;
					});
					if (!props) {
						// console.error("No detail contract found for contractId:", props.id);
						return;
					}
					// console.log("Detail Contract:", props);
				} catch (error) {
					// console.error("Error fetching contract by ID:", error);
					// props = this.listMyContract.data.find(contract => contract.id === props.id);
					return;
				}
				// this.$store.dispatch("listContract/GET_USER_UENROLL", {
				//   search: props.owner.email,
				//   limit: 10,
				//   page: 1
				// }).then(() => {
				//       let data = this.$store.getters["listContract/userUenroll"];
				//       this.list_owner = data
				//   });
				// this.$store.dispatch("listContract/GET_USER_UENROLL", {
				//   search: props.co_owner.email,
				//   limit: 10,
				//   page: 1
				// }).then(() => {
				//       let data = this.$store.getters["listContract/userUenroll"];
				//       this.list_co_owner = data
				// });
				let normalizedOaNumber = this.normalizeOAResponse(props.oa_number);

				this.$bvModal.show('modal-1');
				this.latestStatus = props.status;
				this.isAdd = false;
				// const activePlan = this.ListBudgetPlan.find(plan => plan.is_active);
				// if (activePlan) {
				//   this.saveContract.budget_plan_id = activePlan.id;
				// }
				this.modalUpdate.id = props.id;
				this.saveContract.no = props.no;
				this.saveContract.name = props.name;
				// this.saveContract.budget_gl_id = props.budget_gl_id;
				this.saveContract.department_id = parseInt(props.department_id);
				this.saveContract.type_contract = props.typeContract?.id || '';
				this.saveContract.oa_number = normalizedOaNumber;
				const coOwner = this.listUser.find((user) => user.id == props.co_owner?.id);
				const owner = this.listUser.find((user) => user.id == props.owner?.id);
				this.saveContract.contract_owner = props.owner?.id || '';
				this.saveContract.contract_co_owner = props.co_owner?.id || '';

				this.saveContract.vendor = props.vendor;
				this.saveContract.contract_value = formatCurrency(props.contract_value);
				this.saveContract.scope_of_work = props.scope_of_work;
				this.saveContract.start_date = props.start_date;
				this.saveContract.end_date = props.end_date;
				this.saveContract.status = props.status;
				this.saveContract.po_number = props.po_number;
				this.saveContract.total_duration = props.total_duration;
				this.saveContract.contract_duration_detail.details = props.contract_duration_detail.details;

				if (!props.term_of_payments.fixed_assignment.contract_items && !props.term_of_payments.provision.contract_items) {
					this.saveContract.term_of_payments.fixed_assignment.contract_items = props.term_of_payments.fixed_assignment;
					this.saveContract.term_of_payments.provision.contract_items = props.term_of_payments.provision;
				} else {
					this.saveContract.term_of_payments.fixed_assignment = props.term_of_payments.fixed_assignment;
					this.saveContract.term_of_payments.provision = props.term_of_payments.provision;
				}

				// this.$store.dispatch("listContract/GET_BUDGET_TASK", props.budget_gl_id).then((resp) => {
				//   // let data = this.$store.getters["listContract/listBudgetTask"];
				//   // this.saveContract.budget_task_id =
				//   //   typeof props.budget_task_id === 'string' && props.budget_task_id.includes(',') ?
				//   //   props.budget_task_id.split(',') : [String(props.budget_task_id)];

				//   // let body = {
				//   //   plan_budget_ids: this.saveContract.budget_task_id =
				//   //     typeof props.budget_task_id === 'string' && props.budget_task_id.includes(',') ?
				//   //     props.budget_task_id.split(',') : [String(props.budget_task_id)],
				//   //   oa_number: ''
				//   // };
				//   // this.$store.dispatch("listContract/GET_BUDGET_TASK_DETAIL", body);
				// });
				this.listBudgetTaskGL = props.list_budget_gl;
				this.saveContract.email_cc =
					Array.isArray(props.notification_config?.notification?.email_cc) &&
					props.notification_config?.notification?.email_cc.length > 0
						? props.notification_config?.notification?.email_cc.filter((email) => email)
						: [
								...new Set([
									// ...this.defaultRecipient,
									this.listUser.find((user) => user.id == props.owner.id)?.email,
									this.listUser.find((user) => user.id == props.co_owner.id)?.email,
								]),
						  ].filter((item) => item);

				this.saveContract.email_bcc =
					Array.isArray(props.notification_config?.notification?.email_bcc) &&
					props.notification_config?.notification?.email_bcc.length > 0
						? props.notification_config?.notification?.email_bcc.filter((email) => email)
						: [];
				this.saveContract.email_external =
					Array.isArray(props.notification_config?.notification?.email_external) &&
					props.notification_config?.notification?.email_external.length > 0
						? props.notification_config?.notification?.email_external.filter((email) => email)
						: [];
				this.saveContract.whatsapp_number =
					Array.isArray(props.notification_config?.notification?.whatsapp_number) &&
					props.notification_config?.notification?.whatsapp_number.length > 0
						? props.notification_config?.notification?.whatsapp_number.map((num) => '0' + num.slice(2))
						: [];

				// add owner and co-owner in listUser for display select dropdown
				this.setSelectedDepartment().then(() => {
					const users = new Map();
					this.listUser.forEach((e) => users.set(e.id, e));
					if (props.owner && !users.has(props.owner.id)) {
						users.set(props.owner.id, props.owner);
					}
					if (props.co_owner && !users.has(props.co_owner.id)) {
						users.set(props.co_owner.id, props.co_owner);
					}
					this.listUser = this.listUser = users.size > 0 ? Array.from(users.values()) : [];
					this.setOwnerDepartment(props.owner?.id);
					this.setCoOwnerDepartment(props.co_owner?.id);
					// console.log('listUser', this.listUser);
				});
				// Upload Tor
				const files_tor = [];
				let i = 0;
				let container_tor = new DataTransfer();
				while (i < props.upload_tor.length) {
					const image = props.upload_tor[i].name;
					const image_url = props.upload_tor[i].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});
					// console.log(response);

					files_tor.push(file);
					container_tor.items.add(file);
					i++;
					this.saveContract.files_tor = container_tor.files;
					// console.log('qwer', container);
				}
				if (this.$refs.fileTor?.files) this.$refs.fileTor.files = container_tor.files;

				// Upload Boq
				const files_boq = [];
				let q = 0;
				let container_boq = new DataTransfer();
				while (q < props.upload_boq.length) {
					const image = props.upload_boq[q].name;
					const image_url = props.upload_boq[q].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});
					// console.log(response);

					files_boq.push(file);
					container_boq.items.add(file);
					q++;
					this.saveContract.files_boq = container_boq.files;
					// console.log('qwer', container);
				}
				if (this.$refs.fileBoq?.files) this.$refs.fileBoq.files = container_boq.files;

				// Upload Noa
				const files_noa = [];
				let w = 0;
				let container_noa = new DataTransfer();
				while (w < props.upload_noa_spp.length) {
					const image = props.upload_noa_spp[w].name;
					const image_url = props.upload_noa_spp[w].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});
					// console.log(response);

					files_noa.push(file);
					container_noa.items.add(file);
					w++;
					this.saveContract.files_noa_spp = container_noa.files;
				}
				if (this.$refs.fileNoa?.files) this.$refs.fileNoa.files = container_noa.files;

				// Upload oe
				const files_oe = [];
				let e = 0;
				let container_oe = new DataTransfer();
				while (e < props.upload_oe.length) {
					const image = props.upload_oe[e].name;
					const image_url = props.upload_oe[e].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});

					files_oe.push(file);
					container_oe.items.add(file);
					e++;
					this.saveContract.files_oe = container_oe.files;
				}
				if (this.$refs.fileOe?.files) this.$refs.fileOe.files = container_oe.files;

				// Upload FS
				const files_fs = [];
				let f = 0;
				let container_fs = new DataTransfer();
				while (f < props.upload_fs.length) {
					const image = props.upload_fs[f].name;
					const image_url = props.upload_fs[f].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});

					files_fs.push(file);
					container_fs.items.add(file);
					f++;
					this.saveContract.files_fs = container_fs.files;
				}
				if (this.$refs.fileFs?.files) this.$refs.fileFs.files = container_fs.files;

				// Upload BAPP
				const files_bapp = [];
				let p = 0;
				let container_bapp = new DataTransfer();
				while (p < props.upload_bapp.length) {
					const image = props.upload_bapp[p].name;
					const image_url = props.upload_bapp[p].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});

					files_bapp.push(file);
					container_bapp.items.add(file);
					p++;
					this.saveContract.files_bapp = container_bapp.files;
				}
				if (this.$refs.fileBapp?.files) this.$refs.fileBapp.files = container_bapp.files;

				// Upload Others
				const files = [];
				let x = 0;
				let container_others = new DataTransfer();
				while (x < props.files.length) {
					const image = props.files[x].name;
					const image_url = props.files[x].file;
					const response = await fetch(image_url, {
						headers: {
							'Access-Control-Allow-Origin': '*',
						},
					});
					const blob = await response.blob();
					const file = new File([blob], image, {
						type: blob.type,
					});

					files.push(file);
					container_others.items.add(file);
					x++;
					this.saveContract.files = container_others.files;
				}
				if (this.$refs.fileOther?.files) this.$refs.fileOther.files = container_others.files;

				// console.log('updateMyContract', this.saveContract);
			},
			deleteMyContract(props) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('listContract/DELETE_DATA', props)
							.then((resp) => {
								this.getListContract();
								this.$swal('Deleted!', 'Your contract has been deleted', 'success');
							})
							.catch((resp) => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},
			// detailContract() {},
			detailMyContract(props) {
				// console.log("detail my contract", props);
			},
			onSortMyContract(event) {
				this.bodyMyContract.order = event[0].type == 'none' ? '' : event[0].type;
				this.getListContract();
			},

			getTotalDuration(tipe, start, end) {
				axiosIns
					.post(`${axiosIns.defaults.baseURL}/contract/calculate-duration`, {
						start_date: start,
						end_date: end,
					})
					.then((resp) => {
						let data = resp.data.data;
						if (tipe == 'amandement') {
							this.saveAmandement.total_duration = data.total_months;
						} else {
							this.saveContract.total_duration = data.total_months;
						}
					});
			},

			getDetailContract(props) {
				console.log(props);
			},

			detailNotification(props) {
				this.$bvModal.show('DetailNotif');
				this.detailNotif = props;
			},

			changesPercentageFA(event, index, itmIndex) {
				let inputValue = Number(event.target.value); // Convert input value to number

				if (isNaN(inputValue) || inputValue < 0) {
					// Prevent negative or invalid values
					this.$set(this.saveContract.term_of_payments.fixed_assignment[index].terms[itmIndex], 'percentage', 0);
				} else {
					// Temporarily set value to input (max 100)
					this.$set(
						this.saveContract.term_of_payments.fixed_assignment[index].terms[itmIndex],
						'percentage',
						Math.min(inputValue, 100)
					);
				}

				// Update total percentage
				this.updateTotalPercentage(index, itmIndex);

				// Check if total exceeds 100
				const total = this.totalFixedPercentage + this.totalProvisionPercentage;

				if (total > 100) {
					// Reset the current term to 0 if total exceeds 100
					this.$set(this.saveContract.term_of_payments.fixed_assignment[index].terms[itmIndex], 'percentage', 0);
					// Update totals again after reset
					this.updateTotalPercentage(index, itmIndex);
				}
			},

			updateTotalPercentage(index, itmIndex) {
				// Calculate total percentage dynamically based on term percentages
				let total = this.saveContract.term_of_payments.fixed_assignment[index].terms.reduce(
					(sum, item) => sum + Number(item.percentage || 0),
					0
				);

				// if (total > 100) {
				//   this.$swal.mixin({
				//     toast: true,
				//     position: "top-end",
				//     showConfirmButton: false,
				//     timer: 3000,
				//     timerProgressBar: true,
				//     didOpen: (toast) => {
				//       toast.addEventListener("mouseenter", this.$swal.stopTimer);
				//       toast.addEventListener("mouseleave", this.$swal.resumeTimer);
				//     }
				//   }).fire({
				//     icon: "error",
				//     title: `Total Percentage cannot exceed 100%`
				//   });

				//   // Reset the last entered value to 0
				//   this.$set(this.saveContract.term_of_payments.fixed_assignment[index].terms[itmIndex], "percentage", 0);

				//   // Recalculate total after resetting value
				//   total = this.saveContract.term_of_payments.fixed_assignment[index].terms.reduce(
				//     (sum, item) => sum + Number(item.percentage || 0),
				//     0
				//   );
				// }

				this.$set(this.saveContract.term_of_payments.fixed_assignment[index], 'total_percentage', total);
			},

			changesPercentagePro(event, index, itmIndex) {
				let inputValue = Number(event.target.value); // Convert input value to number

				if (isNaN(inputValue) || inputValue < 0) {
					// Prevent negative or invalid values
					this.$set(this.saveContract.term_of_payments.provision[index].terms[itmIndex], 'percentage', 0);
				} else {
					// Temporarily set value to input (max 100)
					this.$set(
						this.saveContract.term_of_payments.provision[index].terms[itmIndex],
						'percentage',
						Math.min(inputValue, 100)
					);
				}

				// Update total percentage
				this.updateTotalPercentagePro(index, itmIndex);

				// Check if total exceeds 100
				const total = this.totalFixedPercentage + this.totalProvisionPercentage;
				console.log(total);

				if (total > 100) {
					// Reset the current term to 0 if total exceeds 100
					this.$set(this.saveContract.term_of_payments.provision[index].terms[itmIndex], 'percentage', 0);
					// Update the totals again after reset
					this.updateTotalPercentagePro(index, itmIndex);
				}
			},
			updateTotalPercentagePro(index, itmIndex) {
				// Calculate total percentage dynamically based on term percentages
				let total = this.saveContract.term_of_payments.provision[index].terms.reduce(
					(sum, item) => sum + Number(item.percentage || 0),
					0
				);

				// if (total > 100) {
				//   this.$swal.mixin({
				//     toast: true,
				//     position: "top-end",
				//     showConfirmButton: false,
				//     timer: 3000,
				//     timerProgressBar: true,
				//     didOpen: (toast) => {
				//       toast.addEventListener("mouseenter", this.$swal.stopTimer);
				//       toast.addEventListener("mouseleave", this.$swal.resumeTimer);
				//     }
				//   }).fire({
				//     icon: "error",
				//     title: `Total Percentage cannot exceed 100%`
				//   });

				//   // Reset the last entered value to 0
				//   this.$set(this.saveContract.term_of_payments.provision[index].terms[itmIndex], "percentage", 0);

				//   // Recalculate total after resetting value
				//   total = this.saveContract.term_of_payments.provision[index].terms.reduce(
				//     (sum, item) => sum + Number(item.percentage || 0),
				//     0
				//   );
				// }

				this.$set(this.saveContract.term_of_payments.provision[index], 'total_percentage', total);
			},

			selectBudgetTask(id) {
				this.saveContract.budget_task_id = [];
				this.unsavelistBudgetTaskGL = [];
				this.remainingBudgets = '';
				if (id) {
					this.$store.dispatch('listContract/GET_BUDGET_TASK', id).then((resp) => {
						// this.list_budget_task = this.$store.getters["listContract/listBudgetTask"]
						// console.log(data);
					});
				}
			},
			selectBudgetTaskforEdit(id) {
				this.editGL.budget_task_id = '';
				this.remainingBudgets = '';
				this.$store.commit('listContract/SET_BUDGET_TASK', []);
				if (id) {
					this.$store.dispatch('listContract/GET_BUDGET_TASK', id).then((resp) => {
						this.editGL.budget_task_id = [];
						// this.list_budget_task = this.$store.getters["listContract/listBudgetTask"]
						// console.log(data);
					});
				}
			},

			calculateDuration() {
				if (!this.saveContract.start_date || !this.saveContract.end_date) {
					return '';
				}

				let startDate = new Date(this.saveContract.start_date);
				let endDate = new Date(this.saveContract.end_date);

				if (startDate > endDate) {
					return 'Invalid Date Range';
				}

				let timeDiff = endDate - startDate;
				let daysDiff = timeDiff / (1000 * 60 * 60 * 24); // Convert ms to days

				return Math.ceil(daysDiff / 28); // Each 28 days is 1 month
			},
			minDate() {
				return moment().format('YYYY-MM-DD');
			},
			endMin(d) {
				return moment(d).format('YYYY-MM-DD');
			},

			selectBudgetTaskDetail() {
				let body = {
					plan_budget_ids: [this.saveContract.budget_task_id],
					oa_number: '',
				};
				this.remainingBudgets = '';
				if (this.saveContract?.budget_task_id) {
					this.$store.dispatch('listContract/GET_BUDGET_TASK_DETAIL', body).then((resp) => {
						let data = this.unsaveListBudgetTaskGL;
						let currency = data[0].remaining_budget;
						let formattedCurrency = formatCurrency(currency);
						this.remainingBudgets = formattedCurrency;
					});
				}
			},

			selectBudgetTaskDetail2() {
				let body = {
					plan_budget_ids: [this.editGL.budget_task_id],
					oa_number: '',
				};
				this.$store.dispatch('listContract/GET_BUDGET_TASK_DETAIL', body).then((resp) => {
					let data = this.$store.getters['listContract/listBudgetTaskDetail'];
					let currency = data[0].remaining_budget;
					let formattedCurrency = formatCurrency(currency);
					this.editGL.remaining_budget = formattedCurrency;
					this.editGL.fulldata = data;
				});
			},

			savetoTable() {
				const existingIds = this.listBudgetTaskGL.map((item) => item.budget_task_id);
				const duplicate = this.unsaveListBudgetTaskGL.some((item) => existingIds.includes(item.budget_task_id));

				if (duplicate) {
					this.$swal
						.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', this.$swal.stopTimer);
								toast.addEventListener('mouseleave', this.$swal.resumeTimer);
							},
						})
						.fire({
							icon: 'error',
							title: 'Duplicate budget task detected',
						});
					return;
				}
				// console.log(this.unsaveListBudgetTaskGL);

				this.listBudgetTaskGL.push(...this.unsaveListBudgetTaskGL);
				this.saveContract.budget_plan_id = '';
				this.saveContract.budget_gl_id = '';
				this.saveContract.budget_task_id = '';
				this.remainingBudgets = '';
			},
			filterInput() {
				// Remove non-digit characters
				this.oaNumber = this.oaNumber.replace(/[^0-9]/g, '');
				this.oaNumberedit.oa_number = this.oaNumberedit.oa_number.replace(/[^0-9]/g, '');
			},
			handleEnter(type) {
				if (type == 'add') {
					if (this.oaNumber) {
						const inputNumber = Number(this.oaNumber);

						// Check for duplicate
						const isDuplicate = this.saveContract.oa_number.some((item) => item.oa_number === inputNumber);

						if (isDuplicate) {
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'error',
									title: 'OA Number already exist',
								});
							return;
						}

						const nextNo = this.saveContract.oa_number.length + 1;

						this.saveContract.oa_number.push({
							no: nextNo,
							oa_number: inputNumber,
						});

						this.oaNumber = ''; // Clear the input
					}
				} else {
					if (this.oaNumber) {
						const inputNumber = Number(this.oaNumber);

						// Check for duplicate
						const isDuplicate = this.saveAmandement.oa_number.some((item) => item.oa_number === inputNumber);

						if (isDuplicate) {
							this.$swal
								.mixin({
									toast: true,
									position: 'top-end',
									showConfirmButton: false,
									timer: 3000,
									timerProgressBar: true,
									didOpen: (toast) => {
										toast.addEventListener('mouseenter', this.$swal.stopTimer);
										toast.addEventListener('mouseleave', this.$swal.resumeTimer);
									},
								})
								.fire({
									icon: 'error',
									title: 'OA Number already exist',
								});
							return;
						}

						const nextNo = this.saveAmandement.oa_number.length + 1;

						this.saveAmandement.oa_number.push({
							no: nextNo,
							oa_number: inputNumber,
						});

						this.oaNumber = ''; // Clear the input
					}
				}
			},
			updateOA() {
				this.$swal({
					title: 'Confirm Update?',
					text: 'Are you sure want to save this OA Number?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
				}).then((result) => {
					if (result.isConfirmed) {
						if (this.isAmandement == false) {
							this.$bvModal.hide('modal-edit-gl');
							this.$set(this.saveContract.oa_number, this.indexOA, this.oaNumberedit);
							this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
								this.oaNumberedit = {
									oa_number: '',
									no: '',
								};
							});
						} else {
							this.$bvModal.hide('modal-edit-gl');
							this.$set(this.saveAmandement.oa_number, this.indexOA, this.oaNumberedit);
							this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
								this.oaNumberedit = {
									oa_number: '',
									no: '',
								};
							});
						}
					}
				});
			},
			deleteItem(index, type) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
				}).then((result) => {
					if (result.isConfirmed) {
						if (type == 'add') {
							this.saveContract.oa_number.splice(index, 1);
							this.saveContract.oa_number.forEach((item, i) => {
								item.no = i + 1;
							});
						} else {
							this.saveAmandement.oa_number.splice(index, 1);
							this.saveAmandement.oa_number.forEach((item, i) => {
								item.no = i + 1;
							});
						}
					}
				});
			},

			// filter
			async filterPage() {
				this.load = true;
				this.body.page = 1;
				this.saveContract.department_id = this.body.department_id;
				await this.debouncedOnSearch();
			},

			// Pagination
			onPageChange(payload) {
				this.body.pageSize = payload.currentPerPage;
				this.body.page = payload.currentPage;
				this.getListContract();
			},

			onSortChange(event) {
				this.body.order = event[0].type == 'none' ? '' : event[0].type;
				this.body.field = event[0].field ? event[0].field : '';
				this.body.page = 1;
				this.getListContract();
			},

			setOwnerDepartment(val) {
				if (!val) return;
				const owner = this.listUser.find((item) => item.id == val);
				const departmentName =
					(owner?.department ||
						owner?.divisi ||
						owner?.departments?.find((item) => item.id == this.saveContract.department_id)?.name) ??
					'Department not set';
				this.saveContract.contract_owner_department = departmentName;
				this.saveContract.email_cc = [...new Set([...this.saveContract.email_cc, owner.email])];
			},
			setCoOwnerDepartment(val) {
				if (!val) return;
				const coOwner = this.listUser.find((item) => item.id == val);
				const departmentName =
					(coOwner?.department ||
						coOwner?.divisi ||
						coOwner?.departments?.find((item) => item.id == this.saveContract.department_id)?.name) ??
					'Department not set';
				this.saveContract.contract_co_owner_department = departmentName;
				this.saveContract.email_cc = [...new Set([...this.saveContract.email_cc, coOwner.email])];
			},

			addNotificationWhatsappNumber() {
				let inputValue = onlyNumber(this.$refs.modalNotification_whatsapp_number.search);
				inputValue = inputValue.slice(0, 13);
				if (inputValue && !this.modalNotification.whatsapp_number.includes(inputValue)) {
					this.modalNotification.whatsapp_number.push(inputValue);
				}
				this.$refs.modalNotification_whatsapp_number.search = '';
			},
			addNotificationEmailExternal() {
				let inputValue = this.$refs.modalNotification_email_external.search;
				if (inputValue && !this.modalNotification.email_external.includes(inputValue)) {
					this.modalNotification.email_external.push(inputValue);
				}
				this.$refs.modalNotification_email_external.search = '';
			},
			addContractWhatsappNumber() {
				let inputValue = onlyNumber(this.$refs.saveContract_whatsapp_number.search);
				inputValue = inputValue.slice(0, 13);
				if (inputValue && !this.saveContract.whatsapp_number.includes(inputValue)) {
					this.saveContract.whatsapp_number.push(inputValue);
				}
				this.$refs.saveContract_whatsapp_number.search = '';
			},
			addContractEmailExternal() {
				const inputValue = this.$refs.saveContract_email_external.search;
				if (inputValue && !this.saveContract.email_external.includes(inputValue)) {
					this.saveContract.email_external.push(inputValue);
				}
				this.$refs.saveContract_email_external.search = '';
			},
			validateWhatsappNumber: (map, vm) => ({
				...map,
				//enter key
				13: (e) => {
					let inputValue = vm.search;
					const numericValue = onlyNumber(inputValue);
					const truncatedValue = numericValue.slice(0, 13);
					vm.search = truncatedValue;
					if (truncatedValue.length > 0) {
						vm.select(truncatedValue);
					}
				},
				// tab key
				9: (e) => {
					const inputValue = vm.search;
					const numericValue = onlyNumber(inputValue);
					const truncatedValue = numericValue.slice(0, 13);
					vm.search = truncatedValue;
					if (truncatedValue.length > 0) {
						vm.select(truncatedValue);
					}
				},
				// comma key
				188: (e) => {
					const inputValue = vm.search;
					const numericValue = onlyNumber(inputValue);
					const truncatedValue = numericValue.slice(0, 13);
					vm.search = truncatedValue;
					if (truncatedValue.length > 0) {
						vm.select(truncatedValue);
					}
				},
			}),
			async getListDepartment() {
				await this.$store.dispatch('profile/getProfile');
			},
			downloadClosed(id, name) {
				let body = {
					id: id,
					filename: name,
				};
				this.$store.dispatch('listContract/downloadID', body);
			},
			async setSelectedDepartment() {
				//reset budget section and owner section
				if (this.isAdd) {
					this.resetAfterChangeDepartment();
				}
				this.selectedDepartment = this.listDepartments.find(
					(item) => item.id == (this.saveContract.department_id || this.body.department_id)
				);
				console.log('selectedDepartment', this.selectedDepartment);
				await this.getUser();
			},
			changeContractValue(e, action = null) {
				const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 15);
				const payload = (action = null == 'amandement' ? this.saveAmandement : this.saveContract);
				payload.contract_value = formatCurrency(value);
				this.debounceRecalculateTop(action);
			},
			isPercent(evt, action = null) {
				// Clean leading zeros & limit to 2 decimal places
				const key = evt.key;
				const value = evt.target.value;
				const newValue = value + key;

				console.log('newValue', newValue);

				if (newValue.includes('.')) {
					const parts = newValue.split('.');
					if (parts[1].length > 2) {
						evt.preventDefault();
						return;
					}
				}

				if (/^0+[^\.]/.test(newValue)) {
					evt.target.value = value.replace(/^0+/, '');
				}

				// this.debounceRecalculateTop(action);
			},
			recalculateTop(action = null) {
				const payload = action == 'amandement' ? this.saveAmandement : this.saveContract;
				if (payload.term_of_payments.fixed_assignment.percentage > 0) {
					this.calculateAmountFromPercent('fixed_assignment', action);
					if (payload.term_of_payments.fixed_assignment.contract_items.length > 0) {
						payload.term_of_payments.fixed_assignment.contract_items.forEach((item, index) => {
							this.calculateAmountFromPercentage(index, 'fixed_assignment', action);
						});
					}
				}
				if (payload.term_of_payments.provision.percentage > 0) {
					this.calculateAmountFromPercent('provision', action);
					if (payload.term_of_payments.provision.contract_items.length > 0) {
						payload.term_of_payments.provision.contract_items.forEach((item, index) => {
							this.calculateAmountFromPercentage(index, 'provision', action);
						});
					}
				}
			},
			handleChangeContractDepartment(value) {
				this.saveContract.department_id = value;
				this.setSelectedDepartment();
			},
			ValidateEmailCcContract() {
				if (this.saveContract.email_cc.length < 1) {
					const emails = [
						this.listUser.find((user) => user.id == this.saveContract.contract_owner)?.email,
						this.listUser.find((user) => user.id == this.saveContract.contract_co_owner)?.email,
					].filter((email) => email !== undefined && email !== null);

					this.saveContract.email_cc = [...new Set(emails)];
				}
			},
		},
		created() {
			this.debouncedOnSearch = debounce(this.getListContract, 500);
			this.debounceRecalculateTop = debounce(this.recalculateTop, 700);
		},
	};
</script>
<style>
	.input-with-prefix {
		width: 100%;
	}

	.prefix {
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
		color: #4a4a4a;
		font-size: 14px;
		pointer-events: none;
		z-index: 1;
	}

	.with-prefix {
		padding-left: 40px !important;
		/* box-sizing: border-box;
width: 100%; */
	}

	.form-control.with-prefix {
		/* position: relative; */
		z-index: 0;
	}

	.file-upload-wrapper {
		position: relative;
		width: 400px;
		max-width: 100%;
	}

	.file-upload-wrapper input[type='file'] {
		opacity: 0;
		width: 100%;
		height: 45px;
		position: absolute;
		left: 0;
		top: 0;
		cursor: pointer;
	}

	.file-upload-label {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 15px;
		border: 1px solid #ccc;
		border-radius: 6px;
		background-color: #fafafa;
		font-size: 14px;
		color: #999;
	}

	.file-upload-label span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
		margin-right: 15px;
	}

	.file-upload-label button {
		background-color: #eee;
		border: none;
		padding: 6px 12px;
		font-size: 14px;
		cursor: pointer;
		border-radius: 4px;
	}
</style>
